// SRC: https://github.com/OpenAPITools/openapi-generator/blob/master/modules/openapi-generator/src/main/resources/typescript-fetch/apis.mustache
// synched 02.02.2023
import * as yup from 'yup';
import typia from 'typia';
/* tslint:disable */
/* eslint-disable */
/**
 * Lightly API
 * Lightly.ai enables you to do self-supervised learning in an easy and intuitive way. The lightly.ai OpenAPI spec defines how one can interact with our REST API to unleash the full potential of lightly.ai
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@lightly.ai
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import * as runtime from '../runtime';
import type { ApiErrorResponse, DatasourceConfig, DatasourceConfigVerifyData, DatasourceProcessedUntilTimestampRequest, DatasourceProcessedUntilTimestampResponse, DatasourcePurpose, DatasourceRawSamplesData, DatasourceRawSamplesMetadataData, DatasourceRawSamplesPredictionsData, DivideAndConquerCursorData, } from '../models';
import { ApiErrorResponseFromJSON, ApiErrorResponseToJSON, ApiErrorResponseValidator, DatasourceConfigFromJSON, DatasourceConfigToJSON, DatasourceConfigValidator, DatasourceConfigVerifyDataFromJSON, DatasourceConfigVerifyDataToJSON, DatasourceConfigVerifyDataValidator, DatasourceProcessedUntilTimestampRequestFromJSON, DatasourceProcessedUntilTimestampRequestToJSON, DatasourceProcessedUntilTimestampRequestValidator, DatasourceProcessedUntilTimestampResponseFromJSON, DatasourceProcessedUntilTimestampResponseToJSON, DatasourceProcessedUntilTimestampResponseValidator, DatasourcePurposeFromJSON, DatasourcePurposeToJSON, DatasourcePurposeValidator, DatasourceRawSamplesDataFromJSON, DatasourceRawSamplesDataToJSON, DatasourceRawSamplesDataValidator, DatasourceRawSamplesMetadataDataFromJSON, DatasourceRawSamplesMetadataDataToJSON, DatasourceRawSamplesMetadataDataValidator, DatasourceRawSamplesPredictionsDataFromJSON, DatasourceRawSamplesPredictionsDataToJSON, DatasourceRawSamplesPredictionsDataValidator, DivideAndConquerCursorDataFromJSON, DivideAndConquerCursorDataToJSON, DivideAndConquerCursorDataValidator, } from '../models';
import * as models from '../models';
/* LIGHTLY CUSTOM START -> -> moved from bottom to top:  apiMustache */
/* LIGHTLY CUSTOM END -> moved from bottom to top: apiMustache */
export interface GetCustomEmbeddingFileReadUrlFromDatasourceByDatasetIdRequest {
    datasetId: string;
    fileName: string;
}
/* LIGHTLY CUSTOM START -> apis */
export const GetCustomEmbeddingFileReadUrlFromDatasourceByDatasetIdRequestValidatorShape = {
    'datasetId': yup.string().matches(/^[a-f0-9]{24}$/).defined(),
    'fileName': yup.string().matches(/[.]csv$/).min(4).defined(),
};
export const GetCustomEmbeddingFileReadUrlFromDatasourceByDatasetIdRequestValidator = yup.object().shape(GetCustomEmbeddingFileReadUrlFromDatasourceByDatasetIdRequestValidatorShape);
export interface GetDatasourceByDatasetIdRequest {
    datasetId: string;
    purpose?: models.DatasourcePurpose;
}
/* LIGHTLY CUSTOM START -> apis */
export const GetDatasourceByDatasetIdRequestValidatorShape = {
    'datasetId': yup.string().matches(/^[a-f0-9]{24}$/).defined(),
    'purpose': models.DatasourcePurposeValidator.optional().default(undefined),
};
export const GetDatasourceByDatasetIdRequestValidator = yup.object().shape(GetDatasourceByDatasetIdRequestValidatorShape);
export interface GetDatasourceProcessedUntilTimestampByDatasetIdRequest {
    datasetId: string;
}
/* LIGHTLY CUSTOM START -> apis */
export const GetDatasourceProcessedUntilTimestampByDatasetIdRequestValidatorShape = {
    'datasetId': yup.string().matches(/^[a-f0-9]{24}$/).defined(),
};
export const GetDatasourceProcessedUntilTimestampByDatasetIdRequestValidator = yup.object().shape(GetDatasourceProcessedUntilTimestampByDatasetIdRequestValidatorShape);
export interface GetDatasourcesByDatasetIdRequest {
    datasetId: string;
}
/* LIGHTLY CUSTOM START -> apis */
export const GetDatasourcesByDatasetIdRequestValidatorShape = {
    'datasetId': yup.string().matches(/^[a-f0-9]{24}$/).defined(),
};
export const GetDatasourcesByDatasetIdRequestValidator = yup.object().shape(GetDatasourcesByDatasetIdRequestValidatorShape);
export interface GetDivideAndConquerListOfRawSamplesFromDatasourceByDatasetIdRequest {
    datasetId: string;
    dncShards: number;
    from?: number;
    to?: number;
    relevantFilenamesFileName?: string;
}
/* LIGHTLY CUSTOM START -> apis */
export const GetDivideAndConquerListOfRawSamplesFromDatasourceByDatasetIdRequestValidatorShape = {
    'datasetId': yup.string().matches(/^[a-f0-9]{24}$/).defined(),
    'dncShards': yup.number().integer().min(1).defined(),
    'from': yup.number().min(0),
    'to': yup.number().min(0),
    'relevantFilenamesFileName': yup.string().min(4),
};
export const GetDivideAndConquerListOfRawSamplesFromDatasourceByDatasetIdRequestValidator = yup.object().shape(GetDivideAndConquerListOfRawSamplesFromDatasourceByDatasetIdRequestValidatorShape);
export interface GetDivideAndConquerListOfRawSamplesMetadataFromDatasourceByDatasetIdRequest {
    datasetId: string;
    dncShards: number;
    from?: number;
    to?: number;
    relevantFilenamesFileName?: string;
    relevantFilenamesRunId?: string;
    relevantFilenamesArtifactId?: string;
}
/* LIGHTLY CUSTOM START -> apis */
export const GetDivideAndConquerListOfRawSamplesMetadataFromDatasourceByDatasetIdRequestValidatorShape = {
    'datasetId': yup.string().matches(/^[a-f0-9]{24}$/).defined(),
    'dncShards': yup.number().integer().min(1).defined(),
    'from': yup.number().min(0),
    'to': yup.number().min(0),
    'relevantFilenamesFileName': yup.string().min(4),
    'relevantFilenamesRunId': yup.string().matches(/^[a-f0-9]{24}$/),
    'relevantFilenamesArtifactId': yup.string().matches(/^[a-f0-9]{24}$/),
};
export const GetDivideAndConquerListOfRawSamplesMetadataFromDatasourceByDatasetIdRequestValidator = yup.object().shape(GetDivideAndConquerListOfRawSamplesMetadataFromDatasourceByDatasetIdRequestValidatorShape);
export interface GetDivideAndConquerListOfRawSamplesPredictionsFromDatasourceByDatasetIdRequest {
    datasetId: string;
    taskName: string;
    dncShards: number;
    from?: number;
    to?: number;
    relevantFilenamesFileName?: string;
    relevantFilenamesRunId?: string;
    relevantFilenamesArtifactId?: string;
}
/* LIGHTLY CUSTOM START -> apis */
export const GetDivideAndConquerListOfRawSamplesPredictionsFromDatasourceByDatasetIdRequestValidatorShape = {
    'datasetId': yup.string().matches(/^[a-f0-9]{24}$/).defined(),
    'taskName': yup.string().matches(/^[a-zA-Z0-9_+=,.@:\/-]*$/).defined(),
    'dncShards': yup.number().integer().min(1).defined(),
    'from': yup.number().min(0),
    'to': yup.number().min(0),
    'relevantFilenamesFileName': yup.string().min(4),
    'relevantFilenamesRunId': yup.string().matches(/^[a-f0-9]{24}$/),
    'relevantFilenamesArtifactId': yup.string().matches(/^[a-f0-9]{24}$/),
};
export const GetDivideAndConquerListOfRawSamplesPredictionsFromDatasourceByDatasetIdRequestValidator = yup.object().shape(GetDivideAndConquerListOfRawSamplesPredictionsFromDatasourceByDatasetIdRequestValidatorShape);
export interface GetHEADFileReadUrlFromDatasourceByDatasetIdRequest {
    datasetId: string;
    fileName: string;
}
/* LIGHTLY CUSTOM START -> apis */
export const GetHEADFileReadUrlFromDatasourceByDatasetIdRequestValidatorShape = {
    'datasetId': yup.string().matches(/^[a-f0-9]{24}$/).defined(),
    'fileName': yup.string().min(1).defined(),
};
export const GetHEADFileReadUrlFromDatasourceByDatasetIdRequestValidator = yup.object().shape(GetHEADFileReadUrlFromDatasourceByDatasetIdRequestValidatorShape);
export interface GetListOfRawSamplesFromDatasourceByDatasetIdRequest {
    datasetId: string;
    from?: number;
    to?: number;
    cursor?: string;
    useRedirectedReadUrl?: boolean;
    relevantFilenamesFileName?: string;
}
/* LIGHTLY CUSTOM START -> apis */
export const GetListOfRawSamplesFromDatasourceByDatasetIdRequestValidatorShape = {
    'datasetId': yup.string().matches(/^[a-f0-9]{24}$/).defined(),
    'from': yup.number().min(0),
    'to': yup.number().min(0),
    'cursor': yup.string(),
    'useRedirectedReadUrl': yup.boolean(),
    'relevantFilenamesFileName': yup.string().min(4),
};
export const GetListOfRawSamplesFromDatasourceByDatasetIdRequestValidator = yup.object().shape(GetListOfRawSamplesFromDatasourceByDatasetIdRequestValidatorShape);
export interface GetListOfRawSamplesMetadataFromDatasourceByDatasetIdRequest {
    datasetId: string;
    from?: number;
    to?: number;
    cursor?: string;
    useRedirectedReadUrl?: boolean;
    relevantFilenamesFileName?: string;
    relevantFilenamesRunId?: string;
    relevantFilenamesArtifactId?: string;
}
/* LIGHTLY CUSTOM START -> apis */
export const GetListOfRawSamplesMetadataFromDatasourceByDatasetIdRequestValidatorShape = {
    'datasetId': yup.string().matches(/^[a-f0-9]{24}$/).defined(),
    'from': yup.number().min(0),
    'to': yup.number().min(0),
    'cursor': yup.string(),
    'useRedirectedReadUrl': yup.boolean(),
    'relevantFilenamesFileName': yup.string().min(4),
    'relevantFilenamesRunId': yup.string().matches(/^[a-f0-9]{24}$/),
    'relevantFilenamesArtifactId': yup.string().matches(/^[a-f0-9]{24}$/),
};
export const GetListOfRawSamplesMetadataFromDatasourceByDatasetIdRequestValidator = yup.object().shape(GetListOfRawSamplesMetadataFromDatasourceByDatasetIdRequestValidatorShape);
export interface GetListOfRawSamplesPredictionsFromDatasourceByDatasetIdRequest {
    datasetId: string;
    taskName: string;
    from?: number;
    to?: number;
    cursor?: string;
    useRedirectedReadUrl?: boolean;
    relevantFilenamesFileName?: string;
    relevantFilenamesRunId?: string;
    relevantFilenamesArtifactId?: string;
}
/* LIGHTLY CUSTOM START -> apis */
export const GetListOfRawSamplesPredictionsFromDatasourceByDatasetIdRequestValidatorShape = {
    'datasetId': yup.string().matches(/^[a-f0-9]{24}$/).defined(),
    'taskName': yup.string().matches(/^[a-zA-Z0-9_+=,.@:\/-]*$/).defined(),
    'from': yup.number().min(0),
    'to': yup.number().min(0),
    'cursor': yup.string(),
    'useRedirectedReadUrl': yup.boolean(),
    'relevantFilenamesFileName': yup.string().min(4),
    'relevantFilenamesRunId': yup.string().matches(/^[a-f0-9]{24}$/),
    'relevantFilenamesArtifactId': yup.string().matches(/^[a-f0-9]{24}$/),
};
export const GetListOfRawSamplesPredictionsFromDatasourceByDatasetIdRequestValidator = yup.object().shape(GetListOfRawSamplesPredictionsFromDatasourceByDatasetIdRequestValidatorShape);
export interface GetMetadataFileReadUrlFromDatasourceByDatasetIdRequest {
    datasetId: string;
    fileName: string;
}
/* LIGHTLY CUSTOM START -> apis */
export const GetMetadataFileReadUrlFromDatasourceByDatasetIdRequestValidatorShape = {
    'datasetId': yup.string().matches(/^[a-f0-9]{24}$/).defined(),
    'fileName': yup.string().min(5).defined(),
};
export const GetMetadataFileReadUrlFromDatasourceByDatasetIdRequestValidator = yup.object().shape(GetMetadataFileReadUrlFromDatasourceByDatasetIdRequestValidatorShape);
export interface GetPredictionFileReadUrlFromDatasourceByDatasetIdRequest {
    datasetId: string;
    fileName: string;
}
/* LIGHTLY CUSTOM START -> apis */
export const GetPredictionFileReadUrlFromDatasourceByDatasetIdRequestValidatorShape = {
    'datasetId': yup.string().matches(/^[a-f0-9]{24}$/).defined(),
    'fileName': yup.string().min(4).defined(),
};
export const GetPredictionFileReadUrlFromDatasourceByDatasetIdRequestValidator = yup.object().shape(GetPredictionFileReadUrlFromDatasourceByDatasetIdRequestValidatorShape);
export interface GetPredictionFileWriteUrlFromDatasourceByDatasetIdRequest {
    datasetId: string;
    fileName: string;
}
/* LIGHTLY CUSTOM START -> apis */
export const GetPredictionFileWriteUrlFromDatasourceByDatasetIdRequestValidatorShape = {
    'datasetId': yup.string().matches(/^[a-f0-9]{24}$/).defined(),
    'fileName': yup.string().min(4).defined(),
};
export const GetPredictionFileWriteUrlFromDatasourceByDatasetIdRequestValidator = yup.object().shape(GetPredictionFileWriteUrlFromDatasourceByDatasetIdRequestValidatorShape);
export interface GetResourceReadURLRedirectRequest {
    datasetId: string;
    path: string;
}
/* LIGHTLY CUSTOM START -> apis */
export const GetResourceReadURLRedirectRequestValidatorShape = {
    'datasetId': yup.string().matches(/^[a-f0-9]{24}$/).defined(),
    'path': yup.string().defined(),
};
export const GetResourceReadURLRedirectRequestValidator = yup.object().shape(GetResourceReadURLRedirectRequestValidatorShape);
export interface UpdateDatasourceByDatasetIdRequest {
    datasourceConfig: models.DatasourceConfig;
    datasetId: string;
}
/* LIGHTLY CUSTOM START -> apis */
export const UpdateDatasourceByDatasetIdRequestValidatorShape = {
    'datasourceConfig': models.DatasourceConfigValidator,
    'datasetId': yup.string().matches(/^[a-f0-9]{24}$/).defined(),
};
export const UpdateDatasourceByDatasetIdRequestValidator = yup.object().shape(UpdateDatasourceByDatasetIdRequestValidatorShape);
export interface UpdateDatasourceProcessedUntilTimestampByDatasetIdRequest {
    datasourceProcessedUntilTimestampRequest: models.DatasourceProcessedUntilTimestampRequest;
    datasetId: string;
}
/* LIGHTLY CUSTOM START -> apis */
export const UpdateDatasourceProcessedUntilTimestampByDatasetIdRequestValidatorShape = {
    'datasourceProcessedUntilTimestampRequest': models.DatasourceProcessedUntilTimestampRequestValidator.defined(),
    'datasetId': yup.string().matches(/^[a-f0-9]{24}$/).defined(),
};
export const UpdateDatasourceProcessedUntilTimestampByDatasetIdRequestValidator = yup.object().shape(UpdateDatasourceProcessedUntilTimestampByDatasetIdRequestValidatorShape);
export interface VerifyDatasourceByDatasetIdRequest {
    datasetId: string;
}
/* LIGHTLY CUSTOM START -> apis */
export const VerifyDatasourceByDatasetIdRequestValidatorShape = {
    'datasetId': yup.string().matches(/^[a-f0-9]{24}$/).defined(),
};
export const VerifyDatasourceByDatasetIdRequestValidator = yup.object().shape(VerifyDatasourceByDatasetIdRequestValidatorShape);
export interface GetCustomEmbeddingFileReadUrlFromDatasourceByDatasetIdRequestParams {
    datasetId: string;
}
export function GetCustomEmbeddingFileReadUrlFromDatasourceByDatasetIdRequestParamsSanitizer(json: any): GetCustomEmbeddingFileReadUrlFromDatasourceByDatasetIdRequestParams {
    return {
        'datasetId': json['datasetId'],
    };
}
export const GetCustomEmbeddingFileReadUrlFromDatasourceByDatasetIdRequestParamsValidatorShape = {
    'datasetId': yup.string().matches(/^[a-f0-9]{24}$/).defined(),
};
export const GetCustomEmbeddingFileReadUrlFromDatasourceByDatasetIdRequestParamsValidator = yup.object().shape(GetCustomEmbeddingFileReadUrlFromDatasourceByDatasetIdRequestParamsValidatorShape);
export interface GetDatasourceByDatasetIdRequestParams {
    datasetId: string;
}
export function GetDatasourceByDatasetIdRequestParamsSanitizer(json: any): GetDatasourceByDatasetIdRequestParams {
    return {
        'datasetId': json['datasetId'],
    };
}
export const GetDatasourceByDatasetIdRequestParamsValidatorShape = {
    'datasetId': yup.string().matches(/^[a-f0-9]{24}$/).defined(),
};
export const GetDatasourceByDatasetIdRequestParamsValidator = yup.object().shape(GetDatasourceByDatasetIdRequestParamsValidatorShape);
export interface GetDatasourceProcessedUntilTimestampByDatasetIdRequestParams {
    datasetId: string;
}
export function GetDatasourceProcessedUntilTimestampByDatasetIdRequestParamsSanitizer(json: any): GetDatasourceProcessedUntilTimestampByDatasetIdRequestParams {
    return {
        'datasetId': json['datasetId'],
    };
}
export const GetDatasourceProcessedUntilTimestampByDatasetIdRequestParamsValidatorShape = {
    'datasetId': yup.string().matches(/^[a-f0-9]{24}$/).defined(),
};
export const GetDatasourceProcessedUntilTimestampByDatasetIdRequestParamsValidator = yup.object().shape(GetDatasourceProcessedUntilTimestampByDatasetIdRequestParamsValidatorShape);
export interface GetDatasourcesByDatasetIdRequestParams {
    datasetId: string;
}
export function GetDatasourcesByDatasetIdRequestParamsSanitizer(json: any): GetDatasourcesByDatasetIdRequestParams {
    return {
        'datasetId': json['datasetId'],
    };
}
export const GetDatasourcesByDatasetIdRequestParamsValidatorShape = {
    'datasetId': yup.string().matches(/^[a-f0-9]{24}$/).defined(),
};
export const GetDatasourcesByDatasetIdRequestParamsValidator = yup.object().shape(GetDatasourcesByDatasetIdRequestParamsValidatorShape);
export interface GetDivideAndConquerListOfRawSamplesFromDatasourceByDatasetIdRequestParams {
    datasetId: string;
}
export function GetDivideAndConquerListOfRawSamplesFromDatasourceByDatasetIdRequestParamsSanitizer(json: any): GetDivideAndConquerListOfRawSamplesFromDatasourceByDatasetIdRequestParams {
    return {
        'datasetId': json['datasetId'],
    };
}
export const GetDivideAndConquerListOfRawSamplesFromDatasourceByDatasetIdRequestParamsValidatorShape = {
    'datasetId': yup.string().matches(/^[a-f0-9]{24}$/).defined(),
};
export const GetDivideAndConquerListOfRawSamplesFromDatasourceByDatasetIdRequestParamsValidator = yup.object().shape(GetDivideAndConquerListOfRawSamplesFromDatasourceByDatasetIdRequestParamsValidatorShape);
export interface GetDivideAndConquerListOfRawSamplesMetadataFromDatasourceByDatasetIdRequestParams {
    datasetId: string;
}
export function GetDivideAndConquerListOfRawSamplesMetadataFromDatasourceByDatasetIdRequestParamsSanitizer(json: any): GetDivideAndConquerListOfRawSamplesMetadataFromDatasourceByDatasetIdRequestParams {
    return {
        'datasetId': json['datasetId'],
    };
}
export const GetDivideAndConquerListOfRawSamplesMetadataFromDatasourceByDatasetIdRequestParamsValidatorShape = {
    'datasetId': yup.string().matches(/^[a-f0-9]{24}$/).defined(),
};
export const GetDivideAndConquerListOfRawSamplesMetadataFromDatasourceByDatasetIdRequestParamsValidator = yup.object().shape(GetDivideAndConquerListOfRawSamplesMetadataFromDatasourceByDatasetIdRequestParamsValidatorShape);
export interface GetDivideAndConquerListOfRawSamplesPredictionsFromDatasourceByDatasetIdRequestParams {
    datasetId: string;
}
export function GetDivideAndConquerListOfRawSamplesPredictionsFromDatasourceByDatasetIdRequestParamsSanitizer(json: any): GetDivideAndConquerListOfRawSamplesPredictionsFromDatasourceByDatasetIdRequestParams {
    return {
        'datasetId': json['datasetId'],
    };
}
export const GetDivideAndConquerListOfRawSamplesPredictionsFromDatasourceByDatasetIdRequestParamsValidatorShape = {
    'datasetId': yup.string().matches(/^[a-f0-9]{24}$/).defined(),
};
export const GetDivideAndConquerListOfRawSamplesPredictionsFromDatasourceByDatasetIdRequestParamsValidator = yup.object().shape(GetDivideAndConquerListOfRawSamplesPredictionsFromDatasourceByDatasetIdRequestParamsValidatorShape);
export interface GetHEADFileReadUrlFromDatasourceByDatasetIdRequestParams {
    datasetId: string;
}
export function GetHEADFileReadUrlFromDatasourceByDatasetIdRequestParamsSanitizer(json: any): GetHEADFileReadUrlFromDatasourceByDatasetIdRequestParams {
    return {
        'datasetId': json['datasetId'],
    };
}
export const GetHEADFileReadUrlFromDatasourceByDatasetIdRequestParamsValidatorShape = {
    'datasetId': yup.string().matches(/^[a-f0-9]{24}$/).defined(),
};
export const GetHEADFileReadUrlFromDatasourceByDatasetIdRequestParamsValidator = yup.object().shape(GetHEADFileReadUrlFromDatasourceByDatasetIdRequestParamsValidatorShape);
export interface GetListOfRawSamplesFromDatasourceByDatasetIdRequestParams {
    datasetId: string;
}
export function GetListOfRawSamplesFromDatasourceByDatasetIdRequestParamsSanitizer(json: any): GetListOfRawSamplesFromDatasourceByDatasetIdRequestParams {
    return {
        'datasetId': json['datasetId'],
    };
}
export const GetListOfRawSamplesFromDatasourceByDatasetIdRequestParamsValidatorShape = {
    'datasetId': yup.string().matches(/^[a-f0-9]{24}$/).defined(),
};
export const GetListOfRawSamplesFromDatasourceByDatasetIdRequestParamsValidator = yup.object().shape(GetListOfRawSamplesFromDatasourceByDatasetIdRequestParamsValidatorShape);
export interface GetListOfRawSamplesMetadataFromDatasourceByDatasetIdRequestParams {
    datasetId: string;
}
export function GetListOfRawSamplesMetadataFromDatasourceByDatasetIdRequestParamsSanitizer(json: any): GetListOfRawSamplesMetadataFromDatasourceByDatasetIdRequestParams {
    return {
        'datasetId': json['datasetId'],
    };
}
export const GetListOfRawSamplesMetadataFromDatasourceByDatasetIdRequestParamsValidatorShape = {
    'datasetId': yup.string().matches(/^[a-f0-9]{24}$/).defined(),
};
export const GetListOfRawSamplesMetadataFromDatasourceByDatasetIdRequestParamsValidator = yup.object().shape(GetListOfRawSamplesMetadataFromDatasourceByDatasetIdRequestParamsValidatorShape);
export interface GetListOfRawSamplesPredictionsFromDatasourceByDatasetIdRequestParams {
    datasetId: string;
}
export function GetListOfRawSamplesPredictionsFromDatasourceByDatasetIdRequestParamsSanitizer(json: any): GetListOfRawSamplesPredictionsFromDatasourceByDatasetIdRequestParams {
    return {
        'datasetId': json['datasetId'],
    };
}
export const GetListOfRawSamplesPredictionsFromDatasourceByDatasetIdRequestParamsValidatorShape = {
    'datasetId': yup.string().matches(/^[a-f0-9]{24}$/).defined(),
};
export const GetListOfRawSamplesPredictionsFromDatasourceByDatasetIdRequestParamsValidator = yup.object().shape(GetListOfRawSamplesPredictionsFromDatasourceByDatasetIdRequestParamsValidatorShape);
export interface GetMetadataFileReadUrlFromDatasourceByDatasetIdRequestParams {
    datasetId: string;
}
export function GetMetadataFileReadUrlFromDatasourceByDatasetIdRequestParamsSanitizer(json: any): GetMetadataFileReadUrlFromDatasourceByDatasetIdRequestParams {
    return {
        'datasetId': json['datasetId'],
    };
}
export const GetMetadataFileReadUrlFromDatasourceByDatasetIdRequestParamsValidatorShape = {
    'datasetId': yup.string().matches(/^[a-f0-9]{24}$/).defined(),
};
export const GetMetadataFileReadUrlFromDatasourceByDatasetIdRequestParamsValidator = yup.object().shape(GetMetadataFileReadUrlFromDatasourceByDatasetIdRequestParamsValidatorShape);
export interface GetPredictionFileReadUrlFromDatasourceByDatasetIdRequestParams {
    datasetId: string;
}
export function GetPredictionFileReadUrlFromDatasourceByDatasetIdRequestParamsSanitizer(json: any): GetPredictionFileReadUrlFromDatasourceByDatasetIdRequestParams {
    return {
        'datasetId': json['datasetId'],
    };
}
export const GetPredictionFileReadUrlFromDatasourceByDatasetIdRequestParamsValidatorShape = {
    'datasetId': yup.string().matches(/^[a-f0-9]{24}$/).defined(),
};
export const GetPredictionFileReadUrlFromDatasourceByDatasetIdRequestParamsValidator = yup.object().shape(GetPredictionFileReadUrlFromDatasourceByDatasetIdRequestParamsValidatorShape);
export interface GetPredictionFileWriteUrlFromDatasourceByDatasetIdRequestParams {
    datasetId: string;
}
export function GetPredictionFileWriteUrlFromDatasourceByDatasetIdRequestParamsSanitizer(json: any): GetPredictionFileWriteUrlFromDatasourceByDatasetIdRequestParams {
    return {
        'datasetId': json['datasetId'],
    };
}
export const GetPredictionFileWriteUrlFromDatasourceByDatasetIdRequestParamsValidatorShape = {
    'datasetId': yup.string().matches(/^[a-f0-9]{24}$/).defined(),
};
export const GetPredictionFileWriteUrlFromDatasourceByDatasetIdRequestParamsValidator = yup.object().shape(GetPredictionFileWriteUrlFromDatasourceByDatasetIdRequestParamsValidatorShape);
export interface GetResourceReadURLRedirectRequestParams {
    datasetId: string;
}
export function GetResourceReadURLRedirectRequestParamsSanitizer(json: any): GetResourceReadURLRedirectRequestParams {
    return {
        'datasetId': json['datasetId'],
    };
}
export const GetResourceReadURLRedirectRequestParamsValidatorShape = {
    'datasetId': yup.string().matches(/^[a-f0-9]{24}$/).defined(),
};
export const GetResourceReadURLRedirectRequestParamsValidator = yup.object().shape(GetResourceReadURLRedirectRequestParamsValidatorShape);
export interface UpdateDatasourceByDatasetIdRequestParams {
    datasetId: string;
}
export function UpdateDatasourceByDatasetIdRequestParamsSanitizer(json: any): UpdateDatasourceByDatasetIdRequestParams {
    return {
        'datasetId': json['datasetId'],
    };
}
export const UpdateDatasourceByDatasetIdRequestParamsValidatorShape = {
    'datasetId': yup.string().matches(/^[a-f0-9]{24}$/).defined(),
};
export const UpdateDatasourceByDatasetIdRequestParamsValidator = yup.object().shape(UpdateDatasourceByDatasetIdRequestParamsValidatorShape);
export interface UpdateDatasourceProcessedUntilTimestampByDatasetIdRequestParams {
    datasetId: string;
}
export function UpdateDatasourceProcessedUntilTimestampByDatasetIdRequestParamsSanitizer(json: any): UpdateDatasourceProcessedUntilTimestampByDatasetIdRequestParams {
    return {
        'datasetId': json['datasetId'],
    };
}
export const UpdateDatasourceProcessedUntilTimestampByDatasetIdRequestParamsValidatorShape = {
    'datasetId': yup.string().matches(/^[a-f0-9]{24}$/).defined(),
};
export const UpdateDatasourceProcessedUntilTimestampByDatasetIdRequestParamsValidator = yup.object().shape(UpdateDatasourceProcessedUntilTimestampByDatasetIdRequestParamsValidatorShape);
export interface VerifyDatasourceByDatasetIdRequestParams {
    datasetId: string;
}
export function VerifyDatasourceByDatasetIdRequestParamsSanitizer(json: any): VerifyDatasourceByDatasetIdRequestParams {
    return {
        'datasetId': json['datasetId'],
    };
}
export const VerifyDatasourceByDatasetIdRequestParamsValidatorShape = {
    'datasetId': yup.string().matches(/^[a-f0-9]{24}$/).defined(),
};
export const VerifyDatasourceByDatasetIdRequestParamsValidator = yup.object().shape(VerifyDatasourceByDatasetIdRequestParamsValidatorShape);
export interface GetCustomEmbeddingFileReadUrlFromDatasourceByDatasetIdRequestQuery {
    fileName: string;
}
export function GetCustomEmbeddingFileReadUrlFromDatasourceByDatasetIdRequestQuerySanitizer(json: any): GetCustomEmbeddingFileReadUrlFromDatasourceByDatasetIdRequestQuery {
    return {
        'fileName': json['fileName'],
    };
}
export const GetCustomEmbeddingFileReadUrlFromDatasourceByDatasetIdRequestQueryValidatorShape = {
    'fileName': yup.string().matches(/[.]csv$/).min(4).defined(),
};
export const GetCustomEmbeddingFileReadUrlFromDatasourceByDatasetIdRequestQueryValidator = yup.object().shape(GetCustomEmbeddingFileReadUrlFromDatasourceByDatasetIdRequestQueryValidatorShape);
export interface GetDatasourceByDatasetIdRequestQuery {
    purpose?: models.DatasourcePurpose;
}
export function GetDatasourceByDatasetIdRequestQuerySanitizer(json: any): GetDatasourceByDatasetIdRequestQuery {
    return {
        'purpose': json['purpose'],
    };
}
export const GetDatasourceByDatasetIdRequestQueryValidatorShape = {
    'purpose': models.DatasourcePurposeValidator.optional().default(undefined),
};
export const GetDatasourceByDatasetIdRequestQueryValidator = yup.object().shape(GetDatasourceByDatasetIdRequestQueryValidatorShape);
export interface GetDatasourceProcessedUntilTimestampByDatasetIdRequestQuery {
}
export function GetDatasourceProcessedUntilTimestampByDatasetIdRequestQuerySanitizer(json: any): GetDatasourceProcessedUntilTimestampByDatasetIdRequestQuery {
    return {};
}
export const GetDatasourceProcessedUntilTimestampByDatasetIdRequestQueryValidatorShape = {};
export const GetDatasourceProcessedUntilTimestampByDatasetIdRequestQueryValidator = yup.object().shape(GetDatasourceProcessedUntilTimestampByDatasetIdRequestQueryValidatorShape);
export interface GetDatasourcesByDatasetIdRequestQuery {
}
export function GetDatasourcesByDatasetIdRequestQuerySanitizer(json: any): GetDatasourcesByDatasetIdRequestQuery {
    return {};
}
export const GetDatasourcesByDatasetIdRequestQueryValidatorShape = {};
export const GetDatasourcesByDatasetIdRequestQueryValidator = yup.object().shape(GetDatasourcesByDatasetIdRequestQueryValidatorShape);
export interface GetDivideAndConquerListOfRawSamplesFromDatasourceByDatasetIdRequestQuery {
    dncShards: number;
    from?: number;
    to?: number;
    relevantFilenamesFileName?: string;
}
export function GetDivideAndConquerListOfRawSamplesFromDatasourceByDatasetIdRequestQuerySanitizer(json: any): GetDivideAndConquerListOfRawSamplesFromDatasourceByDatasetIdRequestQuery {
    return {
        'dncShards': json['dncShards'],
        'from': json['from'],
        'to': json['to'],
        'relevantFilenamesFileName': json['relevantFilenamesFileName'],
    };
}
export const GetDivideAndConquerListOfRawSamplesFromDatasourceByDatasetIdRequestQueryValidatorShape = {
    'dncShards': yup.number().integer().min(1).defined(),
    'from': yup.number().min(0),
    'to': yup.number().min(0),
    'relevantFilenamesFileName': yup.string().min(4),
};
export const GetDivideAndConquerListOfRawSamplesFromDatasourceByDatasetIdRequestQueryValidator = yup.object().shape(GetDivideAndConquerListOfRawSamplesFromDatasourceByDatasetIdRequestQueryValidatorShape);
export interface GetDivideAndConquerListOfRawSamplesMetadataFromDatasourceByDatasetIdRequestQuery {
    dncShards: number;
    from?: number;
    to?: number;
    relevantFilenamesFileName?: string;
    relevantFilenamesRunId?: string;
    relevantFilenamesArtifactId?: string;
}
export function GetDivideAndConquerListOfRawSamplesMetadataFromDatasourceByDatasetIdRequestQuerySanitizer(json: any): GetDivideAndConquerListOfRawSamplesMetadataFromDatasourceByDatasetIdRequestQuery {
    return {
        'dncShards': json['dncShards'],
        'from': json['from'],
        'to': json['to'],
        'relevantFilenamesFileName': json['relevantFilenamesFileName'],
        'relevantFilenamesRunId': json['relevantFilenamesRunId'],
        'relevantFilenamesArtifactId': json['relevantFilenamesArtifactId'],
    };
}
export const GetDivideAndConquerListOfRawSamplesMetadataFromDatasourceByDatasetIdRequestQueryValidatorShape = {
    'dncShards': yup.number().integer().min(1).defined(),
    'from': yup.number().min(0),
    'to': yup.number().min(0),
    'relevantFilenamesFileName': yup.string().min(4),
    'relevantFilenamesRunId': yup.string().matches(/^[a-f0-9]{24}$/),
    'relevantFilenamesArtifactId': yup.string().matches(/^[a-f0-9]{24}$/),
};
export const GetDivideAndConquerListOfRawSamplesMetadataFromDatasourceByDatasetIdRequestQueryValidator = yup.object().shape(GetDivideAndConquerListOfRawSamplesMetadataFromDatasourceByDatasetIdRequestQueryValidatorShape);
export interface GetDivideAndConquerListOfRawSamplesPredictionsFromDatasourceByDatasetIdRequestQuery {
    taskName: string;
    dncShards: number;
    from?: number;
    to?: number;
    relevantFilenamesFileName?: string;
    relevantFilenamesRunId?: string;
    relevantFilenamesArtifactId?: string;
}
export function GetDivideAndConquerListOfRawSamplesPredictionsFromDatasourceByDatasetIdRequestQuerySanitizer(json: any): GetDivideAndConquerListOfRawSamplesPredictionsFromDatasourceByDatasetIdRequestQuery {
    return {
        'taskName': json['taskName'],
        'dncShards': json['dncShards'],
        'from': json['from'],
        'to': json['to'],
        'relevantFilenamesFileName': json['relevantFilenamesFileName'],
        'relevantFilenamesRunId': json['relevantFilenamesRunId'],
        'relevantFilenamesArtifactId': json['relevantFilenamesArtifactId'],
    };
}
export const GetDivideAndConquerListOfRawSamplesPredictionsFromDatasourceByDatasetIdRequestQueryValidatorShape = {
    'taskName': yup.string().matches(/^[a-zA-Z0-9_+=,.@:\/-]*$/).defined(),
    'dncShards': yup.number().integer().min(1).defined(),
    'from': yup.number().min(0),
    'to': yup.number().min(0),
    'relevantFilenamesFileName': yup.string().min(4),
    'relevantFilenamesRunId': yup.string().matches(/^[a-f0-9]{24}$/),
    'relevantFilenamesArtifactId': yup.string().matches(/^[a-f0-9]{24}$/),
};
export const GetDivideAndConquerListOfRawSamplesPredictionsFromDatasourceByDatasetIdRequestQueryValidator = yup.object().shape(GetDivideAndConquerListOfRawSamplesPredictionsFromDatasourceByDatasetIdRequestQueryValidatorShape);
export interface GetHEADFileReadUrlFromDatasourceByDatasetIdRequestQuery {
    fileName: string;
}
export function GetHEADFileReadUrlFromDatasourceByDatasetIdRequestQuerySanitizer(json: any): GetHEADFileReadUrlFromDatasourceByDatasetIdRequestQuery {
    return {
        'fileName': json['fileName'],
    };
}
export const GetHEADFileReadUrlFromDatasourceByDatasetIdRequestQueryValidatorShape = {
    'fileName': yup.string().min(1).defined(),
};
export const GetHEADFileReadUrlFromDatasourceByDatasetIdRequestQueryValidator = yup.object().shape(GetHEADFileReadUrlFromDatasourceByDatasetIdRequestQueryValidatorShape);
export interface GetListOfRawSamplesFromDatasourceByDatasetIdRequestQuery {
    from?: number;
    to?: number;
    cursor?: string;
    useRedirectedReadUrl?: boolean;
    relevantFilenamesFileName?: string;
}
export function GetListOfRawSamplesFromDatasourceByDatasetIdRequestQuerySanitizer(json: any): GetListOfRawSamplesFromDatasourceByDatasetIdRequestQuery {
    return {
        'from': json['from'],
        'to': json['to'],
        'cursor': json['cursor'],
        'useRedirectedReadUrl': json['useRedirectedReadUrl'],
        'relevantFilenamesFileName': json['relevantFilenamesFileName'],
    };
}
export const GetListOfRawSamplesFromDatasourceByDatasetIdRequestQueryValidatorShape = {
    'from': yup.number().min(0),
    'to': yup.number().min(0),
    'cursor': yup.string(),
    'useRedirectedReadUrl': yup.boolean(),
    'relevantFilenamesFileName': yup.string().min(4),
};
export const GetListOfRawSamplesFromDatasourceByDatasetIdRequestQueryValidator = yup.object().shape(GetListOfRawSamplesFromDatasourceByDatasetIdRequestQueryValidatorShape);
export interface GetListOfRawSamplesMetadataFromDatasourceByDatasetIdRequestQuery {
    from?: number;
    to?: number;
    cursor?: string;
    useRedirectedReadUrl?: boolean;
    relevantFilenamesFileName?: string;
    relevantFilenamesRunId?: string;
    relevantFilenamesArtifactId?: string;
}
export function GetListOfRawSamplesMetadataFromDatasourceByDatasetIdRequestQuerySanitizer(json: any): GetListOfRawSamplesMetadataFromDatasourceByDatasetIdRequestQuery {
    return {
        'from': json['from'],
        'to': json['to'],
        'cursor': json['cursor'],
        'useRedirectedReadUrl': json['useRedirectedReadUrl'],
        'relevantFilenamesFileName': json['relevantFilenamesFileName'],
        'relevantFilenamesRunId': json['relevantFilenamesRunId'],
        'relevantFilenamesArtifactId': json['relevantFilenamesArtifactId'],
    };
}
export const GetListOfRawSamplesMetadataFromDatasourceByDatasetIdRequestQueryValidatorShape = {
    'from': yup.number().min(0),
    'to': yup.number().min(0),
    'cursor': yup.string(),
    'useRedirectedReadUrl': yup.boolean(),
    'relevantFilenamesFileName': yup.string().min(4),
    'relevantFilenamesRunId': yup.string().matches(/^[a-f0-9]{24}$/),
    'relevantFilenamesArtifactId': yup.string().matches(/^[a-f0-9]{24}$/),
};
export const GetListOfRawSamplesMetadataFromDatasourceByDatasetIdRequestQueryValidator = yup.object().shape(GetListOfRawSamplesMetadataFromDatasourceByDatasetIdRequestQueryValidatorShape);
export interface GetListOfRawSamplesPredictionsFromDatasourceByDatasetIdRequestQuery {
    taskName: string;
    from?: number;
    to?: number;
    cursor?: string;
    useRedirectedReadUrl?: boolean;
    relevantFilenamesFileName?: string;
    relevantFilenamesRunId?: string;
    relevantFilenamesArtifactId?: string;
}
export function GetListOfRawSamplesPredictionsFromDatasourceByDatasetIdRequestQuerySanitizer(json: any): GetListOfRawSamplesPredictionsFromDatasourceByDatasetIdRequestQuery {
    return {
        'taskName': json['taskName'],
        'from': json['from'],
        'to': json['to'],
        'cursor': json['cursor'],
        'useRedirectedReadUrl': json['useRedirectedReadUrl'],
        'relevantFilenamesFileName': json['relevantFilenamesFileName'],
        'relevantFilenamesRunId': json['relevantFilenamesRunId'],
        'relevantFilenamesArtifactId': json['relevantFilenamesArtifactId'],
    };
}
export const GetListOfRawSamplesPredictionsFromDatasourceByDatasetIdRequestQueryValidatorShape = {
    'taskName': yup.string().matches(/^[a-zA-Z0-9_+=,.@:\/-]*$/).defined(),
    'from': yup.number().min(0),
    'to': yup.number().min(0),
    'cursor': yup.string(),
    'useRedirectedReadUrl': yup.boolean(),
    'relevantFilenamesFileName': yup.string().min(4),
    'relevantFilenamesRunId': yup.string().matches(/^[a-f0-9]{24}$/),
    'relevantFilenamesArtifactId': yup.string().matches(/^[a-f0-9]{24}$/),
};
export const GetListOfRawSamplesPredictionsFromDatasourceByDatasetIdRequestQueryValidator = yup.object().shape(GetListOfRawSamplesPredictionsFromDatasourceByDatasetIdRequestQueryValidatorShape);
export interface GetMetadataFileReadUrlFromDatasourceByDatasetIdRequestQuery {
    fileName: string;
}
export function GetMetadataFileReadUrlFromDatasourceByDatasetIdRequestQuerySanitizer(json: any): GetMetadataFileReadUrlFromDatasourceByDatasetIdRequestQuery {
    return {
        'fileName': json['fileName'],
    };
}
export const GetMetadataFileReadUrlFromDatasourceByDatasetIdRequestQueryValidatorShape = {
    'fileName': yup.string().min(5).defined(),
};
export const GetMetadataFileReadUrlFromDatasourceByDatasetIdRequestQueryValidator = yup.object().shape(GetMetadataFileReadUrlFromDatasourceByDatasetIdRequestQueryValidatorShape);
export interface GetPredictionFileReadUrlFromDatasourceByDatasetIdRequestQuery {
    fileName: string;
}
export function GetPredictionFileReadUrlFromDatasourceByDatasetIdRequestQuerySanitizer(json: any): GetPredictionFileReadUrlFromDatasourceByDatasetIdRequestQuery {
    return {
        'fileName': json['fileName'],
    };
}
export const GetPredictionFileReadUrlFromDatasourceByDatasetIdRequestQueryValidatorShape = {
    'fileName': yup.string().min(4).defined(),
};
export const GetPredictionFileReadUrlFromDatasourceByDatasetIdRequestQueryValidator = yup.object().shape(GetPredictionFileReadUrlFromDatasourceByDatasetIdRequestQueryValidatorShape);
export interface GetPredictionFileWriteUrlFromDatasourceByDatasetIdRequestQuery {
    fileName: string;
}
export function GetPredictionFileWriteUrlFromDatasourceByDatasetIdRequestQuerySanitizer(json: any): GetPredictionFileWriteUrlFromDatasourceByDatasetIdRequestQuery {
    return {
        'fileName': json['fileName'],
    };
}
export const GetPredictionFileWriteUrlFromDatasourceByDatasetIdRequestQueryValidatorShape = {
    'fileName': yup.string().min(4).defined(),
};
export const GetPredictionFileWriteUrlFromDatasourceByDatasetIdRequestQueryValidator = yup.object().shape(GetPredictionFileWriteUrlFromDatasourceByDatasetIdRequestQueryValidatorShape);
export interface GetResourceReadURLRedirectRequestQuery {
    path: string;
}
export function GetResourceReadURLRedirectRequestQuerySanitizer(json: any): GetResourceReadURLRedirectRequestQuery {
    return {
        'path': json['path'],
    };
}
export const GetResourceReadURLRedirectRequestQueryValidatorShape = {
    'path': yup.string().defined(),
};
export const GetResourceReadURLRedirectRequestQueryValidator = yup.object().shape(GetResourceReadURLRedirectRequestQueryValidatorShape);
export interface UpdateDatasourceByDatasetIdRequestQuery {
}
export function UpdateDatasourceByDatasetIdRequestQuerySanitizer(json: any): UpdateDatasourceByDatasetIdRequestQuery {
    return {};
}
export const UpdateDatasourceByDatasetIdRequestQueryValidatorShape = {};
export const UpdateDatasourceByDatasetIdRequestQueryValidator = yup.object().shape(UpdateDatasourceByDatasetIdRequestQueryValidatorShape);
export interface UpdateDatasourceProcessedUntilTimestampByDatasetIdRequestQuery {
}
export function UpdateDatasourceProcessedUntilTimestampByDatasetIdRequestQuerySanitizer(json: any): UpdateDatasourceProcessedUntilTimestampByDatasetIdRequestQuery {
    return {};
}
export const UpdateDatasourceProcessedUntilTimestampByDatasetIdRequestQueryValidatorShape = {};
export const UpdateDatasourceProcessedUntilTimestampByDatasetIdRequestQueryValidator = yup.object().shape(UpdateDatasourceProcessedUntilTimestampByDatasetIdRequestQueryValidatorShape);
export interface VerifyDatasourceByDatasetIdRequestQuery {
}
export function VerifyDatasourceByDatasetIdRequestQuerySanitizer(json: any): VerifyDatasourceByDatasetIdRequestQuery {
    return {};
}
export const VerifyDatasourceByDatasetIdRequestQueryValidatorShape = {};
export const VerifyDatasourceByDatasetIdRequestQueryValidator = yup.object().shape(VerifyDatasourceByDatasetIdRequestQueryValidatorShape);
export type UpdateDatasourceByDatasetIdRequestBody = DatasourceConfig;
export const UpdateDatasourceByDatasetIdRequestBodySanitizer = DatasourceConfigFromJSON;
export const UpdateDatasourceByDatasetIdRequestBodyValidator = DatasourceConfigValidator;
export const UpdateDatasourceByDatasetIdTypiaAssertEquals = (input: any) => {
    return ((input: any): UpdateDatasourceByDatasetIdRequestBody => {
        const __is = (input: any, _exceptionable: boolean = true): input is UpdateDatasourceByDatasetIdRequestBody => {
            const $is_custom = (typia.createAssertEquals as any).is_custom;
            const $io0 = (input: any, _exceptionable: boolean = true): boolean => "AZURE" === input.type && "string" === typeof input.fullPath && ("string" === typeof input.accountName && 1 <= input.accountName.length) && ("string" === typeof input.accountKey && 1 <= input.accountKey.length) && (undefined === input.id || "string" === typeof input.id && $is_custom("pattern_DatasourceConfigBase_id", "string", "", input.id)) && ("INPUT_OUTPUT" === input.purpose || "INPUT" === input.purpose || "LIGHTLY" === input.purpose) && (undefined === input.thumbSuffix || "string" === typeof input.thumbSuffix) && (5 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["type", "fullPath", "accountName", "accountKey", "id", "purpose", "thumbSuffix"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            const $io1 = (input: any, _exceptionable: boolean = true): boolean => "DatasourceConfigAzure" === input.type && "string" === typeof input.fullPath && ("string" === typeof input.accountName && 1 <= input.accountName.length) && ("string" === typeof input.accountKey && 1 <= input.accountKey.length) && (undefined === input.id || "string" === typeof input.id && $is_custom("pattern_DatasourceConfigBase_id", "string", "", input.id)) && ("INPUT_OUTPUT" === input.purpose || "INPUT" === input.purpose || "LIGHTLY" === input.purpose) && (undefined === input.thumbSuffix || "string" === typeof input.thumbSuffix) && (5 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["type", "fullPath", "accountName", "accountKey", "id", "purpose", "thumbSuffix"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            const $io2 = (input: any, _exceptionable: boolean = true): boolean => "DatasourceConfigGCS" === input.type && "string" === typeof input.fullPath && ("string" === typeof input.gcsProjectId && 1 <= input.gcsProjectId.length) && "string" === typeof input.gcsCredentials && (undefined === input.id || "string" === typeof input.id && $is_custom("pattern_DatasourceConfigBase_id", "string", "", input.id)) && ("INPUT_OUTPUT" === input.purpose || "INPUT" === input.purpose || "LIGHTLY" === input.purpose) && (undefined === input.thumbSuffix || "string" === typeof input.thumbSuffix) && (5 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["type", "fullPath", "gcsProjectId", "gcsCredentials", "id", "purpose", "thumbSuffix"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            const $io3 = (input: any, _exceptionable: boolean = true): boolean => "DatasourceConfigLIGHTLY" === input.type && "string" === typeof input.fullPath && (undefined === input.id || "string" === typeof input.id && $is_custom("pattern_DatasourceConfigBase_id", "string", "", input.id)) && ("INPUT_OUTPUT" === input.purpose || "INPUT" === input.purpose || "LIGHTLY" === input.purpose) && (undefined === input.thumbSuffix || "string" === typeof input.thumbSuffix) && (3 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["type", "fullPath", "id", "purpose", "thumbSuffix"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            const $io4 = (input: any, _exceptionable: boolean = true): boolean => "DatasourceConfigLOCAL" === input.type && "string" === typeof input.fullPath && (undefined === input.webServerLocation || "string" === typeof input.webServerLocation && $is_custom("pattern_DatasourceConfigLOCAL_webServerLocation", "string", "", input.webServerLocation)) && (undefined === input.id || "string" === typeof input.id && $is_custom("pattern_DatasourceConfigBase_id", "string", "", input.id)) && ("INPUT_OUTPUT" === input.purpose || "INPUT" === input.purpose || "LIGHTLY" === input.purpose) && (undefined === input.thumbSuffix || "string" === typeof input.thumbSuffix) && (3 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["type", "fullPath", "webServerLocation", "id", "purpose", "thumbSuffix"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            const $io5 = (input: any, _exceptionable: boolean = true): boolean => "DatasourceConfigOBS" === input.type && "string" === typeof input.fullPath && ("string" === typeof input.obsEndpoint && 1 <= input.obsEndpoint.length && $is_custom("pattern_DatasourceConfigOBS_obsEndpoint", "string", "", input.obsEndpoint)) && ("string" === typeof input.obsAccessKeyId && 1 <= input.obsAccessKeyId.length) && ("string" === typeof input.obsSecretAccessKey && 1 <= input.obsSecretAccessKey.length) && (undefined === input.id || "string" === typeof input.id && $is_custom("pattern_DatasourceConfigBase_id", "string", "", input.id)) && ("INPUT_OUTPUT" === input.purpose || "INPUT" === input.purpose || "LIGHTLY" === input.purpose) && (undefined === input.thumbSuffix || "string" === typeof input.thumbSuffix) && (6 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["type", "fullPath", "obsEndpoint", "obsAccessKeyId", "obsSecretAccessKey", "id", "purpose", "thumbSuffix"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            const $io6 = (input: any, _exceptionable: boolean = true): boolean => "DatasourceConfigS3" === input.type && "string" === typeof input.fullPath && ("us-east-2" === input.s3Region || "us-east-1" === input.s3Region || "us-west-1" === input.s3Region || "us-west-2" === input.s3Region || "af-south-1" === input.s3Region || "ap-east-1" === input.s3Region || "ap-south-2" === input.s3Region || "ap-southeast-3" === input.s3Region || "ap-southeast-4" === input.s3Region || "ap-south-1" === input.s3Region || "ap-northeast-3" === input.s3Region || "ap-northeast-2" === input.s3Region || "ap-southeast-1" === input.s3Region || "ap-southeast-2" === input.s3Region || "ap-northeast-1" === input.s3Region || "ca-central-1" === input.s3Region || "cn-northwest-1" === input.s3Region || "eu-central-1" === input.s3Region || "eu-west-1" === input.s3Region || "eu-west-2" === input.s3Region || "eu-south-1" === input.s3Region || "eu-west-3" === input.s3Region || "eu-north-1" === input.s3Region || "eu-south-2" === input.s3Region || "eu-central-2" === input.s3Region || "me-south-1" === input.s3Region || "me-central-1" === input.s3Region || "sa-east-1" === input.s3Region || "us-gov-east" === input.s3Region || "us-gov-west" === input.s3Region) && ("string" === typeof input.s3AccessKeyId && 1 <= input.s3AccessKeyId.length) && ("string" === typeof input.s3SecretAccessKey && 1 <= input.s3SecretAccessKey.length) && (undefined === input.s3ServerSideEncryptionKMSKey || "string" === typeof input.s3ServerSideEncryptionKMSKey && 1 <= input.s3ServerSideEncryptionKMSKey.length && $is_custom("pattern_DatasourceConfigS3_s3ServerSideEncryptionKMSKey", "string", "", input.s3ServerSideEncryptionKMSKey)) && (undefined === input.id || "string" === typeof input.id && $is_custom("pattern_DatasourceConfigBase_id", "string", "", input.id)) && ("INPUT_OUTPUT" === input.purpose || "INPUT" === input.purpose || "LIGHTLY" === input.purpose) && (undefined === input.thumbSuffix || "string" === typeof input.thumbSuffix) && (6 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["type", "fullPath", "s3Region", "s3AccessKeyId", "s3SecretAccessKey", "s3ServerSideEncryptionKMSKey", "id", "purpose", "thumbSuffix"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            const $io7 = (input: any, _exceptionable: boolean = true): boolean => "DatasourceConfigS3DelegatedAccess" === input.type && "string" === typeof input.fullPath && ("us-east-2" === input.s3Region || "us-east-1" === input.s3Region || "us-west-1" === input.s3Region || "us-west-2" === input.s3Region || "af-south-1" === input.s3Region || "ap-east-1" === input.s3Region || "ap-south-2" === input.s3Region || "ap-southeast-3" === input.s3Region || "ap-southeast-4" === input.s3Region || "ap-south-1" === input.s3Region || "ap-northeast-3" === input.s3Region || "ap-northeast-2" === input.s3Region || "ap-southeast-1" === input.s3Region || "ap-southeast-2" === input.s3Region || "ap-northeast-1" === input.s3Region || "ca-central-1" === input.s3Region || "cn-northwest-1" === input.s3Region || "eu-central-1" === input.s3Region || "eu-west-1" === input.s3Region || "eu-west-2" === input.s3Region || "eu-south-1" === input.s3Region || "eu-west-3" === input.s3Region || "eu-north-1" === input.s3Region || "eu-south-2" === input.s3Region || "eu-central-2" === input.s3Region || "me-south-1" === input.s3Region || "me-central-1" === input.s3Region || "sa-east-1" === input.s3Region || "us-gov-east" === input.s3Region || "us-gov-west" === input.s3Region) && ("string" === typeof input.s3ExternalId && 10 <= input.s3ExternalId.length && $is_custom("pattern_DatasourceConfigS3DelegatedAccess_s3ExternalId", "string", "", input.s3ExternalId)) && ("string" === typeof input.s3ARN && 12 <= input.s3ARN.length && $is_custom("pattern_DatasourceConfigS3DelegatedAccess_s3ARN", "string", "", input.s3ARN)) && (undefined === input.s3ServerSideEncryptionKMSKey || "string" === typeof input.s3ServerSideEncryptionKMSKey && 1 <= input.s3ServerSideEncryptionKMSKey.length && $is_custom("pattern_DatasourceConfigS3DelegatedAccess_s3ServerSideEncryptionKMSKey", "string", "", input.s3ServerSideEncryptionKMSKey)) && (undefined === input.id || "string" === typeof input.id && $is_custom("pattern_DatasourceConfigBase_id", "string", "", input.id)) && ("INPUT_OUTPUT" === input.purpose || "INPUT" === input.purpose || "LIGHTLY" === input.purpose) && (undefined === input.thumbSuffix || "string" === typeof input.thumbSuffix) && (6 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["type", "fullPath", "s3Region", "s3ExternalId", "s3ARN", "s3ServerSideEncryptionKMSKey", "id", "purpose", "thumbSuffix"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            const $io8 = (input: any, _exceptionable: boolean = true): boolean => "GCS" === input.type && "string" === typeof input.fullPath && ("string" === typeof input.gcsProjectId && 1 <= input.gcsProjectId.length) && "string" === typeof input.gcsCredentials && (undefined === input.id || "string" === typeof input.id && $is_custom("pattern_DatasourceConfigBase_id", "string", "", input.id)) && ("INPUT_OUTPUT" === input.purpose || "INPUT" === input.purpose || "LIGHTLY" === input.purpose) && (undefined === input.thumbSuffix || "string" === typeof input.thumbSuffix) && (5 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["type", "fullPath", "gcsProjectId", "gcsCredentials", "id", "purpose", "thumbSuffix"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            const $io9 = (input: any, _exceptionable: boolean = true): boolean => "LIGHTLY" === input.type && "string" === typeof input.fullPath && (undefined === input.id || "string" === typeof input.id && $is_custom("pattern_DatasourceConfigBase_id", "string", "", input.id)) && ("INPUT_OUTPUT" === input.purpose || "INPUT" === input.purpose || "LIGHTLY" === input.purpose) && (undefined === input.thumbSuffix || "string" === typeof input.thumbSuffix) && (3 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["type", "fullPath", "id", "purpose", "thumbSuffix"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            const $io10 = (input: any, _exceptionable: boolean = true): boolean => "LOCAL" === input.type && "string" === typeof input.fullPath && (undefined === input.webServerLocation || "string" === typeof input.webServerLocation && $is_custom("pattern_DatasourceConfigLOCAL_webServerLocation", "string", "", input.webServerLocation)) && (undefined === input.id || "string" === typeof input.id && $is_custom("pattern_DatasourceConfigBase_id", "string", "", input.id)) && ("INPUT_OUTPUT" === input.purpose || "INPUT" === input.purpose || "LIGHTLY" === input.purpose) && (undefined === input.thumbSuffix || "string" === typeof input.thumbSuffix) && (3 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["type", "fullPath", "webServerLocation", "id", "purpose", "thumbSuffix"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            const $io11 = (input: any, _exceptionable: boolean = true): boolean => "OBS" === input.type && "string" === typeof input.fullPath && ("string" === typeof input.obsEndpoint && 1 <= input.obsEndpoint.length && $is_custom("pattern_DatasourceConfigOBS_obsEndpoint", "string", "", input.obsEndpoint)) && ("string" === typeof input.obsAccessKeyId && 1 <= input.obsAccessKeyId.length) && ("string" === typeof input.obsSecretAccessKey && 1 <= input.obsSecretAccessKey.length) && (undefined === input.id || "string" === typeof input.id && $is_custom("pattern_DatasourceConfigBase_id", "string", "", input.id)) && ("INPUT_OUTPUT" === input.purpose || "INPUT" === input.purpose || "LIGHTLY" === input.purpose) && (undefined === input.thumbSuffix || "string" === typeof input.thumbSuffix) && (6 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["type", "fullPath", "obsEndpoint", "obsAccessKeyId", "obsSecretAccessKey", "id", "purpose", "thumbSuffix"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            const $io12 = (input: any, _exceptionable: boolean = true): boolean => "S3" === input.type && "string" === typeof input.fullPath && ("us-east-2" === input.s3Region || "us-east-1" === input.s3Region || "us-west-1" === input.s3Region || "us-west-2" === input.s3Region || "af-south-1" === input.s3Region || "ap-east-1" === input.s3Region || "ap-south-2" === input.s3Region || "ap-southeast-3" === input.s3Region || "ap-southeast-4" === input.s3Region || "ap-south-1" === input.s3Region || "ap-northeast-3" === input.s3Region || "ap-northeast-2" === input.s3Region || "ap-southeast-1" === input.s3Region || "ap-southeast-2" === input.s3Region || "ap-northeast-1" === input.s3Region || "ca-central-1" === input.s3Region || "cn-northwest-1" === input.s3Region || "eu-central-1" === input.s3Region || "eu-west-1" === input.s3Region || "eu-west-2" === input.s3Region || "eu-south-1" === input.s3Region || "eu-west-3" === input.s3Region || "eu-north-1" === input.s3Region || "eu-south-2" === input.s3Region || "eu-central-2" === input.s3Region || "me-south-1" === input.s3Region || "me-central-1" === input.s3Region || "sa-east-1" === input.s3Region || "us-gov-east" === input.s3Region || "us-gov-west" === input.s3Region) && ("string" === typeof input.s3AccessKeyId && 1 <= input.s3AccessKeyId.length) && ("string" === typeof input.s3SecretAccessKey && 1 <= input.s3SecretAccessKey.length) && (undefined === input.s3ServerSideEncryptionKMSKey || "string" === typeof input.s3ServerSideEncryptionKMSKey && 1 <= input.s3ServerSideEncryptionKMSKey.length && $is_custom("pattern_DatasourceConfigS3_s3ServerSideEncryptionKMSKey", "string", "", input.s3ServerSideEncryptionKMSKey)) && (undefined === input.id || "string" === typeof input.id && $is_custom("pattern_DatasourceConfigBase_id", "string", "", input.id)) && ("INPUT_OUTPUT" === input.purpose || "INPUT" === input.purpose || "LIGHTLY" === input.purpose) && (undefined === input.thumbSuffix || "string" === typeof input.thumbSuffix) && (6 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["type", "fullPath", "s3Region", "s3AccessKeyId", "s3SecretAccessKey", "s3ServerSideEncryptionKMSKey", "id", "purpose", "thumbSuffix"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            const $io13 = (input: any, _exceptionable: boolean = true): boolean => "S3DelegatedAccess" === input.type && "string" === typeof input.fullPath && ("us-east-2" === input.s3Region || "us-east-1" === input.s3Region || "us-west-1" === input.s3Region || "us-west-2" === input.s3Region || "af-south-1" === input.s3Region || "ap-east-1" === input.s3Region || "ap-south-2" === input.s3Region || "ap-southeast-3" === input.s3Region || "ap-southeast-4" === input.s3Region || "ap-south-1" === input.s3Region || "ap-northeast-3" === input.s3Region || "ap-northeast-2" === input.s3Region || "ap-southeast-1" === input.s3Region || "ap-southeast-2" === input.s3Region || "ap-northeast-1" === input.s3Region || "ca-central-1" === input.s3Region || "cn-northwest-1" === input.s3Region || "eu-central-1" === input.s3Region || "eu-west-1" === input.s3Region || "eu-west-2" === input.s3Region || "eu-south-1" === input.s3Region || "eu-west-3" === input.s3Region || "eu-north-1" === input.s3Region || "eu-south-2" === input.s3Region || "eu-central-2" === input.s3Region || "me-south-1" === input.s3Region || "me-central-1" === input.s3Region || "sa-east-1" === input.s3Region || "us-gov-east" === input.s3Region || "us-gov-west" === input.s3Region) && ("string" === typeof input.s3ExternalId && 10 <= input.s3ExternalId.length && $is_custom("pattern_DatasourceConfigS3DelegatedAccess_s3ExternalId", "string", "", input.s3ExternalId)) && ("string" === typeof input.s3ARN && 12 <= input.s3ARN.length && $is_custom("pattern_DatasourceConfigS3DelegatedAccess_s3ARN", "string", "", input.s3ARN)) && (undefined === input.s3ServerSideEncryptionKMSKey || "string" === typeof input.s3ServerSideEncryptionKMSKey && 1 <= input.s3ServerSideEncryptionKMSKey.length && $is_custom("pattern_DatasourceConfigS3DelegatedAccess_s3ServerSideEncryptionKMSKey", "string", "", input.s3ServerSideEncryptionKMSKey)) && (undefined === input.id || "string" === typeof input.id && $is_custom("pattern_DatasourceConfigBase_id", "string", "", input.id)) && ("INPUT_OUTPUT" === input.purpose || "INPUT" === input.purpose || "LIGHTLY" === input.purpose) && (undefined === input.thumbSuffix || "string" === typeof input.thumbSuffix) && (6 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["type", "fullPath", "s3Region", "s3ExternalId", "s3ARN", "s3ServerSideEncryptionKMSKey", "id", "purpose", "thumbSuffix"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            const $iu0 = (input: any, _exceptionable: boolean = true): any => (() => {
                if ("DatasourceConfigAzure" === input.type)
                    return $io1(input, true && _exceptionable);
                if ("AZURE" === input.type)
                    return $io0(input, true && _exceptionable);
                if ("DatasourceConfigGCS" === input.type)
                    return $io2(input, true && _exceptionable);
                if ("DatasourceConfigLIGHTLY" === input.type)
                    return $io3(input, true && _exceptionable);
                if ("DatasourceConfigLOCAL" === input.type)
                    return $io4(input, true && _exceptionable);
                if ("OBS" === input.type)
                    return $io11(input, true && _exceptionable);
                if ("DatasourceConfigOBS" === input.type)
                    return $io5(input, true && _exceptionable);
                if ("DatasourceConfigS3" === input.type)
                    return $io6(input, true && _exceptionable);
                if ("DatasourceConfigS3DelegatedAccess" === input.type)
                    return $io7(input, true && _exceptionable);
                if ("GCS" === input.type)
                    return $io8(input, true && _exceptionable);
                if ("LIGHTLY" === input.type)
                    return $io9(input, true && _exceptionable);
                if ("LOCAL" === input.type)
                    return $io10(input, true && _exceptionable);
                if ("S3" === input.type)
                    return $io12(input, true && _exceptionable);
                if ("S3DelegatedAccess" === input.type)
                    return $io13(input, true && _exceptionable);
                return false;
            })();
            return "object" === typeof input && null !== input && $iu0(input, true);
        };
        if (false === __is(input))
            ((input: any, _path: string, _exceptionable: boolean = true): input is UpdateDatasourceByDatasetIdRequestBody => {
                const $guard = (typia.createAssertEquals as any).guard;
                const $is_custom = (typia.createAssertEquals as any).is_custom;
                const $join = (typia.createAssertEquals as any).join;
                const $ao0 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("AZURE" === input.type || $guard(_exceptionable, {
                    path: _path + ".type",
                    expected: "\"AZURE\"",
                    value: input.type
                })) && ("string" === typeof input.fullPath || $guard(_exceptionable, {
                    path: _path + ".fullPath",
                    expected: "string",
                    value: input.fullPath
                })) && ("string" === typeof input.accountName && (1 <= input.accountName.length || $guard(_exceptionable, {
                    path: _path + ".accountName",
                    expected: "string (@minLength 1)",
                    value: input.accountName
                })) || $guard(_exceptionable, {
                    path: _path + ".accountName",
                    expected: "string",
                    value: input.accountName
                })) && ("string" === typeof input.accountKey && (1 <= input.accountKey.length || $guard(_exceptionable, {
                    path: _path + ".accountKey",
                    expected: "string (@minLength 1)",
                    value: input.accountKey
                })) || $guard(_exceptionable, {
                    path: _path + ".accountKey",
                    expected: "string",
                    value: input.accountKey
                })) && (undefined === input.id || "string" === typeof input.id && ($is_custom("pattern_DatasourceConfigBase_id", "string", "", input.id) || $guard(_exceptionable, {
                    path: _path + ".id",
                    expected: "string (@pattern_DatasourceConfigBase_id)",
                    value: input.id
                })) || $guard(_exceptionable, {
                    path: _path + ".id",
                    expected: "(string | undefined)",
                    value: input.id
                })) && ("INPUT_OUTPUT" === input.purpose || "INPUT" === input.purpose || "LIGHTLY" === input.purpose || $guard(_exceptionable, {
                    path: _path + ".purpose",
                    expected: "(\"INPUT\" | \"INPUT_OUTPUT\" | \"LIGHTLY\")",
                    value: input.purpose
                })) && (undefined === input.thumbSuffix || "string" === typeof input.thumbSuffix || $guard(_exceptionable, {
                    path: _path + ".thumbSuffix",
                    expected: "(string | undefined)",
                    value: input.thumbSuffix
                })) && (5 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["type", "fullPath", "accountName", "accountKey", "id", "purpose", "thumbSuffix"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                const $ao1 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("DatasourceConfigAzure" === input.type || $guard(_exceptionable, {
                    path: _path + ".type",
                    expected: "\"DatasourceConfigAzure\"",
                    value: input.type
                })) && ("string" === typeof input.fullPath || $guard(_exceptionable, {
                    path: _path + ".fullPath",
                    expected: "string",
                    value: input.fullPath
                })) && ("string" === typeof input.accountName && (1 <= input.accountName.length || $guard(_exceptionable, {
                    path: _path + ".accountName",
                    expected: "string (@minLength 1)",
                    value: input.accountName
                })) || $guard(_exceptionable, {
                    path: _path + ".accountName",
                    expected: "string",
                    value: input.accountName
                })) && ("string" === typeof input.accountKey && (1 <= input.accountKey.length || $guard(_exceptionable, {
                    path: _path + ".accountKey",
                    expected: "string (@minLength 1)",
                    value: input.accountKey
                })) || $guard(_exceptionable, {
                    path: _path + ".accountKey",
                    expected: "string",
                    value: input.accountKey
                })) && (undefined === input.id || "string" === typeof input.id && ($is_custom("pattern_DatasourceConfigBase_id", "string", "", input.id) || $guard(_exceptionable, {
                    path: _path + ".id",
                    expected: "string (@pattern_DatasourceConfigBase_id)",
                    value: input.id
                })) || $guard(_exceptionable, {
                    path: _path + ".id",
                    expected: "(string | undefined)",
                    value: input.id
                })) && ("INPUT_OUTPUT" === input.purpose || "INPUT" === input.purpose || "LIGHTLY" === input.purpose || $guard(_exceptionable, {
                    path: _path + ".purpose",
                    expected: "(\"INPUT\" | \"INPUT_OUTPUT\" | \"LIGHTLY\")",
                    value: input.purpose
                })) && (undefined === input.thumbSuffix || "string" === typeof input.thumbSuffix || $guard(_exceptionable, {
                    path: _path + ".thumbSuffix",
                    expected: "(string | undefined)",
                    value: input.thumbSuffix
                })) && (5 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["type", "fullPath", "accountName", "accountKey", "id", "purpose", "thumbSuffix"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                const $ao2 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("DatasourceConfigGCS" === input.type || $guard(_exceptionable, {
                    path: _path + ".type",
                    expected: "\"DatasourceConfigGCS\"",
                    value: input.type
                })) && ("string" === typeof input.fullPath || $guard(_exceptionable, {
                    path: _path + ".fullPath",
                    expected: "string",
                    value: input.fullPath
                })) && ("string" === typeof input.gcsProjectId && (1 <= input.gcsProjectId.length || $guard(_exceptionable, {
                    path: _path + ".gcsProjectId",
                    expected: "string (@minLength 1)",
                    value: input.gcsProjectId
                })) || $guard(_exceptionable, {
                    path: _path + ".gcsProjectId",
                    expected: "string",
                    value: input.gcsProjectId
                })) && ("string" === typeof input.gcsCredentials || $guard(_exceptionable, {
                    path: _path + ".gcsCredentials",
                    expected: "string",
                    value: input.gcsCredentials
                })) && (undefined === input.id || "string" === typeof input.id && ($is_custom("pattern_DatasourceConfigBase_id", "string", "", input.id) || $guard(_exceptionable, {
                    path: _path + ".id",
                    expected: "string (@pattern_DatasourceConfigBase_id)",
                    value: input.id
                })) || $guard(_exceptionable, {
                    path: _path + ".id",
                    expected: "(string | undefined)",
                    value: input.id
                })) && ("INPUT_OUTPUT" === input.purpose || "INPUT" === input.purpose || "LIGHTLY" === input.purpose || $guard(_exceptionable, {
                    path: _path + ".purpose",
                    expected: "(\"INPUT\" | \"INPUT_OUTPUT\" | \"LIGHTLY\")",
                    value: input.purpose
                })) && (undefined === input.thumbSuffix || "string" === typeof input.thumbSuffix || $guard(_exceptionable, {
                    path: _path + ".thumbSuffix",
                    expected: "(string | undefined)",
                    value: input.thumbSuffix
                })) && (5 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["type", "fullPath", "gcsProjectId", "gcsCredentials", "id", "purpose", "thumbSuffix"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                const $ao3 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("DatasourceConfigLIGHTLY" === input.type || $guard(_exceptionable, {
                    path: _path + ".type",
                    expected: "\"DatasourceConfigLIGHTLY\"",
                    value: input.type
                })) && ("string" === typeof input.fullPath || $guard(_exceptionable, {
                    path: _path + ".fullPath",
                    expected: "string",
                    value: input.fullPath
                })) && (undefined === input.id || "string" === typeof input.id && ($is_custom("pattern_DatasourceConfigBase_id", "string", "", input.id) || $guard(_exceptionable, {
                    path: _path + ".id",
                    expected: "string (@pattern_DatasourceConfigBase_id)",
                    value: input.id
                })) || $guard(_exceptionable, {
                    path: _path + ".id",
                    expected: "(string | undefined)",
                    value: input.id
                })) && ("INPUT_OUTPUT" === input.purpose || "INPUT" === input.purpose || "LIGHTLY" === input.purpose || $guard(_exceptionable, {
                    path: _path + ".purpose",
                    expected: "(\"INPUT\" | \"INPUT_OUTPUT\" | \"LIGHTLY\")",
                    value: input.purpose
                })) && (undefined === input.thumbSuffix || "string" === typeof input.thumbSuffix || $guard(_exceptionable, {
                    path: _path + ".thumbSuffix",
                    expected: "(string | undefined)",
                    value: input.thumbSuffix
                })) && (3 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["type", "fullPath", "id", "purpose", "thumbSuffix"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                const $ao4 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("DatasourceConfigLOCAL" === input.type || $guard(_exceptionable, {
                    path: _path + ".type",
                    expected: "\"DatasourceConfigLOCAL\"",
                    value: input.type
                })) && ("string" === typeof input.fullPath || $guard(_exceptionable, {
                    path: _path + ".fullPath",
                    expected: "string",
                    value: input.fullPath
                })) && (undefined === input.webServerLocation || "string" === typeof input.webServerLocation && ($is_custom("pattern_DatasourceConfigLOCAL_webServerLocation", "string", "", input.webServerLocation) || $guard(_exceptionable, {
                    path: _path + ".webServerLocation",
                    expected: "string (@pattern_DatasourceConfigLOCAL_webServerLocation)",
                    value: input.webServerLocation
                })) || $guard(_exceptionable, {
                    path: _path + ".webServerLocation",
                    expected: "(string | undefined)",
                    value: input.webServerLocation
                })) && (undefined === input.id || "string" === typeof input.id && ($is_custom("pattern_DatasourceConfigBase_id", "string", "", input.id) || $guard(_exceptionable, {
                    path: _path + ".id",
                    expected: "string (@pattern_DatasourceConfigBase_id)",
                    value: input.id
                })) || $guard(_exceptionable, {
                    path: _path + ".id",
                    expected: "(string | undefined)",
                    value: input.id
                })) && ("INPUT_OUTPUT" === input.purpose || "INPUT" === input.purpose || "LIGHTLY" === input.purpose || $guard(_exceptionable, {
                    path: _path + ".purpose",
                    expected: "(\"INPUT\" | \"INPUT_OUTPUT\" | \"LIGHTLY\")",
                    value: input.purpose
                })) && (undefined === input.thumbSuffix || "string" === typeof input.thumbSuffix || $guard(_exceptionable, {
                    path: _path + ".thumbSuffix",
                    expected: "(string | undefined)",
                    value: input.thumbSuffix
                })) && (3 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["type", "fullPath", "webServerLocation", "id", "purpose", "thumbSuffix"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                const $ao5 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("DatasourceConfigOBS" === input.type || $guard(_exceptionable, {
                    path: _path + ".type",
                    expected: "\"DatasourceConfigOBS\"",
                    value: input.type
                })) && ("string" === typeof input.fullPath || $guard(_exceptionable, {
                    path: _path + ".fullPath",
                    expected: "string",
                    value: input.fullPath
                })) && ("string" === typeof input.obsEndpoint && (1 <= input.obsEndpoint.length || $guard(_exceptionable, {
                    path: _path + ".obsEndpoint",
                    expected: "string (@minLength 1)",
                    value: input.obsEndpoint
                })) && ($is_custom("pattern_DatasourceConfigOBS_obsEndpoint", "string", "", input.obsEndpoint) || $guard(_exceptionable, {
                    path: _path + ".obsEndpoint",
                    expected: "string (@pattern_DatasourceConfigOBS_obsEndpoint)",
                    value: input.obsEndpoint
                })) || $guard(_exceptionable, {
                    path: _path + ".obsEndpoint",
                    expected: "string",
                    value: input.obsEndpoint
                })) && ("string" === typeof input.obsAccessKeyId && (1 <= input.obsAccessKeyId.length || $guard(_exceptionable, {
                    path: _path + ".obsAccessKeyId",
                    expected: "string (@minLength 1)",
                    value: input.obsAccessKeyId
                })) || $guard(_exceptionable, {
                    path: _path + ".obsAccessKeyId",
                    expected: "string",
                    value: input.obsAccessKeyId
                })) && ("string" === typeof input.obsSecretAccessKey && (1 <= input.obsSecretAccessKey.length || $guard(_exceptionable, {
                    path: _path + ".obsSecretAccessKey",
                    expected: "string (@minLength 1)",
                    value: input.obsSecretAccessKey
                })) || $guard(_exceptionable, {
                    path: _path + ".obsSecretAccessKey",
                    expected: "string",
                    value: input.obsSecretAccessKey
                })) && (undefined === input.id || "string" === typeof input.id && ($is_custom("pattern_DatasourceConfigBase_id", "string", "", input.id) || $guard(_exceptionable, {
                    path: _path + ".id",
                    expected: "string (@pattern_DatasourceConfigBase_id)",
                    value: input.id
                })) || $guard(_exceptionable, {
                    path: _path + ".id",
                    expected: "(string | undefined)",
                    value: input.id
                })) && ("INPUT_OUTPUT" === input.purpose || "INPUT" === input.purpose || "LIGHTLY" === input.purpose || $guard(_exceptionable, {
                    path: _path + ".purpose",
                    expected: "(\"INPUT\" | \"INPUT_OUTPUT\" | \"LIGHTLY\")",
                    value: input.purpose
                })) && (undefined === input.thumbSuffix || "string" === typeof input.thumbSuffix || $guard(_exceptionable, {
                    path: _path + ".thumbSuffix",
                    expected: "(string | undefined)",
                    value: input.thumbSuffix
                })) && (6 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["type", "fullPath", "obsEndpoint", "obsAccessKeyId", "obsSecretAccessKey", "id", "purpose", "thumbSuffix"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                const $ao6 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("DatasourceConfigS3" === input.type || $guard(_exceptionable, {
                    path: _path + ".type",
                    expected: "\"DatasourceConfigS3\"",
                    value: input.type
                })) && ("string" === typeof input.fullPath || $guard(_exceptionable, {
                    path: _path + ".fullPath",
                    expected: "string",
                    value: input.fullPath
                })) && ("us-east-2" === input.s3Region || "us-east-1" === input.s3Region || "us-west-1" === input.s3Region || "us-west-2" === input.s3Region || "af-south-1" === input.s3Region || "ap-east-1" === input.s3Region || "ap-south-2" === input.s3Region || "ap-southeast-3" === input.s3Region || "ap-southeast-4" === input.s3Region || "ap-south-1" === input.s3Region || "ap-northeast-3" === input.s3Region || "ap-northeast-2" === input.s3Region || "ap-southeast-1" === input.s3Region || "ap-southeast-2" === input.s3Region || "ap-northeast-1" === input.s3Region || "ca-central-1" === input.s3Region || "cn-northwest-1" === input.s3Region || "eu-central-1" === input.s3Region || "eu-west-1" === input.s3Region || "eu-west-2" === input.s3Region || "eu-south-1" === input.s3Region || "eu-west-3" === input.s3Region || "eu-north-1" === input.s3Region || "eu-south-2" === input.s3Region || "eu-central-2" === input.s3Region || "me-south-1" === input.s3Region || "me-central-1" === input.s3Region || "sa-east-1" === input.s3Region || "us-gov-east" === input.s3Region || "us-gov-west" === input.s3Region || $guard(_exceptionable, {
                    path: _path + ".s3Region",
                    expected: "(\"af-south-1\" | \"ap-east-1\" | \"ap-northeast-1\" | \"ap-northeast-2\" | \"ap-northeast-3\" | \"ap-south-1\" | \"ap-south-2\" | \"ap-southeast-1\" | \"ap-southeast-2\" | \"ap-southeast-3\" | \"ap-southeast-4\" | \"ca-central-1\" | \"cn-northwest-1\" | \"eu-central-1\" | \"eu-central-2\" | \"eu-north-1\" | \"eu-south-1\" | \"eu-south-2\" | \"eu-west-1\" | \"eu-west-2\" | \"eu-west-3\" | \"me-central-1\" | \"me-south-1\" | \"sa-east-1\" | \"us-east-1\" | \"us-east-2\" | \"us-gov-east\" | \"us-gov-west\" | \"us-west-1\" | \"us-west-2\")",
                    value: input.s3Region
                })) && ("string" === typeof input.s3AccessKeyId && (1 <= input.s3AccessKeyId.length || $guard(_exceptionable, {
                    path: _path + ".s3AccessKeyId",
                    expected: "string (@minLength 1)",
                    value: input.s3AccessKeyId
                })) || $guard(_exceptionable, {
                    path: _path + ".s3AccessKeyId",
                    expected: "string",
                    value: input.s3AccessKeyId
                })) && ("string" === typeof input.s3SecretAccessKey && (1 <= input.s3SecretAccessKey.length || $guard(_exceptionable, {
                    path: _path + ".s3SecretAccessKey",
                    expected: "string (@minLength 1)",
                    value: input.s3SecretAccessKey
                })) || $guard(_exceptionable, {
                    path: _path + ".s3SecretAccessKey",
                    expected: "string",
                    value: input.s3SecretAccessKey
                })) && (undefined === input.s3ServerSideEncryptionKMSKey || "string" === typeof input.s3ServerSideEncryptionKMSKey && (1 <= input.s3ServerSideEncryptionKMSKey.length || $guard(_exceptionable, {
                    path: _path + ".s3ServerSideEncryptionKMSKey",
                    expected: "string (@minLength 1)",
                    value: input.s3ServerSideEncryptionKMSKey
                })) && ($is_custom("pattern_DatasourceConfigS3_s3ServerSideEncryptionKMSKey", "string", "", input.s3ServerSideEncryptionKMSKey) || $guard(_exceptionable, {
                    path: _path + ".s3ServerSideEncryptionKMSKey",
                    expected: "string (@pattern_DatasourceConfigS3_s3ServerSideEncryptionKMSKey)",
                    value: input.s3ServerSideEncryptionKMSKey
                })) || $guard(_exceptionable, {
                    path: _path + ".s3ServerSideEncryptionKMSKey",
                    expected: "(string | undefined)",
                    value: input.s3ServerSideEncryptionKMSKey
                })) && (undefined === input.id || "string" === typeof input.id && ($is_custom("pattern_DatasourceConfigBase_id", "string", "", input.id) || $guard(_exceptionable, {
                    path: _path + ".id",
                    expected: "string (@pattern_DatasourceConfigBase_id)",
                    value: input.id
                })) || $guard(_exceptionable, {
                    path: _path + ".id",
                    expected: "(string | undefined)",
                    value: input.id
                })) && ("INPUT_OUTPUT" === input.purpose || "INPUT" === input.purpose || "LIGHTLY" === input.purpose || $guard(_exceptionable, {
                    path: _path + ".purpose",
                    expected: "(\"INPUT\" | \"INPUT_OUTPUT\" | \"LIGHTLY\")",
                    value: input.purpose
                })) && (undefined === input.thumbSuffix || "string" === typeof input.thumbSuffix || $guard(_exceptionable, {
                    path: _path + ".thumbSuffix",
                    expected: "(string | undefined)",
                    value: input.thumbSuffix
                })) && (6 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["type", "fullPath", "s3Region", "s3AccessKeyId", "s3SecretAccessKey", "s3ServerSideEncryptionKMSKey", "id", "purpose", "thumbSuffix"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                const $ao7 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("DatasourceConfigS3DelegatedAccess" === input.type || $guard(_exceptionable, {
                    path: _path + ".type",
                    expected: "\"DatasourceConfigS3DelegatedAccess\"",
                    value: input.type
                })) && ("string" === typeof input.fullPath || $guard(_exceptionable, {
                    path: _path + ".fullPath",
                    expected: "string",
                    value: input.fullPath
                })) && ("us-east-2" === input.s3Region || "us-east-1" === input.s3Region || "us-west-1" === input.s3Region || "us-west-2" === input.s3Region || "af-south-1" === input.s3Region || "ap-east-1" === input.s3Region || "ap-south-2" === input.s3Region || "ap-southeast-3" === input.s3Region || "ap-southeast-4" === input.s3Region || "ap-south-1" === input.s3Region || "ap-northeast-3" === input.s3Region || "ap-northeast-2" === input.s3Region || "ap-southeast-1" === input.s3Region || "ap-southeast-2" === input.s3Region || "ap-northeast-1" === input.s3Region || "ca-central-1" === input.s3Region || "cn-northwest-1" === input.s3Region || "eu-central-1" === input.s3Region || "eu-west-1" === input.s3Region || "eu-west-2" === input.s3Region || "eu-south-1" === input.s3Region || "eu-west-3" === input.s3Region || "eu-north-1" === input.s3Region || "eu-south-2" === input.s3Region || "eu-central-2" === input.s3Region || "me-south-1" === input.s3Region || "me-central-1" === input.s3Region || "sa-east-1" === input.s3Region || "us-gov-east" === input.s3Region || "us-gov-west" === input.s3Region || $guard(_exceptionable, {
                    path: _path + ".s3Region",
                    expected: "(\"af-south-1\" | \"ap-east-1\" | \"ap-northeast-1\" | \"ap-northeast-2\" | \"ap-northeast-3\" | \"ap-south-1\" | \"ap-south-2\" | \"ap-southeast-1\" | \"ap-southeast-2\" | \"ap-southeast-3\" | \"ap-southeast-4\" | \"ca-central-1\" | \"cn-northwest-1\" | \"eu-central-1\" | \"eu-central-2\" | \"eu-north-1\" | \"eu-south-1\" | \"eu-south-2\" | \"eu-west-1\" | \"eu-west-2\" | \"eu-west-3\" | \"me-central-1\" | \"me-south-1\" | \"sa-east-1\" | \"us-east-1\" | \"us-east-2\" | \"us-gov-east\" | \"us-gov-west\" | \"us-west-1\" | \"us-west-2\")",
                    value: input.s3Region
                })) && ("string" === typeof input.s3ExternalId && (10 <= input.s3ExternalId.length || $guard(_exceptionable, {
                    path: _path + ".s3ExternalId",
                    expected: "string (@minLength 10)",
                    value: input.s3ExternalId
                })) && ($is_custom("pattern_DatasourceConfigS3DelegatedAccess_s3ExternalId", "string", "", input.s3ExternalId) || $guard(_exceptionable, {
                    path: _path + ".s3ExternalId",
                    expected: "string (@pattern_DatasourceConfigS3DelegatedAccess_s3ExternalId)",
                    value: input.s3ExternalId
                })) || $guard(_exceptionable, {
                    path: _path + ".s3ExternalId",
                    expected: "string",
                    value: input.s3ExternalId
                })) && ("string" === typeof input.s3ARN && (12 <= input.s3ARN.length || $guard(_exceptionable, {
                    path: _path + ".s3ARN",
                    expected: "string (@minLength 12)",
                    value: input.s3ARN
                })) && ($is_custom("pattern_DatasourceConfigS3DelegatedAccess_s3ARN", "string", "", input.s3ARN) || $guard(_exceptionable, {
                    path: _path + ".s3ARN",
                    expected: "string (@pattern_DatasourceConfigS3DelegatedAccess_s3ARN)",
                    value: input.s3ARN
                })) || $guard(_exceptionable, {
                    path: _path + ".s3ARN",
                    expected: "string",
                    value: input.s3ARN
                })) && (undefined === input.s3ServerSideEncryptionKMSKey || "string" === typeof input.s3ServerSideEncryptionKMSKey && (1 <= input.s3ServerSideEncryptionKMSKey.length || $guard(_exceptionable, {
                    path: _path + ".s3ServerSideEncryptionKMSKey",
                    expected: "string (@minLength 1)",
                    value: input.s3ServerSideEncryptionKMSKey
                })) && ($is_custom("pattern_DatasourceConfigS3DelegatedAccess_s3ServerSideEncryptionKMSKey", "string", "", input.s3ServerSideEncryptionKMSKey) || $guard(_exceptionable, {
                    path: _path + ".s3ServerSideEncryptionKMSKey",
                    expected: "string (@pattern_DatasourceConfigS3DelegatedAccess_s3ServerSideEncryptionKMSKey)",
                    value: input.s3ServerSideEncryptionKMSKey
                })) || $guard(_exceptionable, {
                    path: _path + ".s3ServerSideEncryptionKMSKey",
                    expected: "(string | undefined)",
                    value: input.s3ServerSideEncryptionKMSKey
                })) && (undefined === input.id || "string" === typeof input.id && ($is_custom("pattern_DatasourceConfigBase_id", "string", "", input.id) || $guard(_exceptionable, {
                    path: _path + ".id",
                    expected: "string (@pattern_DatasourceConfigBase_id)",
                    value: input.id
                })) || $guard(_exceptionable, {
                    path: _path + ".id",
                    expected: "(string | undefined)",
                    value: input.id
                })) && ("INPUT_OUTPUT" === input.purpose || "INPUT" === input.purpose || "LIGHTLY" === input.purpose || $guard(_exceptionable, {
                    path: _path + ".purpose",
                    expected: "(\"INPUT\" | \"INPUT_OUTPUT\" | \"LIGHTLY\")",
                    value: input.purpose
                })) && (undefined === input.thumbSuffix || "string" === typeof input.thumbSuffix || $guard(_exceptionable, {
                    path: _path + ".thumbSuffix",
                    expected: "(string | undefined)",
                    value: input.thumbSuffix
                })) && (6 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["type", "fullPath", "s3Region", "s3ExternalId", "s3ARN", "s3ServerSideEncryptionKMSKey", "id", "purpose", "thumbSuffix"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                const $ao8 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("GCS" === input.type || $guard(_exceptionable, {
                    path: _path + ".type",
                    expected: "\"GCS\"",
                    value: input.type
                })) && ("string" === typeof input.fullPath || $guard(_exceptionable, {
                    path: _path + ".fullPath",
                    expected: "string",
                    value: input.fullPath
                })) && ("string" === typeof input.gcsProjectId && (1 <= input.gcsProjectId.length || $guard(_exceptionable, {
                    path: _path + ".gcsProjectId",
                    expected: "string (@minLength 1)",
                    value: input.gcsProjectId
                })) || $guard(_exceptionable, {
                    path: _path + ".gcsProjectId",
                    expected: "string",
                    value: input.gcsProjectId
                })) && ("string" === typeof input.gcsCredentials || $guard(_exceptionable, {
                    path: _path + ".gcsCredentials",
                    expected: "string",
                    value: input.gcsCredentials
                })) && (undefined === input.id || "string" === typeof input.id && ($is_custom("pattern_DatasourceConfigBase_id", "string", "", input.id) || $guard(_exceptionable, {
                    path: _path + ".id",
                    expected: "string (@pattern_DatasourceConfigBase_id)",
                    value: input.id
                })) || $guard(_exceptionable, {
                    path: _path + ".id",
                    expected: "(string | undefined)",
                    value: input.id
                })) && ("INPUT_OUTPUT" === input.purpose || "INPUT" === input.purpose || "LIGHTLY" === input.purpose || $guard(_exceptionable, {
                    path: _path + ".purpose",
                    expected: "(\"INPUT\" | \"INPUT_OUTPUT\" | \"LIGHTLY\")",
                    value: input.purpose
                })) && (undefined === input.thumbSuffix || "string" === typeof input.thumbSuffix || $guard(_exceptionable, {
                    path: _path + ".thumbSuffix",
                    expected: "(string | undefined)",
                    value: input.thumbSuffix
                })) && (5 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["type", "fullPath", "gcsProjectId", "gcsCredentials", "id", "purpose", "thumbSuffix"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                const $ao9 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("LIGHTLY" === input.type || $guard(_exceptionable, {
                    path: _path + ".type",
                    expected: "\"LIGHTLY\"",
                    value: input.type
                })) && ("string" === typeof input.fullPath || $guard(_exceptionable, {
                    path: _path + ".fullPath",
                    expected: "string",
                    value: input.fullPath
                })) && (undefined === input.id || "string" === typeof input.id && ($is_custom("pattern_DatasourceConfigBase_id", "string", "", input.id) || $guard(_exceptionable, {
                    path: _path + ".id",
                    expected: "string (@pattern_DatasourceConfigBase_id)",
                    value: input.id
                })) || $guard(_exceptionable, {
                    path: _path + ".id",
                    expected: "(string | undefined)",
                    value: input.id
                })) && ("INPUT_OUTPUT" === input.purpose || "INPUT" === input.purpose || "LIGHTLY" === input.purpose || $guard(_exceptionable, {
                    path: _path + ".purpose",
                    expected: "(\"INPUT\" | \"INPUT_OUTPUT\" | \"LIGHTLY\")",
                    value: input.purpose
                })) && (undefined === input.thumbSuffix || "string" === typeof input.thumbSuffix || $guard(_exceptionable, {
                    path: _path + ".thumbSuffix",
                    expected: "(string | undefined)",
                    value: input.thumbSuffix
                })) && (3 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["type", "fullPath", "id", "purpose", "thumbSuffix"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                const $ao10 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("LOCAL" === input.type || $guard(_exceptionable, {
                    path: _path + ".type",
                    expected: "\"LOCAL\"",
                    value: input.type
                })) && ("string" === typeof input.fullPath || $guard(_exceptionable, {
                    path: _path + ".fullPath",
                    expected: "string",
                    value: input.fullPath
                })) && (undefined === input.webServerLocation || "string" === typeof input.webServerLocation && ($is_custom("pattern_DatasourceConfigLOCAL_webServerLocation", "string", "", input.webServerLocation) || $guard(_exceptionable, {
                    path: _path + ".webServerLocation",
                    expected: "string (@pattern_DatasourceConfigLOCAL_webServerLocation)",
                    value: input.webServerLocation
                })) || $guard(_exceptionable, {
                    path: _path + ".webServerLocation",
                    expected: "(string | undefined)",
                    value: input.webServerLocation
                })) && (undefined === input.id || "string" === typeof input.id && ($is_custom("pattern_DatasourceConfigBase_id", "string", "", input.id) || $guard(_exceptionable, {
                    path: _path + ".id",
                    expected: "string (@pattern_DatasourceConfigBase_id)",
                    value: input.id
                })) || $guard(_exceptionable, {
                    path: _path + ".id",
                    expected: "(string | undefined)",
                    value: input.id
                })) && ("INPUT_OUTPUT" === input.purpose || "INPUT" === input.purpose || "LIGHTLY" === input.purpose || $guard(_exceptionable, {
                    path: _path + ".purpose",
                    expected: "(\"INPUT\" | \"INPUT_OUTPUT\" | \"LIGHTLY\")",
                    value: input.purpose
                })) && (undefined === input.thumbSuffix || "string" === typeof input.thumbSuffix || $guard(_exceptionable, {
                    path: _path + ".thumbSuffix",
                    expected: "(string | undefined)",
                    value: input.thumbSuffix
                })) && (3 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["type", "fullPath", "webServerLocation", "id", "purpose", "thumbSuffix"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                const $ao11 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("OBS" === input.type || $guard(_exceptionable, {
                    path: _path + ".type",
                    expected: "\"OBS\"",
                    value: input.type
                })) && ("string" === typeof input.fullPath || $guard(_exceptionable, {
                    path: _path + ".fullPath",
                    expected: "string",
                    value: input.fullPath
                })) && ("string" === typeof input.obsEndpoint && (1 <= input.obsEndpoint.length || $guard(_exceptionable, {
                    path: _path + ".obsEndpoint",
                    expected: "string (@minLength 1)",
                    value: input.obsEndpoint
                })) && ($is_custom("pattern_DatasourceConfigOBS_obsEndpoint", "string", "", input.obsEndpoint) || $guard(_exceptionable, {
                    path: _path + ".obsEndpoint",
                    expected: "string (@pattern_DatasourceConfigOBS_obsEndpoint)",
                    value: input.obsEndpoint
                })) || $guard(_exceptionable, {
                    path: _path + ".obsEndpoint",
                    expected: "string",
                    value: input.obsEndpoint
                })) && ("string" === typeof input.obsAccessKeyId && (1 <= input.obsAccessKeyId.length || $guard(_exceptionable, {
                    path: _path + ".obsAccessKeyId",
                    expected: "string (@minLength 1)",
                    value: input.obsAccessKeyId
                })) || $guard(_exceptionable, {
                    path: _path + ".obsAccessKeyId",
                    expected: "string",
                    value: input.obsAccessKeyId
                })) && ("string" === typeof input.obsSecretAccessKey && (1 <= input.obsSecretAccessKey.length || $guard(_exceptionable, {
                    path: _path + ".obsSecretAccessKey",
                    expected: "string (@minLength 1)",
                    value: input.obsSecretAccessKey
                })) || $guard(_exceptionable, {
                    path: _path + ".obsSecretAccessKey",
                    expected: "string",
                    value: input.obsSecretAccessKey
                })) && (undefined === input.id || "string" === typeof input.id && ($is_custom("pattern_DatasourceConfigBase_id", "string", "", input.id) || $guard(_exceptionable, {
                    path: _path + ".id",
                    expected: "string (@pattern_DatasourceConfigBase_id)",
                    value: input.id
                })) || $guard(_exceptionable, {
                    path: _path + ".id",
                    expected: "(string | undefined)",
                    value: input.id
                })) && ("INPUT_OUTPUT" === input.purpose || "INPUT" === input.purpose || "LIGHTLY" === input.purpose || $guard(_exceptionable, {
                    path: _path + ".purpose",
                    expected: "(\"INPUT\" | \"INPUT_OUTPUT\" | \"LIGHTLY\")",
                    value: input.purpose
                })) && (undefined === input.thumbSuffix || "string" === typeof input.thumbSuffix || $guard(_exceptionable, {
                    path: _path + ".thumbSuffix",
                    expected: "(string | undefined)",
                    value: input.thumbSuffix
                })) && (6 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["type", "fullPath", "obsEndpoint", "obsAccessKeyId", "obsSecretAccessKey", "id", "purpose", "thumbSuffix"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                const $ao12 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("S3" === input.type || $guard(_exceptionable, {
                    path: _path + ".type",
                    expected: "\"S3\"",
                    value: input.type
                })) && ("string" === typeof input.fullPath || $guard(_exceptionable, {
                    path: _path + ".fullPath",
                    expected: "string",
                    value: input.fullPath
                })) && ("us-east-2" === input.s3Region || "us-east-1" === input.s3Region || "us-west-1" === input.s3Region || "us-west-2" === input.s3Region || "af-south-1" === input.s3Region || "ap-east-1" === input.s3Region || "ap-south-2" === input.s3Region || "ap-southeast-3" === input.s3Region || "ap-southeast-4" === input.s3Region || "ap-south-1" === input.s3Region || "ap-northeast-3" === input.s3Region || "ap-northeast-2" === input.s3Region || "ap-southeast-1" === input.s3Region || "ap-southeast-2" === input.s3Region || "ap-northeast-1" === input.s3Region || "ca-central-1" === input.s3Region || "cn-northwest-1" === input.s3Region || "eu-central-1" === input.s3Region || "eu-west-1" === input.s3Region || "eu-west-2" === input.s3Region || "eu-south-1" === input.s3Region || "eu-west-3" === input.s3Region || "eu-north-1" === input.s3Region || "eu-south-2" === input.s3Region || "eu-central-2" === input.s3Region || "me-south-1" === input.s3Region || "me-central-1" === input.s3Region || "sa-east-1" === input.s3Region || "us-gov-east" === input.s3Region || "us-gov-west" === input.s3Region || $guard(_exceptionable, {
                    path: _path + ".s3Region",
                    expected: "(\"af-south-1\" | \"ap-east-1\" | \"ap-northeast-1\" | \"ap-northeast-2\" | \"ap-northeast-3\" | \"ap-south-1\" | \"ap-south-2\" | \"ap-southeast-1\" | \"ap-southeast-2\" | \"ap-southeast-3\" | \"ap-southeast-4\" | \"ca-central-1\" | \"cn-northwest-1\" | \"eu-central-1\" | \"eu-central-2\" | \"eu-north-1\" | \"eu-south-1\" | \"eu-south-2\" | \"eu-west-1\" | \"eu-west-2\" | \"eu-west-3\" | \"me-central-1\" | \"me-south-1\" | \"sa-east-1\" | \"us-east-1\" | \"us-east-2\" | \"us-gov-east\" | \"us-gov-west\" | \"us-west-1\" | \"us-west-2\")",
                    value: input.s3Region
                })) && ("string" === typeof input.s3AccessKeyId && (1 <= input.s3AccessKeyId.length || $guard(_exceptionable, {
                    path: _path + ".s3AccessKeyId",
                    expected: "string (@minLength 1)",
                    value: input.s3AccessKeyId
                })) || $guard(_exceptionable, {
                    path: _path + ".s3AccessKeyId",
                    expected: "string",
                    value: input.s3AccessKeyId
                })) && ("string" === typeof input.s3SecretAccessKey && (1 <= input.s3SecretAccessKey.length || $guard(_exceptionable, {
                    path: _path + ".s3SecretAccessKey",
                    expected: "string (@minLength 1)",
                    value: input.s3SecretAccessKey
                })) || $guard(_exceptionable, {
                    path: _path + ".s3SecretAccessKey",
                    expected: "string",
                    value: input.s3SecretAccessKey
                })) && (undefined === input.s3ServerSideEncryptionKMSKey || "string" === typeof input.s3ServerSideEncryptionKMSKey && (1 <= input.s3ServerSideEncryptionKMSKey.length || $guard(_exceptionable, {
                    path: _path + ".s3ServerSideEncryptionKMSKey",
                    expected: "string (@minLength 1)",
                    value: input.s3ServerSideEncryptionKMSKey
                })) && ($is_custom("pattern_DatasourceConfigS3_s3ServerSideEncryptionKMSKey", "string", "", input.s3ServerSideEncryptionKMSKey) || $guard(_exceptionable, {
                    path: _path + ".s3ServerSideEncryptionKMSKey",
                    expected: "string (@pattern_DatasourceConfigS3_s3ServerSideEncryptionKMSKey)",
                    value: input.s3ServerSideEncryptionKMSKey
                })) || $guard(_exceptionable, {
                    path: _path + ".s3ServerSideEncryptionKMSKey",
                    expected: "(string | undefined)",
                    value: input.s3ServerSideEncryptionKMSKey
                })) && (undefined === input.id || "string" === typeof input.id && ($is_custom("pattern_DatasourceConfigBase_id", "string", "", input.id) || $guard(_exceptionable, {
                    path: _path + ".id",
                    expected: "string (@pattern_DatasourceConfigBase_id)",
                    value: input.id
                })) || $guard(_exceptionable, {
                    path: _path + ".id",
                    expected: "(string | undefined)",
                    value: input.id
                })) && ("INPUT_OUTPUT" === input.purpose || "INPUT" === input.purpose || "LIGHTLY" === input.purpose || $guard(_exceptionable, {
                    path: _path + ".purpose",
                    expected: "(\"INPUT\" | \"INPUT_OUTPUT\" | \"LIGHTLY\")",
                    value: input.purpose
                })) && (undefined === input.thumbSuffix || "string" === typeof input.thumbSuffix || $guard(_exceptionable, {
                    path: _path + ".thumbSuffix",
                    expected: "(string | undefined)",
                    value: input.thumbSuffix
                })) && (6 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["type", "fullPath", "s3Region", "s3AccessKeyId", "s3SecretAccessKey", "s3ServerSideEncryptionKMSKey", "id", "purpose", "thumbSuffix"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                const $ao13 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("S3DelegatedAccess" === input.type || $guard(_exceptionable, {
                    path: _path + ".type",
                    expected: "\"S3DelegatedAccess\"",
                    value: input.type
                })) && ("string" === typeof input.fullPath || $guard(_exceptionable, {
                    path: _path + ".fullPath",
                    expected: "string",
                    value: input.fullPath
                })) && ("us-east-2" === input.s3Region || "us-east-1" === input.s3Region || "us-west-1" === input.s3Region || "us-west-2" === input.s3Region || "af-south-1" === input.s3Region || "ap-east-1" === input.s3Region || "ap-south-2" === input.s3Region || "ap-southeast-3" === input.s3Region || "ap-southeast-4" === input.s3Region || "ap-south-1" === input.s3Region || "ap-northeast-3" === input.s3Region || "ap-northeast-2" === input.s3Region || "ap-southeast-1" === input.s3Region || "ap-southeast-2" === input.s3Region || "ap-northeast-1" === input.s3Region || "ca-central-1" === input.s3Region || "cn-northwest-1" === input.s3Region || "eu-central-1" === input.s3Region || "eu-west-1" === input.s3Region || "eu-west-2" === input.s3Region || "eu-south-1" === input.s3Region || "eu-west-3" === input.s3Region || "eu-north-1" === input.s3Region || "eu-south-2" === input.s3Region || "eu-central-2" === input.s3Region || "me-south-1" === input.s3Region || "me-central-1" === input.s3Region || "sa-east-1" === input.s3Region || "us-gov-east" === input.s3Region || "us-gov-west" === input.s3Region || $guard(_exceptionable, {
                    path: _path + ".s3Region",
                    expected: "(\"af-south-1\" | \"ap-east-1\" | \"ap-northeast-1\" | \"ap-northeast-2\" | \"ap-northeast-3\" | \"ap-south-1\" | \"ap-south-2\" | \"ap-southeast-1\" | \"ap-southeast-2\" | \"ap-southeast-3\" | \"ap-southeast-4\" | \"ca-central-1\" | \"cn-northwest-1\" | \"eu-central-1\" | \"eu-central-2\" | \"eu-north-1\" | \"eu-south-1\" | \"eu-south-2\" | \"eu-west-1\" | \"eu-west-2\" | \"eu-west-3\" | \"me-central-1\" | \"me-south-1\" | \"sa-east-1\" | \"us-east-1\" | \"us-east-2\" | \"us-gov-east\" | \"us-gov-west\" | \"us-west-1\" | \"us-west-2\")",
                    value: input.s3Region
                })) && ("string" === typeof input.s3ExternalId && (10 <= input.s3ExternalId.length || $guard(_exceptionable, {
                    path: _path + ".s3ExternalId",
                    expected: "string (@minLength 10)",
                    value: input.s3ExternalId
                })) && ($is_custom("pattern_DatasourceConfigS3DelegatedAccess_s3ExternalId", "string", "", input.s3ExternalId) || $guard(_exceptionable, {
                    path: _path + ".s3ExternalId",
                    expected: "string (@pattern_DatasourceConfigS3DelegatedAccess_s3ExternalId)",
                    value: input.s3ExternalId
                })) || $guard(_exceptionable, {
                    path: _path + ".s3ExternalId",
                    expected: "string",
                    value: input.s3ExternalId
                })) && ("string" === typeof input.s3ARN && (12 <= input.s3ARN.length || $guard(_exceptionable, {
                    path: _path + ".s3ARN",
                    expected: "string (@minLength 12)",
                    value: input.s3ARN
                })) && ($is_custom("pattern_DatasourceConfigS3DelegatedAccess_s3ARN", "string", "", input.s3ARN) || $guard(_exceptionable, {
                    path: _path + ".s3ARN",
                    expected: "string (@pattern_DatasourceConfigS3DelegatedAccess_s3ARN)",
                    value: input.s3ARN
                })) || $guard(_exceptionable, {
                    path: _path + ".s3ARN",
                    expected: "string",
                    value: input.s3ARN
                })) && (undefined === input.s3ServerSideEncryptionKMSKey || "string" === typeof input.s3ServerSideEncryptionKMSKey && (1 <= input.s3ServerSideEncryptionKMSKey.length || $guard(_exceptionable, {
                    path: _path + ".s3ServerSideEncryptionKMSKey",
                    expected: "string (@minLength 1)",
                    value: input.s3ServerSideEncryptionKMSKey
                })) && ($is_custom("pattern_DatasourceConfigS3DelegatedAccess_s3ServerSideEncryptionKMSKey", "string", "", input.s3ServerSideEncryptionKMSKey) || $guard(_exceptionable, {
                    path: _path + ".s3ServerSideEncryptionKMSKey",
                    expected: "string (@pattern_DatasourceConfigS3DelegatedAccess_s3ServerSideEncryptionKMSKey)",
                    value: input.s3ServerSideEncryptionKMSKey
                })) || $guard(_exceptionable, {
                    path: _path + ".s3ServerSideEncryptionKMSKey",
                    expected: "(string | undefined)",
                    value: input.s3ServerSideEncryptionKMSKey
                })) && (undefined === input.id || "string" === typeof input.id && ($is_custom("pattern_DatasourceConfigBase_id", "string", "", input.id) || $guard(_exceptionable, {
                    path: _path + ".id",
                    expected: "string (@pattern_DatasourceConfigBase_id)",
                    value: input.id
                })) || $guard(_exceptionable, {
                    path: _path + ".id",
                    expected: "(string | undefined)",
                    value: input.id
                })) && ("INPUT_OUTPUT" === input.purpose || "INPUT" === input.purpose || "LIGHTLY" === input.purpose || $guard(_exceptionable, {
                    path: _path + ".purpose",
                    expected: "(\"INPUT\" | \"INPUT_OUTPUT\" | \"LIGHTLY\")",
                    value: input.purpose
                })) && (undefined === input.thumbSuffix || "string" === typeof input.thumbSuffix || $guard(_exceptionable, {
                    path: _path + ".thumbSuffix",
                    expected: "(string | undefined)",
                    value: input.thumbSuffix
                })) && (6 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["type", "fullPath", "s3Region", "s3ExternalId", "s3ARN", "s3ServerSideEncryptionKMSKey", "id", "purpose", "thumbSuffix"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                const $au0 = (input: any, _path: string, _exceptionable: boolean = true): any => (() => {
                    if ("DatasourceConfigAzure" === input.type)
                        return $ao1(input, _path, true && _exceptionable);
                    if ("AZURE" === input.type)
                        return $ao0(input, _path, true && _exceptionable);
                    if ("DatasourceConfigGCS" === input.type)
                        return $ao2(input, _path, true && _exceptionable);
                    if ("DatasourceConfigLIGHTLY" === input.type)
                        return $ao3(input, _path, true && _exceptionable);
                    if ("DatasourceConfigLOCAL" === input.type)
                        return $ao4(input, _path, true && _exceptionable);
                    if ("OBS" === input.type)
                        return $ao11(input, _path, true && _exceptionable);
                    if ("DatasourceConfigOBS" === input.type)
                        return $ao5(input, _path, true && _exceptionable);
                    if ("DatasourceConfigS3" === input.type)
                        return $ao6(input, _path, true && _exceptionable);
                    if ("DatasourceConfigS3DelegatedAccess" === input.type)
                        return $ao7(input, _path, true && _exceptionable);
                    if ("GCS" === input.type)
                        return $ao8(input, _path, true && _exceptionable);
                    if ("LIGHTLY" === input.type)
                        return $ao9(input, _path, true && _exceptionable);
                    if ("LOCAL" === input.type)
                        return $ao10(input, _path, true && _exceptionable);
                    if ("S3" === input.type)
                        return $ao12(input, _path, true && _exceptionable);
                    if ("S3DelegatedAccess" === input.type)
                        return $ao13(input, _path, true && _exceptionable);
                    return $guard(_exceptionable, {
                        path: _path,
                        expected: "({ type: \"DatasourceConfigAzure\"; } & DatasourceConfigAzure | { type: \"AZURE\"; } & DatasourceConfigAzure | { type: \"DatasourceConfigGCS\"; } & DatasourceConfigGCS | { type: \"DatasourceConfigLIGHTLY\"; } & DatasourceConfigLIGHTLY | { type: \"DatasourceConfigLOCAL\"; } & DatasourceConfigLOCAL | { type: \"OBS\"; } & DatasourceConfigOBS | { type: \"DatasourceConfigOBS\"; } & DatasourceConfigOBS | { type: \"DatasourceConfigS3\"; } & DatasourceConfigS3 | { type: \"DatasourceConfigS3DelegatedAccess\"; } & DatasourceConfigS3DelegatedAccess | { type: \"GCS\"; } & DatasourceConfigGCS | { type: \"LIGHTLY\"; } & DatasourceConfigLIGHTLY | { type: \"LOCAL\"; } & DatasourceConfigLOCAL | { type: \"S3\"; } & DatasourceConfigS3 | { type: \"S3DelegatedAccess\"; } & DatasourceConfigS3DelegatedAccess)",
                        value: input
                    });
                })();
                return ("object" === typeof input && null !== input || $guard(true, {
                    path: _path + "",
                    expected: "({ type: \"AZURE\"; } & DatasourceConfigAzure | { type: \"DatasourceConfigAzure\"; } & DatasourceConfigAzure | { type: \"DatasourceConfigGCS\"; } & DatasourceConfigGCS | { type: \"DatasourceConfigLIGHTLY\"; } & DatasourceConfigLIGHTLY | { type: \"DatasourceConfigLOCAL\"; } & DatasourceConfigLOCAL | { type: \"DatasourceConfigOBS\"; } & DatasourceConfigOBS | { type: \"DatasourceConfigS3\"; } & DatasourceConfigS3 | { type: \"DatasourceConfigS3DelegatedAccess\"; } & DatasourceConfigS3DelegatedAccess | { type: \"GCS\"; } & DatasourceConfigGCS | { type: \"LIGHTLY\"; } & DatasourceConfigLIGHTLY | { type: \"LOCAL\"; } & DatasourceConfigLOCAL | { type: \"OBS\"; } & DatasourceConfigOBS | { type: \"S3\"; } & DatasourceConfigS3 | { type: \"S3DelegatedAccess\"; } & DatasourceConfigS3DelegatedAccess)",
                    value: input
                })) && $au0(input, _path + "", true) || $guard(true, {
                    path: _path + "",
                    expected: "({ type: \"AZURE\"; } & DatasourceConfigAzure | { type: \"DatasourceConfigAzure\"; } & DatasourceConfigAzure | { type: \"DatasourceConfigGCS\"; } & DatasourceConfigGCS | { type: \"DatasourceConfigLIGHTLY\"; } & DatasourceConfigLIGHTLY | { type: \"DatasourceConfigLOCAL\"; } & DatasourceConfigLOCAL | { type: \"DatasourceConfigOBS\"; } & DatasourceConfigOBS | { type: \"DatasourceConfigS3\"; } & DatasourceConfigS3 | { type: \"DatasourceConfigS3DelegatedAccess\"; } & DatasourceConfigS3DelegatedAccess | { type: \"GCS\"; } & DatasourceConfigGCS | { type: \"LIGHTLY\"; } & DatasourceConfigLIGHTLY | { type: \"LOCAL\"; } & DatasourceConfigLOCAL | { type: \"OBS\"; } & DatasourceConfigOBS | { type: \"S3\"; } & DatasourceConfigS3 | { type: \"S3DelegatedAccess\"; } & DatasourceConfigS3DelegatedAccess)",
                    value: input
                });
            })(input, "$input", true);
        return input;
    })(input);
};
export const UpdateDatasourceByDatasetIdTypiaAssertStringify = (input: UpdateDatasourceByDatasetIdRequestBody): string => {
    return ((input: any): string => { const assert = (input: any): UpdateDatasourceByDatasetIdRequestBody => {
        const __is = (input: any): input is UpdateDatasourceByDatasetIdRequestBody => {
            const $is_custom = (typia.createAssertStringify as any).is_custom;
            const $io0 = (input: any): boolean => "AZURE" === input.type && "string" === typeof input.fullPath && ("string" === typeof input.accountName && 1 <= input.accountName.length) && ("string" === typeof input.accountKey && 1 <= input.accountKey.length) && (undefined === input.id || "string" === typeof input.id && $is_custom("pattern_DatasourceConfigBase_id", "string", "", input.id)) && ("INPUT_OUTPUT" === input.purpose || "INPUT" === input.purpose || "LIGHTLY" === input.purpose) && (undefined === input.thumbSuffix || "string" === typeof input.thumbSuffix);
            const $io1 = (input: any): boolean => "DatasourceConfigAzure" === input.type && "string" === typeof input.fullPath && ("string" === typeof input.accountName && 1 <= input.accountName.length) && ("string" === typeof input.accountKey && 1 <= input.accountKey.length) && (undefined === input.id || "string" === typeof input.id && $is_custom("pattern_DatasourceConfigBase_id", "string", "", input.id)) && ("INPUT_OUTPUT" === input.purpose || "INPUT" === input.purpose || "LIGHTLY" === input.purpose) && (undefined === input.thumbSuffix || "string" === typeof input.thumbSuffix);
            const $io2 = (input: any): boolean => "DatasourceConfigGCS" === input.type && "string" === typeof input.fullPath && ("string" === typeof input.gcsProjectId && 1 <= input.gcsProjectId.length) && "string" === typeof input.gcsCredentials && (undefined === input.id || "string" === typeof input.id && $is_custom("pattern_DatasourceConfigBase_id", "string", "", input.id)) && ("INPUT_OUTPUT" === input.purpose || "INPUT" === input.purpose || "LIGHTLY" === input.purpose) && (undefined === input.thumbSuffix || "string" === typeof input.thumbSuffix);
            const $io3 = (input: any): boolean => "DatasourceConfigLIGHTLY" === input.type && "string" === typeof input.fullPath && (undefined === input.id || "string" === typeof input.id && $is_custom("pattern_DatasourceConfigBase_id", "string", "", input.id)) && ("INPUT_OUTPUT" === input.purpose || "INPUT" === input.purpose || "LIGHTLY" === input.purpose) && (undefined === input.thumbSuffix || "string" === typeof input.thumbSuffix);
            const $io4 = (input: any): boolean => "DatasourceConfigLOCAL" === input.type && "string" === typeof input.fullPath && (undefined === input.webServerLocation || "string" === typeof input.webServerLocation && $is_custom("pattern_DatasourceConfigLOCAL_webServerLocation", "string", "", input.webServerLocation)) && (undefined === input.id || "string" === typeof input.id && $is_custom("pattern_DatasourceConfigBase_id", "string", "", input.id)) && ("INPUT_OUTPUT" === input.purpose || "INPUT" === input.purpose || "LIGHTLY" === input.purpose) && (undefined === input.thumbSuffix || "string" === typeof input.thumbSuffix);
            const $io5 = (input: any): boolean => "DatasourceConfigOBS" === input.type && "string" === typeof input.fullPath && ("string" === typeof input.obsEndpoint && 1 <= input.obsEndpoint.length && $is_custom("pattern_DatasourceConfigOBS_obsEndpoint", "string", "", input.obsEndpoint)) && ("string" === typeof input.obsAccessKeyId && 1 <= input.obsAccessKeyId.length) && ("string" === typeof input.obsSecretAccessKey && 1 <= input.obsSecretAccessKey.length) && (undefined === input.id || "string" === typeof input.id && $is_custom("pattern_DatasourceConfigBase_id", "string", "", input.id)) && ("INPUT_OUTPUT" === input.purpose || "INPUT" === input.purpose || "LIGHTLY" === input.purpose) && (undefined === input.thumbSuffix || "string" === typeof input.thumbSuffix);
            const $io6 = (input: any): boolean => "DatasourceConfigS3" === input.type && "string" === typeof input.fullPath && ("us-east-2" === input.s3Region || "us-east-1" === input.s3Region || "us-west-1" === input.s3Region || "us-west-2" === input.s3Region || "af-south-1" === input.s3Region || "ap-east-1" === input.s3Region || "ap-south-2" === input.s3Region || "ap-southeast-3" === input.s3Region || "ap-southeast-4" === input.s3Region || "ap-south-1" === input.s3Region || "ap-northeast-3" === input.s3Region || "ap-northeast-2" === input.s3Region || "ap-southeast-1" === input.s3Region || "ap-southeast-2" === input.s3Region || "ap-northeast-1" === input.s3Region || "ca-central-1" === input.s3Region || "cn-northwest-1" === input.s3Region || "eu-central-1" === input.s3Region || "eu-west-1" === input.s3Region || "eu-west-2" === input.s3Region || "eu-south-1" === input.s3Region || "eu-west-3" === input.s3Region || "eu-north-1" === input.s3Region || "eu-south-2" === input.s3Region || "eu-central-2" === input.s3Region || "me-south-1" === input.s3Region || "me-central-1" === input.s3Region || "sa-east-1" === input.s3Region || "us-gov-east" === input.s3Region || "us-gov-west" === input.s3Region) && ("string" === typeof input.s3AccessKeyId && 1 <= input.s3AccessKeyId.length) && ("string" === typeof input.s3SecretAccessKey && 1 <= input.s3SecretAccessKey.length) && (undefined === input.s3ServerSideEncryptionKMSKey || "string" === typeof input.s3ServerSideEncryptionKMSKey && 1 <= input.s3ServerSideEncryptionKMSKey.length && $is_custom("pattern_DatasourceConfigS3_s3ServerSideEncryptionKMSKey", "string", "", input.s3ServerSideEncryptionKMSKey)) && (undefined === input.id || "string" === typeof input.id && $is_custom("pattern_DatasourceConfigBase_id", "string", "", input.id)) && ("INPUT_OUTPUT" === input.purpose || "INPUT" === input.purpose || "LIGHTLY" === input.purpose) && (undefined === input.thumbSuffix || "string" === typeof input.thumbSuffix);
            const $io7 = (input: any): boolean => "DatasourceConfigS3DelegatedAccess" === input.type && "string" === typeof input.fullPath && ("us-east-2" === input.s3Region || "us-east-1" === input.s3Region || "us-west-1" === input.s3Region || "us-west-2" === input.s3Region || "af-south-1" === input.s3Region || "ap-east-1" === input.s3Region || "ap-south-2" === input.s3Region || "ap-southeast-3" === input.s3Region || "ap-southeast-4" === input.s3Region || "ap-south-1" === input.s3Region || "ap-northeast-3" === input.s3Region || "ap-northeast-2" === input.s3Region || "ap-southeast-1" === input.s3Region || "ap-southeast-2" === input.s3Region || "ap-northeast-1" === input.s3Region || "ca-central-1" === input.s3Region || "cn-northwest-1" === input.s3Region || "eu-central-1" === input.s3Region || "eu-west-1" === input.s3Region || "eu-west-2" === input.s3Region || "eu-south-1" === input.s3Region || "eu-west-3" === input.s3Region || "eu-north-1" === input.s3Region || "eu-south-2" === input.s3Region || "eu-central-2" === input.s3Region || "me-south-1" === input.s3Region || "me-central-1" === input.s3Region || "sa-east-1" === input.s3Region || "us-gov-east" === input.s3Region || "us-gov-west" === input.s3Region) && ("string" === typeof input.s3ExternalId && 10 <= input.s3ExternalId.length && $is_custom("pattern_DatasourceConfigS3DelegatedAccess_s3ExternalId", "string", "", input.s3ExternalId)) && ("string" === typeof input.s3ARN && 12 <= input.s3ARN.length && $is_custom("pattern_DatasourceConfigS3DelegatedAccess_s3ARN", "string", "", input.s3ARN)) && (undefined === input.s3ServerSideEncryptionKMSKey || "string" === typeof input.s3ServerSideEncryptionKMSKey && 1 <= input.s3ServerSideEncryptionKMSKey.length && $is_custom("pattern_DatasourceConfigS3DelegatedAccess_s3ServerSideEncryptionKMSKey", "string", "", input.s3ServerSideEncryptionKMSKey)) && (undefined === input.id || "string" === typeof input.id && $is_custom("pattern_DatasourceConfigBase_id", "string", "", input.id)) && ("INPUT_OUTPUT" === input.purpose || "INPUT" === input.purpose || "LIGHTLY" === input.purpose) && (undefined === input.thumbSuffix || "string" === typeof input.thumbSuffix);
            const $io8 = (input: any): boolean => "GCS" === input.type && "string" === typeof input.fullPath && ("string" === typeof input.gcsProjectId && 1 <= input.gcsProjectId.length) && "string" === typeof input.gcsCredentials && (undefined === input.id || "string" === typeof input.id && $is_custom("pattern_DatasourceConfigBase_id", "string", "", input.id)) && ("INPUT_OUTPUT" === input.purpose || "INPUT" === input.purpose || "LIGHTLY" === input.purpose) && (undefined === input.thumbSuffix || "string" === typeof input.thumbSuffix);
            const $io9 = (input: any): boolean => "LIGHTLY" === input.type && "string" === typeof input.fullPath && (undefined === input.id || "string" === typeof input.id && $is_custom("pattern_DatasourceConfigBase_id", "string", "", input.id)) && ("INPUT_OUTPUT" === input.purpose || "INPUT" === input.purpose || "LIGHTLY" === input.purpose) && (undefined === input.thumbSuffix || "string" === typeof input.thumbSuffix);
            const $io10 = (input: any): boolean => "LOCAL" === input.type && "string" === typeof input.fullPath && (undefined === input.webServerLocation || "string" === typeof input.webServerLocation && $is_custom("pattern_DatasourceConfigLOCAL_webServerLocation", "string", "", input.webServerLocation)) && (undefined === input.id || "string" === typeof input.id && $is_custom("pattern_DatasourceConfigBase_id", "string", "", input.id)) && ("INPUT_OUTPUT" === input.purpose || "INPUT" === input.purpose || "LIGHTLY" === input.purpose) && (undefined === input.thumbSuffix || "string" === typeof input.thumbSuffix);
            const $io11 = (input: any): boolean => "OBS" === input.type && "string" === typeof input.fullPath && ("string" === typeof input.obsEndpoint && 1 <= input.obsEndpoint.length && $is_custom("pattern_DatasourceConfigOBS_obsEndpoint", "string", "", input.obsEndpoint)) && ("string" === typeof input.obsAccessKeyId && 1 <= input.obsAccessKeyId.length) && ("string" === typeof input.obsSecretAccessKey && 1 <= input.obsSecretAccessKey.length) && (undefined === input.id || "string" === typeof input.id && $is_custom("pattern_DatasourceConfigBase_id", "string", "", input.id)) && ("INPUT_OUTPUT" === input.purpose || "INPUT" === input.purpose || "LIGHTLY" === input.purpose) && (undefined === input.thumbSuffix || "string" === typeof input.thumbSuffix);
            const $io12 = (input: any): boolean => "S3" === input.type && "string" === typeof input.fullPath && ("us-east-2" === input.s3Region || "us-east-1" === input.s3Region || "us-west-1" === input.s3Region || "us-west-2" === input.s3Region || "af-south-1" === input.s3Region || "ap-east-1" === input.s3Region || "ap-south-2" === input.s3Region || "ap-southeast-3" === input.s3Region || "ap-southeast-4" === input.s3Region || "ap-south-1" === input.s3Region || "ap-northeast-3" === input.s3Region || "ap-northeast-2" === input.s3Region || "ap-southeast-1" === input.s3Region || "ap-southeast-2" === input.s3Region || "ap-northeast-1" === input.s3Region || "ca-central-1" === input.s3Region || "cn-northwest-1" === input.s3Region || "eu-central-1" === input.s3Region || "eu-west-1" === input.s3Region || "eu-west-2" === input.s3Region || "eu-south-1" === input.s3Region || "eu-west-3" === input.s3Region || "eu-north-1" === input.s3Region || "eu-south-2" === input.s3Region || "eu-central-2" === input.s3Region || "me-south-1" === input.s3Region || "me-central-1" === input.s3Region || "sa-east-1" === input.s3Region || "us-gov-east" === input.s3Region || "us-gov-west" === input.s3Region) && ("string" === typeof input.s3AccessKeyId && 1 <= input.s3AccessKeyId.length) && ("string" === typeof input.s3SecretAccessKey && 1 <= input.s3SecretAccessKey.length) && (undefined === input.s3ServerSideEncryptionKMSKey || "string" === typeof input.s3ServerSideEncryptionKMSKey && 1 <= input.s3ServerSideEncryptionKMSKey.length && $is_custom("pattern_DatasourceConfigS3_s3ServerSideEncryptionKMSKey", "string", "", input.s3ServerSideEncryptionKMSKey)) && (undefined === input.id || "string" === typeof input.id && $is_custom("pattern_DatasourceConfigBase_id", "string", "", input.id)) && ("INPUT_OUTPUT" === input.purpose || "INPUT" === input.purpose || "LIGHTLY" === input.purpose) && (undefined === input.thumbSuffix || "string" === typeof input.thumbSuffix);
            const $io13 = (input: any): boolean => "S3DelegatedAccess" === input.type && "string" === typeof input.fullPath && ("us-east-2" === input.s3Region || "us-east-1" === input.s3Region || "us-west-1" === input.s3Region || "us-west-2" === input.s3Region || "af-south-1" === input.s3Region || "ap-east-1" === input.s3Region || "ap-south-2" === input.s3Region || "ap-southeast-3" === input.s3Region || "ap-southeast-4" === input.s3Region || "ap-south-1" === input.s3Region || "ap-northeast-3" === input.s3Region || "ap-northeast-2" === input.s3Region || "ap-southeast-1" === input.s3Region || "ap-southeast-2" === input.s3Region || "ap-northeast-1" === input.s3Region || "ca-central-1" === input.s3Region || "cn-northwest-1" === input.s3Region || "eu-central-1" === input.s3Region || "eu-west-1" === input.s3Region || "eu-west-2" === input.s3Region || "eu-south-1" === input.s3Region || "eu-west-3" === input.s3Region || "eu-north-1" === input.s3Region || "eu-south-2" === input.s3Region || "eu-central-2" === input.s3Region || "me-south-1" === input.s3Region || "me-central-1" === input.s3Region || "sa-east-1" === input.s3Region || "us-gov-east" === input.s3Region || "us-gov-west" === input.s3Region) && ("string" === typeof input.s3ExternalId && 10 <= input.s3ExternalId.length && $is_custom("pattern_DatasourceConfigS3DelegatedAccess_s3ExternalId", "string", "", input.s3ExternalId)) && ("string" === typeof input.s3ARN && 12 <= input.s3ARN.length && $is_custom("pattern_DatasourceConfigS3DelegatedAccess_s3ARN", "string", "", input.s3ARN)) && (undefined === input.s3ServerSideEncryptionKMSKey || "string" === typeof input.s3ServerSideEncryptionKMSKey && 1 <= input.s3ServerSideEncryptionKMSKey.length && $is_custom("pattern_DatasourceConfigS3DelegatedAccess_s3ServerSideEncryptionKMSKey", "string", "", input.s3ServerSideEncryptionKMSKey)) && (undefined === input.id || "string" === typeof input.id && $is_custom("pattern_DatasourceConfigBase_id", "string", "", input.id)) && ("INPUT_OUTPUT" === input.purpose || "INPUT" === input.purpose || "LIGHTLY" === input.purpose) && (undefined === input.thumbSuffix || "string" === typeof input.thumbSuffix);
            const $iu0 = (input: any): any => (() => {
                if ("DatasourceConfigAzure" === input.type)
                    return $io1(input);
                if ("AZURE" === input.type)
                    return $io0(input);
                if ("DatasourceConfigGCS" === input.type)
                    return $io2(input);
                if ("DatasourceConfigLIGHTLY" === input.type)
                    return $io3(input);
                if ("DatasourceConfigLOCAL" === input.type)
                    return $io4(input);
                if ("OBS" === input.type)
                    return $io11(input);
                if ("DatasourceConfigOBS" === input.type)
                    return $io5(input);
                if ("DatasourceConfigS3" === input.type)
                    return $io6(input);
                if ("DatasourceConfigS3DelegatedAccess" === input.type)
                    return $io7(input);
                if ("GCS" === input.type)
                    return $io8(input);
                if ("LIGHTLY" === input.type)
                    return $io9(input);
                if ("LOCAL" === input.type)
                    return $io10(input);
                if ("S3" === input.type)
                    return $io12(input);
                if ("S3DelegatedAccess" === input.type)
                    return $io13(input);
                return false;
            })();
            return "object" === typeof input && null !== input && $iu0(input);
        };
        if (false === __is(input))
            ((input: any, _path: string, _exceptionable: boolean = true): input is UpdateDatasourceByDatasetIdRequestBody => {
                const $guard = (typia.createAssertStringify as any).guard;
                const $is_custom = (typia.createAssertStringify as any).is_custom;
                const $ao0 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("AZURE" === input.type || $guard(_exceptionable, {
                    path: _path + ".type",
                    expected: "\"AZURE\"",
                    value: input.type
                })) && ("string" === typeof input.fullPath || $guard(_exceptionable, {
                    path: _path + ".fullPath",
                    expected: "string",
                    value: input.fullPath
                })) && ("string" === typeof input.accountName && (1 <= input.accountName.length || $guard(_exceptionable, {
                    path: _path + ".accountName",
                    expected: "string (@minLength 1)",
                    value: input.accountName
                })) || $guard(_exceptionable, {
                    path: _path + ".accountName",
                    expected: "string",
                    value: input.accountName
                })) && ("string" === typeof input.accountKey && (1 <= input.accountKey.length || $guard(_exceptionable, {
                    path: _path + ".accountKey",
                    expected: "string (@minLength 1)",
                    value: input.accountKey
                })) || $guard(_exceptionable, {
                    path: _path + ".accountKey",
                    expected: "string",
                    value: input.accountKey
                })) && (undefined === input.id || "string" === typeof input.id && ($is_custom("pattern_DatasourceConfigBase_id", "string", "", input.id) || $guard(_exceptionable, {
                    path: _path + ".id",
                    expected: "string (@pattern_DatasourceConfigBase_id)",
                    value: input.id
                })) || $guard(_exceptionable, {
                    path: _path + ".id",
                    expected: "(string | undefined)",
                    value: input.id
                })) && ("INPUT_OUTPUT" === input.purpose || "INPUT" === input.purpose || "LIGHTLY" === input.purpose || $guard(_exceptionable, {
                    path: _path + ".purpose",
                    expected: "(\"INPUT\" | \"INPUT_OUTPUT\" | \"LIGHTLY\")",
                    value: input.purpose
                })) && (undefined === input.thumbSuffix || "string" === typeof input.thumbSuffix || $guard(_exceptionable, {
                    path: _path + ".thumbSuffix",
                    expected: "(string | undefined)",
                    value: input.thumbSuffix
                }));
                const $ao1 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("DatasourceConfigAzure" === input.type || $guard(_exceptionable, {
                    path: _path + ".type",
                    expected: "\"DatasourceConfigAzure\"",
                    value: input.type
                })) && ("string" === typeof input.fullPath || $guard(_exceptionable, {
                    path: _path + ".fullPath",
                    expected: "string",
                    value: input.fullPath
                })) && ("string" === typeof input.accountName && (1 <= input.accountName.length || $guard(_exceptionable, {
                    path: _path + ".accountName",
                    expected: "string (@minLength 1)",
                    value: input.accountName
                })) || $guard(_exceptionable, {
                    path: _path + ".accountName",
                    expected: "string",
                    value: input.accountName
                })) && ("string" === typeof input.accountKey && (1 <= input.accountKey.length || $guard(_exceptionable, {
                    path: _path + ".accountKey",
                    expected: "string (@minLength 1)",
                    value: input.accountKey
                })) || $guard(_exceptionable, {
                    path: _path + ".accountKey",
                    expected: "string",
                    value: input.accountKey
                })) && (undefined === input.id || "string" === typeof input.id && ($is_custom("pattern_DatasourceConfigBase_id", "string", "", input.id) || $guard(_exceptionable, {
                    path: _path + ".id",
                    expected: "string (@pattern_DatasourceConfigBase_id)",
                    value: input.id
                })) || $guard(_exceptionable, {
                    path: _path + ".id",
                    expected: "(string | undefined)",
                    value: input.id
                })) && ("INPUT_OUTPUT" === input.purpose || "INPUT" === input.purpose || "LIGHTLY" === input.purpose || $guard(_exceptionable, {
                    path: _path + ".purpose",
                    expected: "(\"INPUT\" | \"INPUT_OUTPUT\" | \"LIGHTLY\")",
                    value: input.purpose
                })) && (undefined === input.thumbSuffix || "string" === typeof input.thumbSuffix || $guard(_exceptionable, {
                    path: _path + ".thumbSuffix",
                    expected: "(string | undefined)",
                    value: input.thumbSuffix
                }));
                const $ao2 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("DatasourceConfigGCS" === input.type || $guard(_exceptionable, {
                    path: _path + ".type",
                    expected: "\"DatasourceConfigGCS\"",
                    value: input.type
                })) && ("string" === typeof input.fullPath || $guard(_exceptionable, {
                    path: _path + ".fullPath",
                    expected: "string",
                    value: input.fullPath
                })) && ("string" === typeof input.gcsProjectId && (1 <= input.gcsProjectId.length || $guard(_exceptionable, {
                    path: _path + ".gcsProjectId",
                    expected: "string (@minLength 1)",
                    value: input.gcsProjectId
                })) || $guard(_exceptionable, {
                    path: _path + ".gcsProjectId",
                    expected: "string",
                    value: input.gcsProjectId
                })) && ("string" === typeof input.gcsCredentials || $guard(_exceptionable, {
                    path: _path + ".gcsCredentials",
                    expected: "string",
                    value: input.gcsCredentials
                })) && (undefined === input.id || "string" === typeof input.id && ($is_custom("pattern_DatasourceConfigBase_id", "string", "", input.id) || $guard(_exceptionable, {
                    path: _path + ".id",
                    expected: "string (@pattern_DatasourceConfigBase_id)",
                    value: input.id
                })) || $guard(_exceptionable, {
                    path: _path + ".id",
                    expected: "(string | undefined)",
                    value: input.id
                })) && ("INPUT_OUTPUT" === input.purpose || "INPUT" === input.purpose || "LIGHTLY" === input.purpose || $guard(_exceptionable, {
                    path: _path + ".purpose",
                    expected: "(\"INPUT\" | \"INPUT_OUTPUT\" | \"LIGHTLY\")",
                    value: input.purpose
                })) && (undefined === input.thumbSuffix || "string" === typeof input.thumbSuffix || $guard(_exceptionable, {
                    path: _path + ".thumbSuffix",
                    expected: "(string | undefined)",
                    value: input.thumbSuffix
                }));
                const $ao3 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("DatasourceConfigLIGHTLY" === input.type || $guard(_exceptionable, {
                    path: _path + ".type",
                    expected: "\"DatasourceConfigLIGHTLY\"",
                    value: input.type
                })) && ("string" === typeof input.fullPath || $guard(_exceptionable, {
                    path: _path + ".fullPath",
                    expected: "string",
                    value: input.fullPath
                })) && (undefined === input.id || "string" === typeof input.id && ($is_custom("pattern_DatasourceConfigBase_id", "string", "", input.id) || $guard(_exceptionable, {
                    path: _path + ".id",
                    expected: "string (@pattern_DatasourceConfigBase_id)",
                    value: input.id
                })) || $guard(_exceptionable, {
                    path: _path + ".id",
                    expected: "(string | undefined)",
                    value: input.id
                })) && ("INPUT_OUTPUT" === input.purpose || "INPUT" === input.purpose || "LIGHTLY" === input.purpose || $guard(_exceptionable, {
                    path: _path + ".purpose",
                    expected: "(\"INPUT\" | \"INPUT_OUTPUT\" | \"LIGHTLY\")",
                    value: input.purpose
                })) && (undefined === input.thumbSuffix || "string" === typeof input.thumbSuffix || $guard(_exceptionable, {
                    path: _path + ".thumbSuffix",
                    expected: "(string | undefined)",
                    value: input.thumbSuffix
                }));
                const $ao4 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("DatasourceConfigLOCAL" === input.type || $guard(_exceptionable, {
                    path: _path + ".type",
                    expected: "\"DatasourceConfigLOCAL\"",
                    value: input.type
                })) && ("string" === typeof input.fullPath || $guard(_exceptionable, {
                    path: _path + ".fullPath",
                    expected: "string",
                    value: input.fullPath
                })) && (undefined === input.webServerLocation || "string" === typeof input.webServerLocation && ($is_custom("pattern_DatasourceConfigLOCAL_webServerLocation", "string", "", input.webServerLocation) || $guard(_exceptionable, {
                    path: _path + ".webServerLocation",
                    expected: "string (@pattern_DatasourceConfigLOCAL_webServerLocation)",
                    value: input.webServerLocation
                })) || $guard(_exceptionable, {
                    path: _path + ".webServerLocation",
                    expected: "(string | undefined)",
                    value: input.webServerLocation
                })) && (undefined === input.id || "string" === typeof input.id && ($is_custom("pattern_DatasourceConfigBase_id", "string", "", input.id) || $guard(_exceptionable, {
                    path: _path + ".id",
                    expected: "string (@pattern_DatasourceConfigBase_id)",
                    value: input.id
                })) || $guard(_exceptionable, {
                    path: _path + ".id",
                    expected: "(string | undefined)",
                    value: input.id
                })) && ("INPUT_OUTPUT" === input.purpose || "INPUT" === input.purpose || "LIGHTLY" === input.purpose || $guard(_exceptionable, {
                    path: _path + ".purpose",
                    expected: "(\"INPUT\" | \"INPUT_OUTPUT\" | \"LIGHTLY\")",
                    value: input.purpose
                })) && (undefined === input.thumbSuffix || "string" === typeof input.thumbSuffix || $guard(_exceptionable, {
                    path: _path + ".thumbSuffix",
                    expected: "(string | undefined)",
                    value: input.thumbSuffix
                }));
                const $ao5 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("DatasourceConfigOBS" === input.type || $guard(_exceptionable, {
                    path: _path + ".type",
                    expected: "\"DatasourceConfigOBS\"",
                    value: input.type
                })) && ("string" === typeof input.fullPath || $guard(_exceptionable, {
                    path: _path + ".fullPath",
                    expected: "string",
                    value: input.fullPath
                })) && ("string" === typeof input.obsEndpoint && (1 <= input.obsEndpoint.length || $guard(_exceptionable, {
                    path: _path + ".obsEndpoint",
                    expected: "string (@minLength 1)",
                    value: input.obsEndpoint
                })) && ($is_custom("pattern_DatasourceConfigOBS_obsEndpoint", "string", "", input.obsEndpoint) || $guard(_exceptionable, {
                    path: _path + ".obsEndpoint",
                    expected: "string (@pattern_DatasourceConfigOBS_obsEndpoint)",
                    value: input.obsEndpoint
                })) || $guard(_exceptionable, {
                    path: _path + ".obsEndpoint",
                    expected: "string",
                    value: input.obsEndpoint
                })) && ("string" === typeof input.obsAccessKeyId && (1 <= input.obsAccessKeyId.length || $guard(_exceptionable, {
                    path: _path + ".obsAccessKeyId",
                    expected: "string (@minLength 1)",
                    value: input.obsAccessKeyId
                })) || $guard(_exceptionable, {
                    path: _path + ".obsAccessKeyId",
                    expected: "string",
                    value: input.obsAccessKeyId
                })) && ("string" === typeof input.obsSecretAccessKey && (1 <= input.obsSecretAccessKey.length || $guard(_exceptionable, {
                    path: _path + ".obsSecretAccessKey",
                    expected: "string (@minLength 1)",
                    value: input.obsSecretAccessKey
                })) || $guard(_exceptionable, {
                    path: _path + ".obsSecretAccessKey",
                    expected: "string",
                    value: input.obsSecretAccessKey
                })) && (undefined === input.id || "string" === typeof input.id && ($is_custom("pattern_DatasourceConfigBase_id", "string", "", input.id) || $guard(_exceptionable, {
                    path: _path + ".id",
                    expected: "string (@pattern_DatasourceConfigBase_id)",
                    value: input.id
                })) || $guard(_exceptionable, {
                    path: _path + ".id",
                    expected: "(string | undefined)",
                    value: input.id
                })) && ("INPUT_OUTPUT" === input.purpose || "INPUT" === input.purpose || "LIGHTLY" === input.purpose || $guard(_exceptionable, {
                    path: _path + ".purpose",
                    expected: "(\"INPUT\" | \"INPUT_OUTPUT\" | \"LIGHTLY\")",
                    value: input.purpose
                })) && (undefined === input.thumbSuffix || "string" === typeof input.thumbSuffix || $guard(_exceptionable, {
                    path: _path + ".thumbSuffix",
                    expected: "(string | undefined)",
                    value: input.thumbSuffix
                }));
                const $ao6 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("DatasourceConfigS3" === input.type || $guard(_exceptionable, {
                    path: _path + ".type",
                    expected: "\"DatasourceConfigS3\"",
                    value: input.type
                })) && ("string" === typeof input.fullPath || $guard(_exceptionable, {
                    path: _path + ".fullPath",
                    expected: "string",
                    value: input.fullPath
                })) && ("us-east-2" === input.s3Region || "us-east-1" === input.s3Region || "us-west-1" === input.s3Region || "us-west-2" === input.s3Region || "af-south-1" === input.s3Region || "ap-east-1" === input.s3Region || "ap-south-2" === input.s3Region || "ap-southeast-3" === input.s3Region || "ap-southeast-4" === input.s3Region || "ap-south-1" === input.s3Region || "ap-northeast-3" === input.s3Region || "ap-northeast-2" === input.s3Region || "ap-southeast-1" === input.s3Region || "ap-southeast-2" === input.s3Region || "ap-northeast-1" === input.s3Region || "ca-central-1" === input.s3Region || "cn-northwest-1" === input.s3Region || "eu-central-1" === input.s3Region || "eu-west-1" === input.s3Region || "eu-west-2" === input.s3Region || "eu-south-1" === input.s3Region || "eu-west-3" === input.s3Region || "eu-north-1" === input.s3Region || "eu-south-2" === input.s3Region || "eu-central-2" === input.s3Region || "me-south-1" === input.s3Region || "me-central-1" === input.s3Region || "sa-east-1" === input.s3Region || "us-gov-east" === input.s3Region || "us-gov-west" === input.s3Region || $guard(_exceptionable, {
                    path: _path + ".s3Region",
                    expected: "(\"af-south-1\" | \"ap-east-1\" | \"ap-northeast-1\" | \"ap-northeast-2\" | \"ap-northeast-3\" | \"ap-south-1\" | \"ap-south-2\" | \"ap-southeast-1\" | \"ap-southeast-2\" | \"ap-southeast-3\" | \"ap-southeast-4\" | \"ca-central-1\" | \"cn-northwest-1\" | \"eu-central-1\" | \"eu-central-2\" | \"eu-north-1\" | \"eu-south-1\" | \"eu-south-2\" | \"eu-west-1\" | \"eu-west-2\" | \"eu-west-3\" | \"me-central-1\" | \"me-south-1\" | \"sa-east-1\" | \"us-east-1\" | \"us-east-2\" | \"us-gov-east\" | \"us-gov-west\" | \"us-west-1\" | \"us-west-2\")",
                    value: input.s3Region
                })) && ("string" === typeof input.s3AccessKeyId && (1 <= input.s3AccessKeyId.length || $guard(_exceptionable, {
                    path: _path + ".s3AccessKeyId",
                    expected: "string (@minLength 1)",
                    value: input.s3AccessKeyId
                })) || $guard(_exceptionable, {
                    path: _path + ".s3AccessKeyId",
                    expected: "string",
                    value: input.s3AccessKeyId
                })) && ("string" === typeof input.s3SecretAccessKey && (1 <= input.s3SecretAccessKey.length || $guard(_exceptionable, {
                    path: _path + ".s3SecretAccessKey",
                    expected: "string (@minLength 1)",
                    value: input.s3SecretAccessKey
                })) || $guard(_exceptionable, {
                    path: _path + ".s3SecretAccessKey",
                    expected: "string",
                    value: input.s3SecretAccessKey
                })) && (undefined === input.s3ServerSideEncryptionKMSKey || "string" === typeof input.s3ServerSideEncryptionKMSKey && (1 <= input.s3ServerSideEncryptionKMSKey.length || $guard(_exceptionable, {
                    path: _path + ".s3ServerSideEncryptionKMSKey",
                    expected: "string (@minLength 1)",
                    value: input.s3ServerSideEncryptionKMSKey
                })) && ($is_custom("pattern_DatasourceConfigS3_s3ServerSideEncryptionKMSKey", "string", "", input.s3ServerSideEncryptionKMSKey) || $guard(_exceptionable, {
                    path: _path + ".s3ServerSideEncryptionKMSKey",
                    expected: "string (@pattern_DatasourceConfigS3_s3ServerSideEncryptionKMSKey)",
                    value: input.s3ServerSideEncryptionKMSKey
                })) || $guard(_exceptionable, {
                    path: _path + ".s3ServerSideEncryptionKMSKey",
                    expected: "(string | undefined)",
                    value: input.s3ServerSideEncryptionKMSKey
                })) && (undefined === input.id || "string" === typeof input.id && ($is_custom("pattern_DatasourceConfigBase_id", "string", "", input.id) || $guard(_exceptionable, {
                    path: _path + ".id",
                    expected: "string (@pattern_DatasourceConfigBase_id)",
                    value: input.id
                })) || $guard(_exceptionable, {
                    path: _path + ".id",
                    expected: "(string | undefined)",
                    value: input.id
                })) && ("INPUT_OUTPUT" === input.purpose || "INPUT" === input.purpose || "LIGHTLY" === input.purpose || $guard(_exceptionable, {
                    path: _path + ".purpose",
                    expected: "(\"INPUT\" | \"INPUT_OUTPUT\" | \"LIGHTLY\")",
                    value: input.purpose
                })) && (undefined === input.thumbSuffix || "string" === typeof input.thumbSuffix || $guard(_exceptionable, {
                    path: _path + ".thumbSuffix",
                    expected: "(string | undefined)",
                    value: input.thumbSuffix
                }));
                const $ao7 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("DatasourceConfigS3DelegatedAccess" === input.type || $guard(_exceptionable, {
                    path: _path + ".type",
                    expected: "\"DatasourceConfigS3DelegatedAccess\"",
                    value: input.type
                })) && ("string" === typeof input.fullPath || $guard(_exceptionable, {
                    path: _path + ".fullPath",
                    expected: "string",
                    value: input.fullPath
                })) && ("us-east-2" === input.s3Region || "us-east-1" === input.s3Region || "us-west-1" === input.s3Region || "us-west-2" === input.s3Region || "af-south-1" === input.s3Region || "ap-east-1" === input.s3Region || "ap-south-2" === input.s3Region || "ap-southeast-3" === input.s3Region || "ap-southeast-4" === input.s3Region || "ap-south-1" === input.s3Region || "ap-northeast-3" === input.s3Region || "ap-northeast-2" === input.s3Region || "ap-southeast-1" === input.s3Region || "ap-southeast-2" === input.s3Region || "ap-northeast-1" === input.s3Region || "ca-central-1" === input.s3Region || "cn-northwest-1" === input.s3Region || "eu-central-1" === input.s3Region || "eu-west-1" === input.s3Region || "eu-west-2" === input.s3Region || "eu-south-1" === input.s3Region || "eu-west-3" === input.s3Region || "eu-north-1" === input.s3Region || "eu-south-2" === input.s3Region || "eu-central-2" === input.s3Region || "me-south-1" === input.s3Region || "me-central-1" === input.s3Region || "sa-east-1" === input.s3Region || "us-gov-east" === input.s3Region || "us-gov-west" === input.s3Region || $guard(_exceptionable, {
                    path: _path + ".s3Region",
                    expected: "(\"af-south-1\" | \"ap-east-1\" | \"ap-northeast-1\" | \"ap-northeast-2\" | \"ap-northeast-3\" | \"ap-south-1\" | \"ap-south-2\" | \"ap-southeast-1\" | \"ap-southeast-2\" | \"ap-southeast-3\" | \"ap-southeast-4\" | \"ca-central-1\" | \"cn-northwest-1\" | \"eu-central-1\" | \"eu-central-2\" | \"eu-north-1\" | \"eu-south-1\" | \"eu-south-2\" | \"eu-west-1\" | \"eu-west-2\" | \"eu-west-3\" | \"me-central-1\" | \"me-south-1\" | \"sa-east-1\" | \"us-east-1\" | \"us-east-2\" | \"us-gov-east\" | \"us-gov-west\" | \"us-west-1\" | \"us-west-2\")",
                    value: input.s3Region
                })) && ("string" === typeof input.s3ExternalId && (10 <= input.s3ExternalId.length || $guard(_exceptionable, {
                    path: _path + ".s3ExternalId",
                    expected: "string (@minLength 10)",
                    value: input.s3ExternalId
                })) && ($is_custom("pattern_DatasourceConfigS3DelegatedAccess_s3ExternalId", "string", "", input.s3ExternalId) || $guard(_exceptionable, {
                    path: _path + ".s3ExternalId",
                    expected: "string (@pattern_DatasourceConfigS3DelegatedAccess_s3ExternalId)",
                    value: input.s3ExternalId
                })) || $guard(_exceptionable, {
                    path: _path + ".s3ExternalId",
                    expected: "string",
                    value: input.s3ExternalId
                })) && ("string" === typeof input.s3ARN && (12 <= input.s3ARN.length || $guard(_exceptionable, {
                    path: _path + ".s3ARN",
                    expected: "string (@minLength 12)",
                    value: input.s3ARN
                })) && ($is_custom("pattern_DatasourceConfigS3DelegatedAccess_s3ARN", "string", "", input.s3ARN) || $guard(_exceptionable, {
                    path: _path + ".s3ARN",
                    expected: "string (@pattern_DatasourceConfigS3DelegatedAccess_s3ARN)",
                    value: input.s3ARN
                })) || $guard(_exceptionable, {
                    path: _path + ".s3ARN",
                    expected: "string",
                    value: input.s3ARN
                })) && (undefined === input.s3ServerSideEncryptionKMSKey || "string" === typeof input.s3ServerSideEncryptionKMSKey && (1 <= input.s3ServerSideEncryptionKMSKey.length || $guard(_exceptionable, {
                    path: _path + ".s3ServerSideEncryptionKMSKey",
                    expected: "string (@minLength 1)",
                    value: input.s3ServerSideEncryptionKMSKey
                })) && ($is_custom("pattern_DatasourceConfigS3DelegatedAccess_s3ServerSideEncryptionKMSKey", "string", "", input.s3ServerSideEncryptionKMSKey) || $guard(_exceptionable, {
                    path: _path + ".s3ServerSideEncryptionKMSKey",
                    expected: "string (@pattern_DatasourceConfigS3DelegatedAccess_s3ServerSideEncryptionKMSKey)",
                    value: input.s3ServerSideEncryptionKMSKey
                })) || $guard(_exceptionable, {
                    path: _path + ".s3ServerSideEncryptionKMSKey",
                    expected: "(string | undefined)",
                    value: input.s3ServerSideEncryptionKMSKey
                })) && (undefined === input.id || "string" === typeof input.id && ($is_custom("pattern_DatasourceConfigBase_id", "string", "", input.id) || $guard(_exceptionable, {
                    path: _path + ".id",
                    expected: "string (@pattern_DatasourceConfigBase_id)",
                    value: input.id
                })) || $guard(_exceptionable, {
                    path: _path + ".id",
                    expected: "(string | undefined)",
                    value: input.id
                })) && ("INPUT_OUTPUT" === input.purpose || "INPUT" === input.purpose || "LIGHTLY" === input.purpose || $guard(_exceptionable, {
                    path: _path + ".purpose",
                    expected: "(\"INPUT\" | \"INPUT_OUTPUT\" | \"LIGHTLY\")",
                    value: input.purpose
                })) && (undefined === input.thumbSuffix || "string" === typeof input.thumbSuffix || $guard(_exceptionable, {
                    path: _path + ".thumbSuffix",
                    expected: "(string | undefined)",
                    value: input.thumbSuffix
                }));
                const $ao8 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("GCS" === input.type || $guard(_exceptionable, {
                    path: _path + ".type",
                    expected: "\"GCS\"",
                    value: input.type
                })) && ("string" === typeof input.fullPath || $guard(_exceptionable, {
                    path: _path + ".fullPath",
                    expected: "string",
                    value: input.fullPath
                })) && ("string" === typeof input.gcsProjectId && (1 <= input.gcsProjectId.length || $guard(_exceptionable, {
                    path: _path + ".gcsProjectId",
                    expected: "string (@minLength 1)",
                    value: input.gcsProjectId
                })) || $guard(_exceptionable, {
                    path: _path + ".gcsProjectId",
                    expected: "string",
                    value: input.gcsProjectId
                })) && ("string" === typeof input.gcsCredentials || $guard(_exceptionable, {
                    path: _path + ".gcsCredentials",
                    expected: "string",
                    value: input.gcsCredentials
                })) && (undefined === input.id || "string" === typeof input.id && ($is_custom("pattern_DatasourceConfigBase_id", "string", "", input.id) || $guard(_exceptionable, {
                    path: _path + ".id",
                    expected: "string (@pattern_DatasourceConfigBase_id)",
                    value: input.id
                })) || $guard(_exceptionable, {
                    path: _path + ".id",
                    expected: "(string | undefined)",
                    value: input.id
                })) && ("INPUT_OUTPUT" === input.purpose || "INPUT" === input.purpose || "LIGHTLY" === input.purpose || $guard(_exceptionable, {
                    path: _path + ".purpose",
                    expected: "(\"INPUT\" | \"INPUT_OUTPUT\" | \"LIGHTLY\")",
                    value: input.purpose
                })) && (undefined === input.thumbSuffix || "string" === typeof input.thumbSuffix || $guard(_exceptionable, {
                    path: _path + ".thumbSuffix",
                    expected: "(string | undefined)",
                    value: input.thumbSuffix
                }));
                const $ao9 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("LIGHTLY" === input.type || $guard(_exceptionable, {
                    path: _path + ".type",
                    expected: "\"LIGHTLY\"",
                    value: input.type
                })) && ("string" === typeof input.fullPath || $guard(_exceptionable, {
                    path: _path + ".fullPath",
                    expected: "string",
                    value: input.fullPath
                })) && (undefined === input.id || "string" === typeof input.id && ($is_custom("pattern_DatasourceConfigBase_id", "string", "", input.id) || $guard(_exceptionable, {
                    path: _path + ".id",
                    expected: "string (@pattern_DatasourceConfigBase_id)",
                    value: input.id
                })) || $guard(_exceptionable, {
                    path: _path + ".id",
                    expected: "(string | undefined)",
                    value: input.id
                })) && ("INPUT_OUTPUT" === input.purpose || "INPUT" === input.purpose || "LIGHTLY" === input.purpose || $guard(_exceptionable, {
                    path: _path + ".purpose",
                    expected: "(\"INPUT\" | \"INPUT_OUTPUT\" | \"LIGHTLY\")",
                    value: input.purpose
                })) && (undefined === input.thumbSuffix || "string" === typeof input.thumbSuffix || $guard(_exceptionable, {
                    path: _path + ".thumbSuffix",
                    expected: "(string | undefined)",
                    value: input.thumbSuffix
                }));
                const $ao10 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("LOCAL" === input.type || $guard(_exceptionable, {
                    path: _path + ".type",
                    expected: "\"LOCAL\"",
                    value: input.type
                })) && ("string" === typeof input.fullPath || $guard(_exceptionable, {
                    path: _path + ".fullPath",
                    expected: "string",
                    value: input.fullPath
                })) && (undefined === input.webServerLocation || "string" === typeof input.webServerLocation && ($is_custom("pattern_DatasourceConfigLOCAL_webServerLocation", "string", "", input.webServerLocation) || $guard(_exceptionable, {
                    path: _path + ".webServerLocation",
                    expected: "string (@pattern_DatasourceConfigLOCAL_webServerLocation)",
                    value: input.webServerLocation
                })) || $guard(_exceptionable, {
                    path: _path + ".webServerLocation",
                    expected: "(string | undefined)",
                    value: input.webServerLocation
                })) && (undefined === input.id || "string" === typeof input.id && ($is_custom("pattern_DatasourceConfigBase_id", "string", "", input.id) || $guard(_exceptionable, {
                    path: _path + ".id",
                    expected: "string (@pattern_DatasourceConfigBase_id)",
                    value: input.id
                })) || $guard(_exceptionable, {
                    path: _path + ".id",
                    expected: "(string | undefined)",
                    value: input.id
                })) && ("INPUT_OUTPUT" === input.purpose || "INPUT" === input.purpose || "LIGHTLY" === input.purpose || $guard(_exceptionable, {
                    path: _path + ".purpose",
                    expected: "(\"INPUT\" | \"INPUT_OUTPUT\" | \"LIGHTLY\")",
                    value: input.purpose
                })) && (undefined === input.thumbSuffix || "string" === typeof input.thumbSuffix || $guard(_exceptionable, {
                    path: _path + ".thumbSuffix",
                    expected: "(string | undefined)",
                    value: input.thumbSuffix
                }));
                const $ao11 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("OBS" === input.type || $guard(_exceptionable, {
                    path: _path + ".type",
                    expected: "\"OBS\"",
                    value: input.type
                })) && ("string" === typeof input.fullPath || $guard(_exceptionable, {
                    path: _path + ".fullPath",
                    expected: "string",
                    value: input.fullPath
                })) && ("string" === typeof input.obsEndpoint && (1 <= input.obsEndpoint.length || $guard(_exceptionable, {
                    path: _path + ".obsEndpoint",
                    expected: "string (@minLength 1)",
                    value: input.obsEndpoint
                })) && ($is_custom("pattern_DatasourceConfigOBS_obsEndpoint", "string", "", input.obsEndpoint) || $guard(_exceptionable, {
                    path: _path + ".obsEndpoint",
                    expected: "string (@pattern_DatasourceConfigOBS_obsEndpoint)",
                    value: input.obsEndpoint
                })) || $guard(_exceptionable, {
                    path: _path + ".obsEndpoint",
                    expected: "string",
                    value: input.obsEndpoint
                })) && ("string" === typeof input.obsAccessKeyId && (1 <= input.obsAccessKeyId.length || $guard(_exceptionable, {
                    path: _path + ".obsAccessKeyId",
                    expected: "string (@minLength 1)",
                    value: input.obsAccessKeyId
                })) || $guard(_exceptionable, {
                    path: _path + ".obsAccessKeyId",
                    expected: "string",
                    value: input.obsAccessKeyId
                })) && ("string" === typeof input.obsSecretAccessKey && (1 <= input.obsSecretAccessKey.length || $guard(_exceptionable, {
                    path: _path + ".obsSecretAccessKey",
                    expected: "string (@minLength 1)",
                    value: input.obsSecretAccessKey
                })) || $guard(_exceptionable, {
                    path: _path + ".obsSecretAccessKey",
                    expected: "string",
                    value: input.obsSecretAccessKey
                })) && (undefined === input.id || "string" === typeof input.id && ($is_custom("pattern_DatasourceConfigBase_id", "string", "", input.id) || $guard(_exceptionable, {
                    path: _path + ".id",
                    expected: "string (@pattern_DatasourceConfigBase_id)",
                    value: input.id
                })) || $guard(_exceptionable, {
                    path: _path + ".id",
                    expected: "(string | undefined)",
                    value: input.id
                })) && ("INPUT_OUTPUT" === input.purpose || "INPUT" === input.purpose || "LIGHTLY" === input.purpose || $guard(_exceptionable, {
                    path: _path + ".purpose",
                    expected: "(\"INPUT\" | \"INPUT_OUTPUT\" | \"LIGHTLY\")",
                    value: input.purpose
                })) && (undefined === input.thumbSuffix || "string" === typeof input.thumbSuffix || $guard(_exceptionable, {
                    path: _path + ".thumbSuffix",
                    expected: "(string | undefined)",
                    value: input.thumbSuffix
                }));
                const $ao12 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("S3" === input.type || $guard(_exceptionable, {
                    path: _path + ".type",
                    expected: "\"S3\"",
                    value: input.type
                })) && ("string" === typeof input.fullPath || $guard(_exceptionable, {
                    path: _path + ".fullPath",
                    expected: "string",
                    value: input.fullPath
                })) && ("us-east-2" === input.s3Region || "us-east-1" === input.s3Region || "us-west-1" === input.s3Region || "us-west-2" === input.s3Region || "af-south-1" === input.s3Region || "ap-east-1" === input.s3Region || "ap-south-2" === input.s3Region || "ap-southeast-3" === input.s3Region || "ap-southeast-4" === input.s3Region || "ap-south-1" === input.s3Region || "ap-northeast-3" === input.s3Region || "ap-northeast-2" === input.s3Region || "ap-southeast-1" === input.s3Region || "ap-southeast-2" === input.s3Region || "ap-northeast-1" === input.s3Region || "ca-central-1" === input.s3Region || "cn-northwest-1" === input.s3Region || "eu-central-1" === input.s3Region || "eu-west-1" === input.s3Region || "eu-west-2" === input.s3Region || "eu-south-1" === input.s3Region || "eu-west-3" === input.s3Region || "eu-north-1" === input.s3Region || "eu-south-2" === input.s3Region || "eu-central-2" === input.s3Region || "me-south-1" === input.s3Region || "me-central-1" === input.s3Region || "sa-east-1" === input.s3Region || "us-gov-east" === input.s3Region || "us-gov-west" === input.s3Region || $guard(_exceptionable, {
                    path: _path + ".s3Region",
                    expected: "(\"af-south-1\" | \"ap-east-1\" | \"ap-northeast-1\" | \"ap-northeast-2\" | \"ap-northeast-3\" | \"ap-south-1\" | \"ap-south-2\" | \"ap-southeast-1\" | \"ap-southeast-2\" | \"ap-southeast-3\" | \"ap-southeast-4\" | \"ca-central-1\" | \"cn-northwest-1\" | \"eu-central-1\" | \"eu-central-2\" | \"eu-north-1\" | \"eu-south-1\" | \"eu-south-2\" | \"eu-west-1\" | \"eu-west-2\" | \"eu-west-3\" | \"me-central-1\" | \"me-south-1\" | \"sa-east-1\" | \"us-east-1\" | \"us-east-2\" | \"us-gov-east\" | \"us-gov-west\" | \"us-west-1\" | \"us-west-2\")",
                    value: input.s3Region
                })) && ("string" === typeof input.s3AccessKeyId && (1 <= input.s3AccessKeyId.length || $guard(_exceptionable, {
                    path: _path + ".s3AccessKeyId",
                    expected: "string (@minLength 1)",
                    value: input.s3AccessKeyId
                })) || $guard(_exceptionable, {
                    path: _path + ".s3AccessKeyId",
                    expected: "string",
                    value: input.s3AccessKeyId
                })) && ("string" === typeof input.s3SecretAccessKey && (1 <= input.s3SecretAccessKey.length || $guard(_exceptionable, {
                    path: _path + ".s3SecretAccessKey",
                    expected: "string (@minLength 1)",
                    value: input.s3SecretAccessKey
                })) || $guard(_exceptionable, {
                    path: _path + ".s3SecretAccessKey",
                    expected: "string",
                    value: input.s3SecretAccessKey
                })) && (undefined === input.s3ServerSideEncryptionKMSKey || "string" === typeof input.s3ServerSideEncryptionKMSKey && (1 <= input.s3ServerSideEncryptionKMSKey.length || $guard(_exceptionable, {
                    path: _path + ".s3ServerSideEncryptionKMSKey",
                    expected: "string (@minLength 1)",
                    value: input.s3ServerSideEncryptionKMSKey
                })) && ($is_custom("pattern_DatasourceConfigS3_s3ServerSideEncryptionKMSKey", "string", "", input.s3ServerSideEncryptionKMSKey) || $guard(_exceptionable, {
                    path: _path + ".s3ServerSideEncryptionKMSKey",
                    expected: "string (@pattern_DatasourceConfigS3_s3ServerSideEncryptionKMSKey)",
                    value: input.s3ServerSideEncryptionKMSKey
                })) || $guard(_exceptionable, {
                    path: _path + ".s3ServerSideEncryptionKMSKey",
                    expected: "(string | undefined)",
                    value: input.s3ServerSideEncryptionKMSKey
                })) && (undefined === input.id || "string" === typeof input.id && ($is_custom("pattern_DatasourceConfigBase_id", "string", "", input.id) || $guard(_exceptionable, {
                    path: _path + ".id",
                    expected: "string (@pattern_DatasourceConfigBase_id)",
                    value: input.id
                })) || $guard(_exceptionable, {
                    path: _path + ".id",
                    expected: "(string | undefined)",
                    value: input.id
                })) && ("INPUT_OUTPUT" === input.purpose || "INPUT" === input.purpose || "LIGHTLY" === input.purpose || $guard(_exceptionable, {
                    path: _path + ".purpose",
                    expected: "(\"INPUT\" | \"INPUT_OUTPUT\" | \"LIGHTLY\")",
                    value: input.purpose
                })) && (undefined === input.thumbSuffix || "string" === typeof input.thumbSuffix || $guard(_exceptionable, {
                    path: _path + ".thumbSuffix",
                    expected: "(string | undefined)",
                    value: input.thumbSuffix
                }));
                const $ao13 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("S3DelegatedAccess" === input.type || $guard(_exceptionable, {
                    path: _path + ".type",
                    expected: "\"S3DelegatedAccess\"",
                    value: input.type
                })) && ("string" === typeof input.fullPath || $guard(_exceptionable, {
                    path: _path + ".fullPath",
                    expected: "string",
                    value: input.fullPath
                })) && ("us-east-2" === input.s3Region || "us-east-1" === input.s3Region || "us-west-1" === input.s3Region || "us-west-2" === input.s3Region || "af-south-1" === input.s3Region || "ap-east-1" === input.s3Region || "ap-south-2" === input.s3Region || "ap-southeast-3" === input.s3Region || "ap-southeast-4" === input.s3Region || "ap-south-1" === input.s3Region || "ap-northeast-3" === input.s3Region || "ap-northeast-2" === input.s3Region || "ap-southeast-1" === input.s3Region || "ap-southeast-2" === input.s3Region || "ap-northeast-1" === input.s3Region || "ca-central-1" === input.s3Region || "cn-northwest-1" === input.s3Region || "eu-central-1" === input.s3Region || "eu-west-1" === input.s3Region || "eu-west-2" === input.s3Region || "eu-south-1" === input.s3Region || "eu-west-3" === input.s3Region || "eu-north-1" === input.s3Region || "eu-south-2" === input.s3Region || "eu-central-2" === input.s3Region || "me-south-1" === input.s3Region || "me-central-1" === input.s3Region || "sa-east-1" === input.s3Region || "us-gov-east" === input.s3Region || "us-gov-west" === input.s3Region || $guard(_exceptionable, {
                    path: _path + ".s3Region",
                    expected: "(\"af-south-1\" | \"ap-east-1\" | \"ap-northeast-1\" | \"ap-northeast-2\" | \"ap-northeast-3\" | \"ap-south-1\" | \"ap-south-2\" | \"ap-southeast-1\" | \"ap-southeast-2\" | \"ap-southeast-3\" | \"ap-southeast-4\" | \"ca-central-1\" | \"cn-northwest-1\" | \"eu-central-1\" | \"eu-central-2\" | \"eu-north-1\" | \"eu-south-1\" | \"eu-south-2\" | \"eu-west-1\" | \"eu-west-2\" | \"eu-west-3\" | \"me-central-1\" | \"me-south-1\" | \"sa-east-1\" | \"us-east-1\" | \"us-east-2\" | \"us-gov-east\" | \"us-gov-west\" | \"us-west-1\" | \"us-west-2\")",
                    value: input.s3Region
                })) && ("string" === typeof input.s3ExternalId && (10 <= input.s3ExternalId.length || $guard(_exceptionable, {
                    path: _path + ".s3ExternalId",
                    expected: "string (@minLength 10)",
                    value: input.s3ExternalId
                })) && ($is_custom("pattern_DatasourceConfigS3DelegatedAccess_s3ExternalId", "string", "", input.s3ExternalId) || $guard(_exceptionable, {
                    path: _path + ".s3ExternalId",
                    expected: "string (@pattern_DatasourceConfigS3DelegatedAccess_s3ExternalId)",
                    value: input.s3ExternalId
                })) || $guard(_exceptionable, {
                    path: _path + ".s3ExternalId",
                    expected: "string",
                    value: input.s3ExternalId
                })) && ("string" === typeof input.s3ARN && (12 <= input.s3ARN.length || $guard(_exceptionable, {
                    path: _path + ".s3ARN",
                    expected: "string (@minLength 12)",
                    value: input.s3ARN
                })) && ($is_custom("pattern_DatasourceConfigS3DelegatedAccess_s3ARN", "string", "", input.s3ARN) || $guard(_exceptionable, {
                    path: _path + ".s3ARN",
                    expected: "string (@pattern_DatasourceConfigS3DelegatedAccess_s3ARN)",
                    value: input.s3ARN
                })) || $guard(_exceptionable, {
                    path: _path + ".s3ARN",
                    expected: "string",
                    value: input.s3ARN
                })) && (undefined === input.s3ServerSideEncryptionKMSKey || "string" === typeof input.s3ServerSideEncryptionKMSKey && (1 <= input.s3ServerSideEncryptionKMSKey.length || $guard(_exceptionable, {
                    path: _path + ".s3ServerSideEncryptionKMSKey",
                    expected: "string (@minLength 1)",
                    value: input.s3ServerSideEncryptionKMSKey
                })) && ($is_custom("pattern_DatasourceConfigS3DelegatedAccess_s3ServerSideEncryptionKMSKey", "string", "", input.s3ServerSideEncryptionKMSKey) || $guard(_exceptionable, {
                    path: _path + ".s3ServerSideEncryptionKMSKey",
                    expected: "string (@pattern_DatasourceConfigS3DelegatedAccess_s3ServerSideEncryptionKMSKey)",
                    value: input.s3ServerSideEncryptionKMSKey
                })) || $guard(_exceptionable, {
                    path: _path + ".s3ServerSideEncryptionKMSKey",
                    expected: "(string | undefined)",
                    value: input.s3ServerSideEncryptionKMSKey
                })) && (undefined === input.id || "string" === typeof input.id && ($is_custom("pattern_DatasourceConfigBase_id", "string", "", input.id) || $guard(_exceptionable, {
                    path: _path + ".id",
                    expected: "string (@pattern_DatasourceConfigBase_id)",
                    value: input.id
                })) || $guard(_exceptionable, {
                    path: _path + ".id",
                    expected: "(string | undefined)",
                    value: input.id
                })) && ("INPUT_OUTPUT" === input.purpose || "INPUT" === input.purpose || "LIGHTLY" === input.purpose || $guard(_exceptionable, {
                    path: _path + ".purpose",
                    expected: "(\"INPUT\" | \"INPUT_OUTPUT\" | \"LIGHTLY\")",
                    value: input.purpose
                })) && (undefined === input.thumbSuffix || "string" === typeof input.thumbSuffix || $guard(_exceptionable, {
                    path: _path + ".thumbSuffix",
                    expected: "(string | undefined)",
                    value: input.thumbSuffix
                }));
                const $au0 = (input: any, _path: string, _exceptionable: boolean = true): any => (() => {
                    if ("DatasourceConfigAzure" === input.type)
                        return $ao1(input, _path, true && _exceptionable);
                    if ("AZURE" === input.type)
                        return $ao0(input, _path, true && _exceptionable);
                    if ("DatasourceConfigGCS" === input.type)
                        return $ao2(input, _path, true && _exceptionable);
                    if ("DatasourceConfigLIGHTLY" === input.type)
                        return $ao3(input, _path, true && _exceptionable);
                    if ("DatasourceConfigLOCAL" === input.type)
                        return $ao4(input, _path, true && _exceptionable);
                    if ("OBS" === input.type)
                        return $ao11(input, _path, true && _exceptionable);
                    if ("DatasourceConfigOBS" === input.type)
                        return $ao5(input, _path, true && _exceptionable);
                    if ("DatasourceConfigS3" === input.type)
                        return $ao6(input, _path, true && _exceptionable);
                    if ("DatasourceConfigS3DelegatedAccess" === input.type)
                        return $ao7(input, _path, true && _exceptionable);
                    if ("GCS" === input.type)
                        return $ao8(input, _path, true && _exceptionable);
                    if ("LIGHTLY" === input.type)
                        return $ao9(input, _path, true && _exceptionable);
                    if ("LOCAL" === input.type)
                        return $ao10(input, _path, true && _exceptionable);
                    if ("S3" === input.type)
                        return $ao12(input, _path, true && _exceptionable);
                    if ("S3DelegatedAccess" === input.type)
                        return $ao13(input, _path, true && _exceptionable);
                    return $guard(_exceptionable, {
                        path: _path,
                        expected: "({ type: \"DatasourceConfigAzure\"; } & DatasourceConfigAzure | { type: \"AZURE\"; } & DatasourceConfigAzure | { type: \"DatasourceConfigGCS\"; } & DatasourceConfigGCS | { type: \"DatasourceConfigLIGHTLY\"; } & DatasourceConfigLIGHTLY | { type: \"DatasourceConfigLOCAL\"; } & DatasourceConfigLOCAL | { type: \"OBS\"; } & DatasourceConfigOBS | { type: \"DatasourceConfigOBS\"; } & DatasourceConfigOBS | { type: \"DatasourceConfigS3\"; } & DatasourceConfigS3 | { type: \"DatasourceConfigS3DelegatedAccess\"; } & DatasourceConfigS3DelegatedAccess | { type: \"GCS\"; } & DatasourceConfigGCS | { type: \"LIGHTLY\"; } & DatasourceConfigLIGHTLY | { type: \"LOCAL\"; } & DatasourceConfigLOCAL | { type: \"S3\"; } & DatasourceConfigS3 | { type: \"S3DelegatedAccess\"; } & DatasourceConfigS3DelegatedAccess)",
                        value: input
                    });
                })();
                return ("object" === typeof input && null !== input || $guard(true, {
                    path: _path + "",
                    expected: "({ type: \"AZURE\"; } & DatasourceConfigAzure | { type: \"DatasourceConfigAzure\"; } & DatasourceConfigAzure | { type: \"DatasourceConfigGCS\"; } & DatasourceConfigGCS | { type: \"DatasourceConfigLIGHTLY\"; } & DatasourceConfigLIGHTLY | { type: \"DatasourceConfigLOCAL\"; } & DatasourceConfigLOCAL | { type: \"DatasourceConfigOBS\"; } & DatasourceConfigOBS | { type: \"DatasourceConfigS3\"; } & DatasourceConfigS3 | { type: \"DatasourceConfigS3DelegatedAccess\"; } & DatasourceConfigS3DelegatedAccess | { type: \"GCS\"; } & DatasourceConfigGCS | { type: \"LIGHTLY\"; } & DatasourceConfigLIGHTLY | { type: \"LOCAL\"; } & DatasourceConfigLOCAL | { type: \"OBS\"; } & DatasourceConfigOBS | { type: \"S3\"; } & DatasourceConfigS3 | { type: \"S3DelegatedAccess\"; } & DatasourceConfigS3DelegatedAccess)",
                    value: input
                })) && $au0(input, _path + "", true) || $guard(true, {
                    path: _path + "",
                    expected: "({ type: \"AZURE\"; } & DatasourceConfigAzure | { type: \"DatasourceConfigAzure\"; } & DatasourceConfigAzure | { type: \"DatasourceConfigGCS\"; } & DatasourceConfigGCS | { type: \"DatasourceConfigLIGHTLY\"; } & DatasourceConfigLIGHTLY | { type: \"DatasourceConfigLOCAL\"; } & DatasourceConfigLOCAL | { type: \"DatasourceConfigOBS\"; } & DatasourceConfigOBS | { type: \"DatasourceConfigS3\"; } & DatasourceConfigS3 | { type: \"DatasourceConfigS3DelegatedAccess\"; } & DatasourceConfigS3DelegatedAccess | { type: \"GCS\"; } & DatasourceConfigGCS | { type: \"LIGHTLY\"; } & DatasourceConfigLIGHTLY | { type: \"LOCAL\"; } & DatasourceConfigLOCAL | { type: \"OBS\"; } & DatasourceConfigOBS | { type: \"S3\"; } & DatasourceConfigS3 | { type: \"S3DelegatedAccess\"; } & DatasourceConfigS3DelegatedAccess)",
                    value: input
                });
            })(input, "$input", true);
        return input;
    }; const stringify = (input: UpdateDatasourceByDatasetIdRequestBody): string => {
        const $io0 = (input: any): boolean => "AZURE" === input.type && "string" === typeof input.fullPath && ("string" === typeof input.accountName && 1 <= input.accountName.length) && ("string" === typeof input.accountKey && 1 <= input.accountKey.length) && (undefined === input.id || "string" === typeof input.id && $is_custom("pattern_DatasourceConfigBase_id", "string", "", input.id)) && ("INPUT_OUTPUT" === input.purpose || "INPUT" === input.purpose || "LIGHTLY" === input.purpose) && (undefined === input.thumbSuffix || "string" === typeof input.thumbSuffix);
        const $io1 = (input: any): boolean => "DatasourceConfigAzure" === input.type && "string" === typeof input.fullPath && ("string" === typeof input.accountName && 1 <= input.accountName.length) && ("string" === typeof input.accountKey && 1 <= input.accountKey.length) && (undefined === input.id || "string" === typeof input.id && $is_custom("pattern_DatasourceConfigBase_id", "string", "", input.id)) && ("INPUT_OUTPUT" === input.purpose || "INPUT" === input.purpose || "LIGHTLY" === input.purpose) && (undefined === input.thumbSuffix || "string" === typeof input.thumbSuffix);
        const $io2 = (input: any): boolean => "DatasourceConfigGCS" === input.type && "string" === typeof input.fullPath && ("string" === typeof input.gcsProjectId && 1 <= input.gcsProjectId.length) && "string" === typeof input.gcsCredentials && (undefined === input.id || "string" === typeof input.id && $is_custom("pattern_DatasourceConfigBase_id", "string", "", input.id)) && ("INPUT_OUTPUT" === input.purpose || "INPUT" === input.purpose || "LIGHTLY" === input.purpose) && (undefined === input.thumbSuffix || "string" === typeof input.thumbSuffix);
        const $io3 = (input: any): boolean => "DatasourceConfigLIGHTLY" === input.type && "string" === typeof input.fullPath && (undefined === input.id || "string" === typeof input.id && $is_custom("pattern_DatasourceConfigBase_id", "string", "", input.id)) && ("INPUT_OUTPUT" === input.purpose || "INPUT" === input.purpose || "LIGHTLY" === input.purpose) && (undefined === input.thumbSuffix || "string" === typeof input.thumbSuffix);
        const $io4 = (input: any): boolean => "DatasourceConfigLOCAL" === input.type && "string" === typeof input.fullPath && (undefined === input.webServerLocation || "string" === typeof input.webServerLocation && $is_custom("pattern_DatasourceConfigLOCAL_webServerLocation", "string", "", input.webServerLocation)) && (undefined === input.id || "string" === typeof input.id && $is_custom("pattern_DatasourceConfigBase_id", "string", "", input.id)) && ("INPUT_OUTPUT" === input.purpose || "INPUT" === input.purpose || "LIGHTLY" === input.purpose) && (undefined === input.thumbSuffix || "string" === typeof input.thumbSuffix);
        const $io5 = (input: any): boolean => "DatasourceConfigOBS" === input.type && "string" === typeof input.fullPath && ("string" === typeof input.obsEndpoint && 1 <= input.obsEndpoint.length && $is_custom("pattern_DatasourceConfigOBS_obsEndpoint", "string", "", input.obsEndpoint)) && ("string" === typeof input.obsAccessKeyId && 1 <= input.obsAccessKeyId.length) && ("string" === typeof input.obsSecretAccessKey && 1 <= input.obsSecretAccessKey.length) && (undefined === input.id || "string" === typeof input.id && $is_custom("pattern_DatasourceConfigBase_id", "string", "", input.id)) && ("INPUT_OUTPUT" === input.purpose || "INPUT" === input.purpose || "LIGHTLY" === input.purpose) && (undefined === input.thumbSuffix || "string" === typeof input.thumbSuffix);
        const $io6 = (input: any): boolean => "DatasourceConfigS3" === input.type && "string" === typeof input.fullPath && ("us-east-2" === input.s3Region || "us-east-1" === input.s3Region || "us-west-1" === input.s3Region || "us-west-2" === input.s3Region || "af-south-1" === input.s3Region || "ap-east-1" === input.s3Region || "ap-south-2" === input.s3Region || "ap-southeast-3" === input.s3Region || "ap-southeast-4" === input.s3Region || "ap-south-1" === input.s3Region || "ap-northeast-3" === input.s3Region || "ap-northeast-2" === input.s3Region || "ap-southeast-1" === input.s3Region || "ap-southeast-2" === input.s3Region || "ap-northeast-1" === input.s3Region || "ca-central-1" === input.s3Region || "cn-northwest-1" === input.s3Region || "eu-central-1" === input.s3Region || "eu-west-1" === input.s3Region || "eu-west-2" === input.s3Region || "eu-south-1" === input.s3Region || "eu-west-3" === input.s3Region || "eu-north-1" === input.s3Region || "eu-south-2" === input.s3Region || "eu-central-2" === input.s3Region || "me-south-1" === input.s3Region || "me-central-1" === input.s3Region || "sa-east-1" === input.s3Region || "us-gov-east" === input.s3Region || "us-gov-west" === input.s3Region) && ("string" === typeof input.s3AccessKeyId && 1 <= input.s3AccessKeyId.length) && ("string" === typeof input.s3SecretAccessKey && 1 <= input.s3SecretAccessKey.length) && (undefined === input.s3ServerSideEncryptionKMSKey || "string" === typeof input.s3ServerSideEncryptionKMSKey && 1 <= input.s3ServerSideEncryptionKMSKey.length && $is_custom("pattern_DatasourceConfigS3_s3ServerSideEncryptionKMSKey", "string", "", input.s3ServerSideEncryptionKMSKey)) && (undefined === input.id || "string" === typeof input.id && $is_custom("pattern_DatasourceConfigBase_id", "string", "", input.id)) && ("INPUT_OUTPUT" === input.purpose || "INPUT" === input.purpose || "LIGHTLY" === input.purpose) && (undefined === input.thumbSuffix || "string" === typeof input.thumbSuffix);
        const $io7 = (input: any): boolean => "DatasourceConfigS3DelegatedAccess" === input.type && "string" === typeof input.fullPath && ("us-east-2" === input.s3Region || "us-east-1" === input.s3Region || "us-west-1" === input.s3Region || "us-west-2" === input.s3Region || "af-south-1" === input.s3Region || "ap-east-1" === input.s3Region || "ap-south-2" === input.s3Region || "ap-southeast-3" === input.s3Region || "ap-southeast-4" === input.s3Region || "ap-south-1" === input.s3Region || "ap-northeast-3" === input.s3Region || "ap-northeast-2" === input.s3Region || "ap-southeast-1" === input.s3Region || "ap-southeast-2" === input.s3Region || "ap-northeast-1" === input.s3Region || "ca-central-1" === input.s3Region || "cn-northwest-1" === input.s3Region || "eu-central-1" === input.s3Region || "eu-west-1" === input.s3Region || "eu-west-2" === input.s3Region || "eu-south-1" === input.s3Region || "eu-west-3" === input.s3Region || "eu-north-1" === input.s3Region || "eu-south-2" === input.s3Region || "eu-central-2" === input.s3Region || "me-south-1" === input.s3Region || "me-central-1" === input.s3Region || "sa-east-1" === input.s3Region || "us-gov-east" === input.s3Region || "us-gov-west" === input.s3Region) && ("string" === typeof input.s3ExternalId && 10 <= input.s3ExternalId.length && $is_custom("pattern_DatasourceConfigS3DelegatedAccess_s3ExternalId", "string", "", input.s3ExternalId)) && ("string" === typeof input.s3ARN && 12 <= input.s3ARN.length && $is_custom("pattern_DatasourceConfigS3DelegatedAccess_s3ARN", "string", "", input.s3ARN)) && (undefined === input.s3ServerSideEncryptionKMSKey || "string" === typeof input.s3ServerSideEncryptionKMSKey && 1 <= input.s3ServerSideEncryptionKMSKey.length && $is_custom("pattern_DatasourceConfigS3DelegatedAccess_s3ServerSideEncryptionKMSKey", "string", "", input.s3ServerSideEncryptionKMSKey)) && (undefined === input.id || "string" === typeof input.id && $is_custom("pattern_DatasourceConfigBase_id", "string", "", input.id)) && ("INPUT_OUTPUT" === input.purpose || "INPUT" === input.purpose || "LIGHTLY" === input.purpose) && (undefined === input.thumbSuffix || "string" === typeof input.thumbSuffix);
        const $io8 = (input: any): boolean => "GCS" === input.type && "string" === typeof input.fullPath && ("string" === typeof input.gcsProjectId && 1 <= input.gcsProjectId.length) && "string" === typeof input.gcsCredentials && (undefined === input.id || "string" === typeof input.id && $is_custom("pattern_DatasourceConfigBase_id", "string", "", input.id)) && ("INPUT_OUTPUT" === input.purpose || "INPUT" === input.purpose || "LIGHTLY" === input.purpose) && (undefined === input.thumbSuffix || "string" === typeof input.thumbSuffix);
        const $io9 = (input: any): boolean => "LIGHTLY" === input.type && "string" === typeof input.fullPath && (undefined === input.id || "string" === typeof input.id && $is_custom("pattern_DatasourceConfigBase_id", "string", "", input.id)) && ("INPUT_OUTPUT" === input.purpose || "INPUT" === input.purpose || "LIGHTLY" === input.purpose) && (undefined === input.thumbSuffix || "string" === typeof input.thumbSuffix);
        const $io10 = (input: any): boolean => "LOCAL" === input.type && "string" === typeof input.fullPath && (undefined === input.webServerLocation || "string" === typeof input.webServerLocation && $is_custom("pattern_DatasourceConfigLOCAL_webServerLocation", "string", "", input.webServerLocation)) && (undefined === input.id || "string" === typeof input.id && $is_custom("pattern_DatasourceConfigBase_id", "string", "", input.id)) && ("INPUT_OUTPUT" === input.purpose || "INPUT" === input.purpose || "LIGHTLY" === input.purpose) && (undefined === input.thumbSuffix || "string" === typeof input.thumbSuffix);
        const $io11 = (input: any): boolean => "OBS" === input.type && "string" === typeof input.fullPath && ("string" === typeof input.obsEndpoint && 1 <= input.obsEndpoint.length && $is_custom("pattern_DatasourceConfigOBS_obsEndpoint", "string", "", input.obsEndpoint)) && ("string" === typeof input.obsAccessKeyId && 1 <= input.obsAccessKeyId.length) && ("string" === typeof input.obsSecretAccessKey && 1 <= input.obsSecretAccessKey.length) && (undefined === input.id || "string" === typeof input.id && $is_custom("pattern_DatasourceConfigBase_id", "string", "", input.id)) && ("INPUT_OUTPUT" === input.purpose || "INPUT" === input.purpose || "LIGHTLY" === input.purpose) && (undefined === input.thumbSuffix || "string" === typeof input.thumbSuffix);
        const $io12 = (input: any): boolean => "S3" === input.type && "string" === typeof input.fullPath && ("us-east-2" === input.s3Region || "us-east-1" === input.s3Region || "us-west-1" === input.s3Region || "us-west-2" === input.s3Region || "af-south-1" === input.s3Region || "ap-east-1" === input.s3Region || "ap-south-2" === input.s3Region || "ap-southeast-3" === input.s3Region || "ap-southeast-4" === input.s3Region || "ap-south-1" === input.s3Region || "ap-northeast-3" === input.s3Region || "ap-northeast-2" === input.s3Region || "ap-southeast-1" === input.s3Region || "ap-southeast-2" === input.s3Region || "ap-northeast-1" === input.s3Region || "ca-central-1" === input.s3Region || "cn-northwest-1" === input.s3Region || "eu-central-1" === input.s3Region || "eu-west-1" === input.s3Region || "eu-west-2" === input.s3Region || "eu-south-1" === input.s3Region || "eu-west-3" === input.s3Region || "eu-north-1" === input.s3Region || "eu-south-2" === input.s3Region || "eu-central-2" === input.s3Region || "me-south-1" === input.s3Region || "me-central-1" === input.s3Region || "sa-east-1" === input.s3Region || "us-gov-east" === input.s3Region || "us-gov-west" === input.s3Region) && ("string" === typeof input.s3AccessKeyId && 1 <= input.s3AccessKeyId.length) && ("string" === typeof input.s3SecretAccessKey && 1 <= input.s3SecretAccessKey.length) && (undefined === input.s3ServerSideEncryptionKMSKey || "string" === typeof input.s3ServerSideEncryptionKMSKey && 1 <= input.s3ServerSideEncryptionKMSKey.length && $is_custom("pattern_DatasourceConfigS3_s3ServerSideEncryptionKMSKey", "string", "", input.s3ServerSideEncryptionKMSKey)) && (undefined === input.id || "string" === typeof input.id && $is_custom("pattern_DatasourceConfigBase_id", "string", "", input.id)) && ("INPUT_OUTPUT" === input.purpose || "INPUT" === input.purpose || "LIGHTLY" === input.purpose) && (undefined === input.thumbSuffix || "string" === typeof input.thumbSuffix);
        const $io13 = (input: any): boolean => "S3DelegatedAccess" === input.type && "string" === typeof input.fullPath && ("us-east-2" === input.s3Region || "us-east-1" === input.s3Region || "us-west-1" === input.s3Region || "us-west-2" === input.s3Region || "af-south-1" === input.s3Region || "ap-east-1" === input.s3Region || "ap-south-2" === input.s3Region || "ap-southeast-3" === input.s3Region || "ap-southeast-4" === input.s3Region || "ap-south-1" === input.s3Region || "ap-northeast-3" === input.s3Region || "ap-northeast-2" === input.s3Region || "ap-southeast-1" === input.s3Region || "ap-southeast-2" === input.s3Region || "ap-northeast-1" === input.s3Region || "ca-central-1" === input.s3Region || "cn-northwest-1" === input.s3Region || "eu-central-1" === input.s3Region || "eu-west-1" === input.s3Region || "eu-west-2" === input.s3Region || "eu-south-1" === input.s3Region || "eu-west-3" === input.s3Region || "eu-north-1" === input.s3Region || "eu-south-2" === input.s3Region || "eu-central-2" === input.s3Region || "me-south-1" === input.s3Region || "me-central-1" === input.s3Region || "sa-east-1" === input.s3Region || "us-gov-east" === input.s3Region || "us-gov-west" === input.s3Region) && ("string" === typeof input.s3ExternalId && 10 <= input.s3ExternalId.length && $is_custom("pattern_DatasourceConfigS3DelegatedAccess_s3ExternalId", "string", "", input.s3ExternalId)) && ("string" === typeof input.s3ARN && 12 <= input.s3ARN.length && $is_custom("pattern_DatasourceConfigS3DelegatedAccess_s3ARN", "string", "", input.s3ARN)) && (undefined === input.s3ServerSideEncryptionKMSKey || "string" === typeof input.s3ServerSideEncryptionKMSKey && 1 <= input.s3ServerSideEncryptionKMSKey.length && $is_custom("pattern_DatasourceConfigS3DelegatedAccess_s3ServerSideEncryptionKMSKey", "string", "", input.s3ServerSideEncryptionKMSKey)) && (undefined === input.id || "string" === typeof input.id && $is_custom("pattern_DatasourceConfigBase_id", "string", "", input.id)) && ("INPUT_OUTPUT" === input.purpose || "INPUT" === input.purpose || "LIGHTLY" === input.purpose) && (undefined === input.thumbSuffix || "string" === typeof input.thumbSuffix);
        const $string = (typia.createAssertStringify as any).string;
        const $throws = (typia.createAssertStringify as any).throws;
        const $is_custom = (typia.createAssertStringify as any).is_custom;
        const $so0 = (input: any): any => `{${undefined === input.id ? "" : `"id":${undefined !== input.id ? $string(input.id) : undefined},`}${undefined === input.thumbSuffix ? "" : `"thumbSuffix":${undefined !== input.thumbSuffix ? $string(input.thumbSuffix) : undefined},`}"type":${(() => {
            if ("string" === typeof input.type)
                return $string(input.type);
            if ("string" === typeof input.type)
                return "\"" + input.type + "\"";
            $throws({
                expected: "\"AZURE\"",
                value: input.type
            });
        })()},"fullPath":${$string(input.fullPath)},"accountName":${$string(input.accountName)},"accountKey":${$string(input.accountKey)},"purpose":${(() => {
            if ("string" === typeof input.purpose)
                return $string(input.purpose);
            if ("string" === typeof input.purpose)
                return "\"" + input.purpose + "\"";
            $throws({
                expected: "(\"INPUT\" | \"INPUT_OUTPUT\" | \"LIGHTLY\")",
                value: input.purpose
            });
        })()}}`;
        const $so1 = (input: any): any => `{${undefined === input.id ? "" : `"id":${undefined !== input.id ? $string(input.id) : undefined},`}${undefined === input.thumbSuffix ? "" : `"thumbSuffix":${undefined !== input.thumbSuffix ? $string(input.thumbSuffix) : undefined},`}"type":${(() => {
            if ("string" === typeof input.type)
                return $string(input.type);
            if ("string" === typeof input.type)
                return "\"" + input.type + "\"";
            $throws({
                expected: "\"DatasourceConfigAzure\"",
                value: input.type
            });
        })()},"fullPath":${$string(input.fullPath)},"accountName":${$string(input.accountName)},"accountKey":${$string(input.accountKey)},"purpose":${(() => {
            if ("string" === typeof input.purpose)
                return $string(input.purpose);
            if ("string" === typeof input.purpose)
                return "\"" + input.purpose + "\"";
            $throws({
                expected: "(\"INPUT\" | \"INPUT_OUTPUT\" | \"LIGHTLY\")",
                value: input.purpose
            });
        })()}}`;
        const $so2 = (input: any): any => `{${undefined === input.id ? "" : `"id":${undefined !== input.id ? $string(input.id) : undefined},`}${undefined === input.thumbSuffix ? "" : `"thumbSuffix":${undefined !== input.thumbSuffix ? $string(input.thumbSuffix) : undefined},`}"type":${(() => {
            if ("string" === typeof input.type)
                return $string(input.type);
            if ("string" === typeof input.type)
                return "\"" + input.type + "\"";
            $throws({
                expected: "\"DatasourceConfigGCS\"",
                value: input.type
            });
        })()},"fullPath":${$string(input.fullPath)},"gcsProjectId":${$string(input.gcsProjectId)},"gcsCredentials":${$string(input.gcsCredentials)},"purpose":${(() => {
            if ("string" === typeof input.purpose)
                return $string(input.purpose);
            if ("string" === typeof input.purpose)
                return "\"" + input.purpose + "\"";
            $throws({
                expected: "(\"INPUT\" | \"INPUT_OUTPUT\" | \"LIGHTLY\")",
                value: input.purpose
            });
        })()}}`;
        const $so3 = (input: any): any => `{${undefined === input.id ? "" : `"id":${undefined !== input.id ? $string(input.id) : undefined},`}${undefined === input.thumbSuffix ? "" : `"thumbSuffix":${undefined !== input.thumbSuffix ? $string(input.thumbSuffix) : undefined},`}"type":${(() => {
            if ("string" === typeof input.type)
                return $string(input.type);
            if ("string" === typeof input.type)
                return "\"" + input.type + "\"";
            $throws({
                expected: "\"DatasourceConfigLIGHTLY\"",
                value: input.type
            });
        })()},"fullPath":${$string(input.fullPath)},"purpose":${(() => {
            if ("string" === typeof input.purpose)
                return $string(input.purpose);
            if ("string" === typeof input.purpose)
                return "\"" + input.purpose + "\"";
            $throws({
                expected: "(\"INPUT\" | \"INPUT_OUTPUT\" | \"LIGHTLY\")",
                value: input.purpose
            });
        })()}}`;
        const $so4 = (input: any): any => `{${undefined === input.webServerLocation ? "" : `"webServerLocation":${undefined !== input.webServerLocation ? $string(input.webServerLocation) : undefined},`}${undefined === input.id ? "" : `"id":${undefined !== input.id ? $string(input.id) : undefined},`}${undefined === input.thumbSuffix ? "" : `"thumbSuffix":${undefined !== input.thumbSuffix ? $string(input.thumbSuffix) : undefined},`}"type":${(() => {
            if ("string" === typeof input.type)
                return $string(input.type);
            if ("string" === typeof input.type)
                return "\"" + input.type + "\"";
            $throws({
                expected: "\"DatasourceConfigLOCAL\"",
                value: input.type
            });
        })()},"fullPath":${$string(input.fullPath)},"purpose":${(() => {
            if ("string" === typeof input.purpose)
                return $string(input.purpose);
            if ("string" === typeof input.purpose)
                return "\"" + input.purpose + "\"";
            $throws({
                expected: "(\"INPUT\" | \"INPUT_OUTPUT\" | \"LIGHTLY\")",
                value: input.purpose
            });
        })()}}`;
        const $so5 = (input: any): any => `{${undefined === input.id ? "" : `"id":${undefined !== input.id ? $string(input.id) : undefined},`}${undefined === input.thumbSuffix ? "" : `"thumbSuffix":${undefined !== input.thumbSuffix ? $string(input.thumbSuffix) : undefined},`}"type":${(() => {
            if ("string" === typeof input.type)
                return $string(input.type);
            if ("string" === typeof input.type)
                return "\"" + input.type + "\"";
            $throws({
                expected: "\"DatasourceConfigOBS\"",
                value: input.type
            });
        })()},"fullPath":${$string(input.fullPath)},"obsEndpoint":${$string(input.obsEndpoint)},"obsAccessKeyId":${$string(input.obsAccessKeyId)},"obsSecretAccessKey":${$string(input.obsSecretAccessKey)},"purpose":${(() => {
            if ("string" === typeof input.purpose)
                return $string(input.purpose);
            if ("string" === typeof input.purpose)
                return "\"" + input.purpose + "\"";
            $throws({
                expected: "(\"INPUT\" | \"INPUT_OUTPUT\" | \"LIGHTLY\")",
                value: input.purpose
            });
        })()}}`;
        const $so6 = (input: any): any => `{${undefined === input.s3ServerSideEncryptionKMSKey ? "" : `"s3ServerSideEncryptionKMSKey":${undefined !== input.s3ServerSideEncryptionKMSKey ? $string(input.s3ServerSideEncryptionKMSKey) : undefined},`}${undefined === input.id ? "" : `"id":${undefined !== input.id ? $string(input.id) : undefined},`}${undefined === input.thumbSuffix ? "" : `"thumbSuffix":${undefined !== input.thumbSuffix ? $string(input.thumbSuffix) : undefined},`}"type":${(() => {
            if ("string" === typeof input.type)
                return $string(input.type);
            if ("string" === typeof input.type)
                return "\"" + input.type + "\"";
            $throws({
                expected: "\"DatasourceConfigS3\"",
                value: input.type
            });
        })()},"fullPath":${$string(input.fullPath)},"s3Region":${(() => {
            if ("string" === typeof input.s3Region)
                return $string(input.s3Region);
            if ("string" === typeof input.s3Region)
                return "\"" + input.s3Region + "\"";
            $throws({
                expected: "(\"af-south-1\" | \"ap-east-1\" | \"ap-northeast-1\" | \"ap-northeast-2\" | \"ap-northeast-3\" | \"ap-south-1\" | \"ap-south-2\" | \"ap-southeast-1\" | \"ap-southeast-2\" | \"ap-southeast-3\" | \"ap-southeast-4\" | \"ca-central-1\" | \"cn-northwest-1\" | \"eu-central-1\" | \"eu-central-2\" | \"eu-north-1\" | \"eu-south-1\" | \"eu-south-2\" | \"eu-west-1\" | \"eu-west-2\" | \"eu-west-3\" | \"me-central-1\" | \"me-south-1\" | \"sa-east-1\" | \"us-east-1\" | \"us-east-2\" | \"us-gov-east\" | \"us-gov-west\" | \"us-west-1\" | \"us-west-2\")",
                value: input.s3Region
            });
        })()},"s3AccessKeyId":${$string(input.s3AccessKeyId)},"s3SecretAccessKey":${$string(input.s3SecretAccessKey)},"purpose":${(() => {
            if ("string" === typeof input.purpose)
                return $string(input.purpose);
            if ("string" === typeof input.purpose)
                return "\"" + input.purpose + "\"";
            $throws({
                expected: "(\"INPUT\" | \"INPUT_OUTPUT\" | \"LIGHTLY\")",
                value: input.purpose
            });
        })()}}`;
        const $so7 = (input: any): any => `{${undefined === input.s3ServerSideEncryptionKMSKey ? "" : `"s3ServerSideEncryptionKMSKey":${undefined !== input.s3ServerSideEncryptionKMSKey ? $string(input.s3ServerSideEncryptionKMSKey) : undefined},`}${undefined === input.id ? "" : `"id":${undefined !== input.id ? $string(input.id) : undefined},`}${undefined === input.thumbSuffix ? "" : `"thumbSuffix":${undefined !== input.thumbSuffix ? $string(input.thumbSuffix) : undefined},`}"type":${(() => {
            if ("string" === typeof input.type)
                return $string(input.type);
            if ("string" === typeof input.type)
                return "\"" + input.type + "\"";
            $throws({
                expected: "\"DatasourceConfigS3DelegatedAccess\"",
                value: input.type
            });
        })()},"fullPath":${$string(input.fullPath)},"s3Region":${(() => {
            if ("string" === typeof input.s3Region)
                return $string(input.s3Region);
            if ("string" === typeof input.s3Region)
                return "\"" + input.s3Region + "\"";
            $throws({
                expected: "(\"af-south-1\" | \"ap-east-1\" | \"ap-northeast-1\" | \"ap-northeast-2\" | \"ap-northeast-3\" | \"ap-south-1\" | \"ap-south-2\" | \"ap-southeast-1\" | \"ap-southeast-2\" | \"ap-southeast-3\" | \"ap-southeast-4\" | \"ca-central-1\" | \"cn-northwest-1\" | \"eu-central-1\" | \"eu-central-2\" | \"eu-north-1\" | \"eu-south-1\" | \"eu-south-2\" | \"eu-west-1\" | \"eu-west-2\" | \"eu-west-3\" | \"me-central-1\" | \"me-south-1\" | \"sa-east-1\" | \"us-east-1\" | \"us-east-2\" | \"us-gov-east\" | \"us-gov-west\" | \"us-west-1\" | \"us-west-2\")",
                value: input.s3Region
            });
        })()},"s3ExternalId":${$string(input.s3ExternalId)},"s3ARN":${$string(input.s3ARN)},"purpose":${(() => {
            if ("string" === typeof input.purpose)
                return $string(input.purpose);
            if ("string" === typeof input.purpose)
                return "\"" + input.purpose + "\"";
            $throws({
                expected: "(\"INPUT\" | \"INPUT_OUTPUT\" | \"LIGHTLY\")",
                value: input.purpose
            });
        })()}}`;
        const $so8 = (input: any): any => `{${undefined === input.id ? "" : `"id":${undefined !== input.id ? $string(input.id) : undefined},`}${undefined === input.thumbSuffix ? "" : `"thumbSuffix":${undefined !== input.thumbSuffix ? $string(input.thumbSuffix) : undefined},`}"type":${(() => {
            if ("string" === typeof input.type)
                return $string(input.type);
            if ("string" === typeof input.type)
                return "\"" + input.type + "\"";
            $throws({
                expected: "\"GCS\"",
                value: input.type
            });
        })()},"fullPath":${$string(input.fullPath)},"gcsProjectId":${$string(input.gcsProjectId)},"gcsCredentials":${$string(input.gcsCredentials)},"purpose":${(() => {
            if ("string" === typeof input.purpose)
                return $string(input.purpose);
            if ("string" === typeof input.purpose)
                return "\"" + input.purpose + "\"";
            $throws({
                expected: "(\"INPUT\" | \"INPUT_OUTPUT\" | \"LIGHTLY\")",
                value: input.purpose
            });
        })()}}`;
        const $so9 = (input: any): any => `{${undefined === input.id ? "" : `"id":${undefined !== input.id ? $string(input.id) : undefined},`}${undefined === input.thumbSuffix ? "" : `"thumbSuffix":${undefined !== input.thumbSuffix ? $string(input.thumbSuffix) : undefined},`}"type":${(() => {
            if ("string" === typeof input.type)
                return $string(input.type);
            if ("string" === typeof input.type)
                return "\"" + input.type + "\"";
            $throws({
                expected: "\"LIGHTLY\"",
                value: input.type
            });
        })()},"fullPath":${$string(input.fullPath)},"purpose":${(() => {
            if ("string" === typeof input.purpose)
                return $string(input.purpose);
            if ("string" === typeof input.purpose)
                return "\"" + input.purpose + "\"";
            $throws({
                expected: "(\"INPUT\" | \"INPUT_OUTPUT\" | \"LIGHTLY\")",
                value: input.purpose
            });
        })()}}`;
        const $so10 = (input: any): any => `{${undefined === input.webServerLocation ? "" : `"webServerLocation":${undefined !== input.webServerLocation ? $string(input.webServerLocation) : undefined},`}${undefined === input.id ? "" : `"id":${undefined !== input.id ? $string(input.id) : undefined},`}${undefined === input.thumbSuffix ? "" : `"thumbSuffix":${undefined !== input.thumbSuffix ? $string(input.thumbSuffix) : undefined},`}"type":${(() => {
            if ("string" === typeof input.type)
                return $string(input.type);
            if ("string" === typeof input.type)
                return "\"" + input.type + "\"";
            $throws({
                expected: "\"LOCAL\"",
                value: input.type
            });
        })()},"fullPath":${$string(input.fullPath)},"purpose":${(() => {
            if ("string" === typeof input.purpose)
                return $string(input.purpose);
            if ("string" === typeof input.purpose)
                return "\"" + input.purpose + "\"";
            $throws({
                expected: "(\"INPUT\" | \"INPUT_OUTPUT\" | \"LIGHTLY\")",
                value: input.purpose
            });
        })()}}`;
        const $so11 = (input: any): any => `{${undefined === input.id ? "" : `"id":${undefined !== input.id ? $string(input.id) : undefined},`}${undefined === input.thumbSuffix ? "" : `"thumbSuffix":${undefined !== input.thumbSuffix ? $string(input.thumbSuffix) : undefined},`}"type":${(() => {
            if ("string" === typeof input.type)
                return $string(input.type);
            if ("string" === typeof input.type)
                return "\"" + input.type + "\"";
            $throws({
                expected: "\"OBS\"",
                value: input.type
            });
        })()},"fullPath":${$string(input.fullPath)},"obsEndpoint":${$string(input.obsEndpoint)},"obsAccessKeyId":${$string(input.obsAccessKeyId)},"obsSecretAccessKey":${$string(input.obsSecretAccessKey)},"purpose":${(() => {
            if ("string" === typeof input.purpose)
                return $string(input.purpose);
            if ("string" === typeof input.purpose)
                return "\"" + input.purpose + "\"";
            $throws({
                expected: "(\"INPUT\" | \"INPUT_OUTPUT\" | \"LIGHTLY\")",
                value: input.purpose
            });
        })()}}`;
        const $so12 = (input: any): any => `{${undefined === input.s3ServerSideEncryptionKMSKey ? "" : `"s3ServerSideEncryptionKMSKey":${undefined !== input.s3ServerSideEncryptionKMSKey ? $string(input.s3ServerSideEncryptionKMSKey) : undefined},`}${undefined === input.id ? "" : `"id":${undefined !== input.id ? $string(input.id) : undefined},`}${undefined === input.thumbSuffix ? "" : `"thumbSuffix":${undefined !== input.thumbSuffix ? $string(input.thumbSuffix) : undefined},`}"type":${(() => {
            if ("string" === typeof input.type)
                return $string(input.type);
            if ("string" === typeof input.type)
                return "\"" + input.type + "\"";
            $throws({
                expected: "\"S3\"",
                value: input.type
            });
        })()},"fullPath":${$string(input.fullPath)},"s3Region":${(() => {
            if ("string" === typeof input.s3Region)
                return $string(input.s3Region);
            if ("string" === typeof input.s3Region)
                return "\"" + input.s3Region + "\"";
            $throws({
                expected: "(\"af-south-1\" | \"ap-east-1\" | \"ap-northeast-1\" | \"ap-northeast-2\" | \"ap-northeast-3\" | \"ap-south-1\" | \"ap-south-2\" | \"ap-southeast-1\" | \"ap-southeast-2\" | \"ap-southeast-3\" | \"ap-southeast-4\" | \"ca-central-1\" | \"cn-northwest-1\" | \"eu-central-1\" | \"eu-central-2\" | \"eu-north-1\" | \"eu-south-1\" | \"eu-south-2\" | \"eu-west-1\" | \"eu-west-2\" | \"eu-west-3\" | \"me-central-1\" | \"me-south-1\" | \"sa-east-1\" | \"us-east-1\" | \"us-east-2\" | \"us-gov-east\" | \"us-gov-west\" | \"us-west-1\" | \"us-west-2\")",
                value: input.s3Region
            });
        })()},"s3AccessKeyId":${$string(input.s3AccessKeyId)},"s3SecretAccessKey":${$string(input.s3SecretAccessKey)},"purpose":${(() => {
            if ("string" === typeof input.purpose)
                return $string(input.purpose);
            if ("string" === typeof input.purpose)
                return "\"" + input.purpose + "\"";
            $throws({
                expected: "(\"INPUT\" | \"INPUT_OUTPUT\" | \"LIGHTLY\")",
                value: input.purpose
            });
        })()}}`;
        const $so13 = (input: any): any => `{${undefined === input.s3ServerSideEncryptionKMSKey ? "" : `"s3ServerSideEncryptionKMSKey":${undefined !== input.s3ServerSideEncryptionKMSKey ? $string(input.s3ServerSideEncryptionKMSKey) : undefined},`}${undefined === input.id ? "" : `"id":${undefined !== input.id ? $string(input.id) : undefined},`}${undefined === input.thumbSuffix ? "" : `"thumbSuffix":${undefined !== input.thumbSuffix ? $string(input.thumbSuffix) : undefined},`}"type":${(() => {
            if ("string" === typeof input.type)
                return $string(input.type);
            if ("string" === typeof input.type)
                return "\"" + input.type + "\"";
            $throws({
                expected: "\"S3DelegatedAccess\"",
                value: input.type
            });
        })()},"fullPath":${$string(input.fullPath)},"s3Region":${(() => {
            if ("string" === typeof input.s3Region)
                return $string(input.s3Region);
            if ("string" === typeof input.s3Region)
                return "\"" + input.s3Region + "\"";
            $throws({
                expected: "(\"af-south-1\" | \"ap-east-1\" | \"ap-northeast-1\" | \"ap-northeast-2\" | \"ap-northeast-3\" | \"ap-south-1\" | \"ap-south-2\" | \"ap-southeast-1\" | \"ap-southeast-2\" | \"ap-southeast-3\" | \"ap-southeast-4\" | \"ca-central-1\" | \"cn-northwest-1\" | \"eu-central-1\" | \"eu-central-2\" | \"eu-north-1\" | \"eu-south-1\" | \"eu-south-2\" | \"eu-west-1\" | \"eu-west-2\" | \"eu-west-3\" | \"me-central-1\" | \"me-south-1\" | \"sa-east-1\" | \"us-east-1\" | \"us-east-2\" | \"us-gov-east\" | \"us-gov-west\" | \"us-west-1\" | \"us-west-2\")",
                value: input.s3Region
            });
        })()},"s3ExternalId":${$string(input.s3ExternalId)},"s3ARN":${$string(input.s3ARN)},"purpose":${(() => {
            if ("string" === typeof input.purpose)
                return $string(input.purpose);
            if ("string" === typeof input.purpose)
                return "\"" + input.purpose + "\"";
            $throws({
                expected: "(\"INPUT\" | \"INPUT_OUTPUT\" | \"LIGHTLY\")",
                value: input.purpose
            });
        })()}}`;
        const $su0 = (input: any): any => (() => {
            if ("DatasourceConfigAzure" === input.type)
                return $so1(input);
            if ("AZURE" === input.type)
                return $so0(input);
            if ("DatasourceConfigGCS" === input.type)
                return $so2(input);
            if ("DatasourceConfigLIGHTLY" === input.type)
                return $so3(input);
            if ("DatasourceConfigLOCAL" === input.type)
                return $so4(input);
            if ("OBS" === input.type)
                return $so11(input);
            if ("DatasourceConfigOBS" === input.type)
                return $so5(input);
            if ("DatasourceConfigS3" === input.type)
                return $so6(input);
            if ("DatasourceConfigS3DelegatedAccess" === input.type)
                return $so7(input);
            if ("GCS" === input.type)
                return $so8(input);
            if ("LIGHTLY" === input.type)
                return $so9(input);
            if ("LOCAL" === input.type)
                return $so10(input);
            if ("S3" === input.type)
                return $so12(input);
            if ("S3DelegatedAccess" === input.type)
                return $so13(input);
            $throws({
                expected: "({ type: \"DatasourceConfigAzure\"; } & DatasourceConfigAzure | { type: \"AZURE\"; } & DatasourceConfigAzure | { type: \"DatasourceConfigGCS\"; } & DatasourceConfigGCS | { type: \"DatasourceConfigLIGHTLY\"; } & DatasourceConfigLIGHTLY | { type: \"DatasourceConfigLOCAL\"; } & DatasourceConfigLOCAL | { type: \"OBS\"; } & DatasourceConfigOBS | { type: \"DatasourceConfigOBS\"; } & DatasourceConfigOBS | { type: \"DatasourceConfigS3\"; } & DatasourceConfigS3 | { type: \"DatasourceConfigS3DelegatedAccess\"; } & DatasourceConfigS3DelegatedAccess | { type: \"GCS\"; } & DatasourceConfigGCS | { type: \"LIGHTLY\"; } & DatasourceConfigLIGHTLY | { type: \"LOCAL\"; } & DatasourceConfigLOCAL | { type: \"S3\"; } & DatasourceConfigS3 | { type: \"S3DelegatedAccess\"; } & DatasourceConfigS3DelegatedAccess)",
                value: input
            });
        })();
        return $su0(input);
    }; return stringify(assert(input)); })(input);
};
export type UpdateDatasourceProcessedUntilTimestampByDatasetIdRequestBody = DatasourceProcessedUntilTimestampRequest;
export const UpdateDatasourceProcessedUntilTimestampByDatasetIdRequestBodySanitizer = DatasourceProcessedUntilTimestampRequestFromJSON;
export const UpdateDatasourceProcessedUntilTimestampByDatasetIdRequestBodyValidator = DatasourceProcessedUntilTimestampRequestValidator;
export const UpdateDatasourceProcessedUntilTimestampByDatasetIdTypiaAssertEquals = (input: any) => {
    return ((input: any): UpdateDatasourceProcessedUntilTimestampByDatasetIdRequestBody => {
        const __is = (input: any, _exceptionable: boolean = true): input is UpdateDatasourceProcessedUntilTimestampByDatasetIdRequestBody => {
            const $io0 = (input: any, _exceptionable: boolean = true): boolean => "number" === typeof input.processedUntilTimestamp && 0 <= input.processedUntilTimestamp && (1 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["processedUntilTimestamp"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            return "object" === typeof input && null !== input && $io0(input, true);
        };
        if (false === __is(input))
            ((input: any, _path: string, _exceptionable: boolean = true): input is UpdateDatasourceProcessedUntilTimestampByDatasetIdRequestBody => {
                const $guard = (typia.createAssertEquals as any).guard;
                const $join = (typia.createAssertEquals as any).join;
                const $ao0 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("number" === typeof input.processedUntilTimestamp && (0 <= input.processedUntilTimestamp || $guard(_exceptionable, {
                    path: _path + ".processedUntilTimestamp",
                    expected: "number (@minimum 0)",
                    value: input.processedUntilTimestamp
                })) || $guard(_exceptionable, {
                    path: _path + ".processedUntilTimestamp",
                    expected: "number",
                    value: input.processedUntilTimestamp
                })) && (1 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["processedUntilTimestamp"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                return ("object" === typeof input && null !== input || $guard(true, {
                    path: _path + "",
                    expected: "DatasourceProcessedUntilTimestampRequest",
                    value: input
                })) && $ao0(input, _path + "", true) || $guard(true, {
                    path: _path + "",
                    expected: "DatasourceProcessedUntilTimestampRequest",
                    value: input
                });
            })(input, "$input", true);
        return input;
    })(input);
};
export const UpdateDatasourceProcessedUntilTimestampByDatasetIdTypiaAssertStringify = (input: UpdateDatasourceProcessedUntilTimestampByDatasetIdRequestBody): string => {
    return ((input: any): string => { const assert = (input: any): UpdateDatasourceProcessedUntilTimestampByDatasetIdRequestBody => {
        const __is = (input: any): input is UpdateDatasourceProcessedUntilTimestampByDatasetIdRequestBody => {
            return "object" === typeof input && null !== input && ("number" === typeof (input as any).processedUntilTimestamp && !Number.isNaN((input as any).processedUntilTimestamp) && 0 <= (input as any).processedUntilTimestamp);
        };
        if (false === __is(input))
            ((input: any, _path: string, _exceptionable: boolean = true): input is UpdateDatasourceProcessedUntilTimestampByDatasetIdRequestBody => {
                const $guard = (typia.createAssertStringify as any).guard;
                const $ao0 = (input: any, _path: string, _exceptionable: boolean = true): boolean => "number" === typeof input.processedUntilTimestamp && !Number.isNaN(input.processedUntilTimestamp) && (0 <= input.processedUntilTimestamp || $guard(_exceptionable, {
                    path: _path + ".processedUntilTimestamp",
                    expected: "number (@minimum 0)",
                    value: input.processedUntilTimestamp
                })) || $guard(_exceptionable, {
                    path: _path + ".processedUntilTimestamp",
                    expected: "number",
                    value: input.processedUntilTimestamp
                });
                return ("object" === typeof input && null !== input || $guard(true, {
                    path: _path + "",
                    expected: "DatasourceProcessedUntilTimestampRequest",
                    value: input
                })) && $ao0(input, _path + "", true) || $guard(true, {
                    path: _path + "",
                    expected: "DatasourceProcessedUntilTimestampRequest",
                    value: input
                });
            })(input, "$input", true);
        return input;
    }; const stringify = (input: UpdateDatasourceProcessedUntilTimestampByDatasetIdRequestBody): string => {
        return `{"processedUntilTimestamp":${(input as any).processedUntilTimestamp}}`;
    }; return stringify(assert(input)); })(input);
};
/*
HANDLERS:



/v1/datasets/{datasetId}/datasource/embeddings/file

export const getCustomEmbeddingFileReadUrlFromDatasourceByDatasetIdFN: RequestHandler<
    GetCustomEmbeddingFileReadUrlFromDatasourceByDatasetIdRequestParams,
    string | ApiErrorResponse,
    GetCustomEmbeddingFileReadUrlFromDatasourceByDatasetIdRequestBody,
    GetCustomEmbeddingFileReadUrlFromDatasourceByDatasetIdRequestQuery
> = async (req, res) => {
    if (!ensureUserOnReq(req)) {
        return
    }

    const {
        
    } = await validateAndSanitizeStrict(req.body, GetCustomEmbeddingFileReadUrlFromDatasourceByDatasetIdRequestBodySanitizer, GetCustomEmbeddingFileReadUrlFromDatasourceByDatasetIdRequestBodyValidator);
    const {
        datasetId,
        
    } =  await validateAndSanitize(req.params, GetCustomEmbeddingFileReadUrlFromDatasourceByDatasetIdRequestParamsSanitizer, GetCustomEmbeddingFileReadUrlFromDatasourceByDatasetIdRequestParamsValidator);
    const {
        
        fileName,
    } = await validateAndSanitize(req.query, GetCustomEmbeddingFileReadUrlFromDatasourceByDatasetIdRequestQuerySanitizer, GetCustomEmbeddingFileReadUrlFromDatasourceByDatasetIdRequestQueryValidator);



    
    const schema = ....

    const { _id: id, ...rest } = schema;
    return fastJSONResponse(
        res,
        stringStringify,
        validateAndRespond({ id, ...rest }, stringFromJSON, stringValidator),
    );
}



/v1/datasets/{datasetId}/datasource

export const getDatasourceByDatasetIdFN: RequestHandler<
    GetDatasourceByDatasetIdRequestParams,
    DatasourceConfig | ApiErrorResponse,
    GetDatasourceByDatasetIdRequestBody,
    GetDatasourceByDatasetIdRequestQuery
> = async (req, res) => {
    if (!ensureUserOnReq(req)) {
        return
    }

    const {
        
    } = await validateAndSanitizeStrict(req.body, GetDatasourceByDatasetIdRequestBodySanitizer, GetDatasourceByDatasetIdRequestBodyValidator);
    const {
        datasetId,
        
    } =  await validateAndSanitize(req.params, GetDatasourceByDatasetIdRequestParamsSanitizer, GetDatasourceByDatasetIdRequestParamsValidator);
    const {
        
        purpose,
    } = await validateAndSanitize(req.query, GetDatasourceByDatasetIdRequestQuerySanitizer, GetDatasourceByDatasetIdRequestQueryValidator);



    
    const schema = ....

    const { _id: id, ...rest } = schema;
    return fastJSONResponse(
        res,
        DatasourceConfigStringify,
        validateAndRespond({ id, ...rest }, DatasourceConfigFromJSON, DatasourceConfigValidator),
    );
}



/v1/datasets/{datasetId}/datasource/processedUntilTimestamp

export const getDatasourceProcessedUntilTimestampByDatasetIdFN: RequestHandler<
    GetDatasourceProcessedUntilTimestampByDatasetIdRequestParams,
    DatasourceProcessedUntilTimestampResponse | ApiErrorResponse,
    GetDatasourceProcessedUntilTimestampByDatasetIdRequestBody,
    GetDatasourceProcessedUntilTimestampByDatasetIdRequestQuery
> = async (req, res) => {
    if (!ensureUserOnReq(req)) {
        return
    }

    const {
        
    } = await validateAndSanitizeStrict(req.body, GetDatasourceProcessedUntilTimestampByDatasetIdRequestBodySanitizer, GetDatasourceProcessedUntilTimestampByDatasetIdRequestBodyValidator);
    const {
        datasetId,
    } =  await validateAndSanitize(req.params, GetDatasourceProcessedUntilTimestampByDatasetIdRequestParamsSanitizer, GetDatasourceProcessedUntilTimestampByDatasetIdRequestParamsValidator);
    const {
        
    } = await validateAndSanitize(req.query, GetDatasourceProcessedUntilTimestampByDatasetIdRequestQuerySanitizer, GetDatasourceProcessedUntilTimestampByDatasetIdRequestQueryValidator);



    
    const schema = ....

    const { _id: id, ...rest } = schema;
    return fastJSONResponse(
        res,
        DatasourceProcessedUntilTimestampResponseStringify,
        validateAndRespond({ id, ...rest }, DatasourceProcessedUntilTimestampResponseFromJSON, DatasourceProcessedUntilTimestampResponseValidator),
    );
}



/v1/datasets/{datasetId}/datasource/all
const DatasourceConfigArrayStringify = fastJSONArrayify(DatasourceConfigStringifyShape);
export const getDatasourcesByDatasetIdFN: RequestHandler<
    GetDatasourcesByDatasetIdRequestParams,
    DatasourceConfig[] | ApiErrorResponse,
    GetDatasourcesByDatasetIdRequestBody,
    GetDatasourcesByDatasetIdRequestQuery
> = async (req, res) => {
    if (!ensureUserOnReq(req)) {
        return
    }

    const {
        
    } = await validateAndSanitizeStrict(req.body, GetDatasourcesByDatasetIdRequestBodySanitizer, GetDatasourcesByDatasetIdRequestBodyValidator);
    const {
        datasetId,
    } =  await validateAndSanitize(req.params, GetDatasourcesByDatasetIdRequestParamsSanitizer, GetDatasourcesByDatasetIdRequestParamsValidator);
    const {
        
    } = await validateAndSanitize(req.query, GetDatasourcesByDatasetIdRequestQuerySanitizer, GetDatasourcesByDatasetIdRequestQueryValidator);



    
    const schemas = ....

    return fastJSONResponse(
        res,
        DatasourceConfigArrayStringify,
        schemas.map((schema) => {
            const { _id: id, ...rest } = schema;
            return validateAndRespond({ id, ...rest }, DatasourceConfigFromJSON, DatasourceConfigValidator);
        }),
    );
}



/v1/datasets/{datasetId}/datasource/list/dnc

export const getDivideAndConquerListOfRawSamplesFromDatasourceByDatasetIdFN: RequestHandler<
    GetDivideAndConquerListOfRawSamplesFromDatasourceByDatasetIdRequestParams,
    DivideAndConquerCursorData | ApiErrorResponse,
    GetDivideAndConquerListOfRawSamplesFromDatasourceByDatasetIdRequestBody,
    GetDivideAndConquerListOfRawSamplesFromDatasourceByDatasetIdRequestQuery
> = async (req, res) => {
    if (!ensureUserOnReq(req)) {
        return
    }

    const {
        
    } = await validateAndSanitizeStrict(req.body, GetDivideAndConquerListOfRawSamplesFromDatasourceByDatasetIdRequestBodySanitizer, GetDivideAndConquerListOfRawSamplesFromDatasourceByDatasetIdRequestBodyValidator);
    const {
        datasetId,
        
        
        
        
    } =  await validateAndSanitize(req.params, GetDivideAndConquerListOfRawSamplesFromDatasourceByDatasetIdRequestParamsSanitizer, GetDivideAndConquerListOfRawSamplesFromDatasourceByDatasetIdRequestParamsValidator);
    const {
        
        dncShards,
        from,
        to,
        relevantFilenamesFileName,
    } = await validateAndSanitize(req.query, GetDivideAndConquerListOfRawSamplesFromDatasourceByDatasetIdRequestQuerySanitizer, GetDivideAndConquerListOfRawSamplesFromDatasourceByDatasetIdRequestQueryValidator);



    
    const schema = ....

    const { _id: id, ...rest } = schema;
    return fastJSONResponse(
        res,
        DivideAndConquerCursorDataStringify,
        validateAndRespond({ id, ...rest }, DivideAndConquerCursorDataFromJSON, DivideAndConquerCursorDataValidator),
    );
}



/v1/datasets/{datasetId}/datasource/metadata/list/dnc

export const getDivideAndConquerListOfRawSamplesMetadataFromDatasourceByDatasetIdFN: RequestHandler<
    GetDivideAndConquerListOfRawSamplesMetadataFromDatasourceByDatasetIdRequestParams,
    DivideAndConquerCursorData | ApiErrorResponse,
    GetDivideAndConquerListOfRawSamplesMetadataFromDatasourceByDatasetIdRequestBody,
    GetDivideAndConquerListOfRawSamplesMetadataFromDatasourceByDatasetIdRequestQuery
> = async (req, res) => {
    if (!ensureUserOnReq(req)) {
        return
    }

    const {
        
    } = await validateAndSanitizeStrict(req.body, GetDivideAndConquerListOfRawSamplesMetadataFromDatasourceByDatasetIdRequestBodySanitizer, GetDivideAndConquerListOfRawSamplesMetadataFromDatasourceByDatasetIdRequestBodyValidator);
    const {
        datasetId,
        
        
        
        
        
        
    } =  await validateAndSanitize(req.params, GetDivideAndConquerListOfRawSamplesMetadataFromDatasourceByDatasetIdRequestParamsSanitizer, GetDivideAndConquerListOfRawSamplesMetadataFromDatasourceByDatasetIdRequestParamsValidator);
    const {
        
        dncShards,
        from,
        to,
        relevantFilenamesFileName,
        relevantFilenamesRunId,
        relevantFilenamesArtifactId,
    } = await validateAndSanitize(req.query, GetDivideAndConquerListOfRawSamplesMetadataFromDatasourceByDatasetIdRequestQuerySanitizer, GetDivideAndConquerListOfRawSamplesMetadataFromDatasourceByDatasetIdRequestQueryValidator);



    
    const schema = ....

    const { _id: id, ...rest } = schema;
    return fastJSONResponse(
        res,
        DivideAndConquerCursorDataStringify,
        validateAndRespond({ id, ...rest }, DivideAndConquerCursorDataFromJSON, DivideAndConquerCursorDataValidator),
    );
}



/v1/datasets/{datasetId}/datasource/predictions/list/dnc

export const getDivideAndConquerListOfRawSamplesPredictionsFromDatasourceByDatasetIdFN: RequestHandler<
    GetDivideAndConquerListOfRawSamplesPredictionsFromDatasourceByDatasetIdRequestParams,
    DivideAndConquerCursorData | ApiErrorResponse,
    GetDivideAndConquerListOfRawSamplesPredictionsFromDatasourceByDatasetIdRequestBody,
    GetDivideAndConquerListOfRawSamplesPredictionsFromDatasourceByDatasetIdRequestQuery
> = async (req, res) => {
    if (!ensureUserOnReq(req)) {
        return
    }

    const {
        
    } = await validateAndSanitizeStrict(req.body, GetDivideAndConquerListOfRawSamplesPredictionsFromDatasourceByDatasetIdRequestBodySanitizer, GetDivideAndConquerListOfRawSamplesPredictionsFromDatasourceByDatasetIdRequestBodyValidator);
    const {
        datasetId,
        
        
        
        
        
        
        
    } =  await validateAndSanitize(req.params, GetDivideAndConquerListOfRawSamplesPredictionsFromDatasourceByDatasetIdRequestParamsSanitizer, GetDivideAndConquerListOfRawSamplesPredictionsFromDatasourceByDatasetIdRequestParamsValidator);
    const {
        
        taskName,
        dncShards,
        from,
        to,
        relevantFilenamesFileName,
        relevantFilenamesRunId,
        relevantFilenamesArtifactId,
    } = await validateAndSanitize(req.query, GetDivideAndConquerListOfRawSamplesPredictionsFromDatasourceByDatasetIdRequestQuerySanitizer, GetDivideAndConquerListOfRawSamplesPredictionsFromDatasourceByDatasetIdRequestQueryValidator);



    
    const schema = ....

    const { _id: id, ...rest } = schema;
    return fastJSONResponse(
        res,
        DivideAndConquerCursorDataStringify,
        validateAndRespond({ id, ...rest }, DivideAndConquerCursorDataFromJSON, DivideAndConquerCursorDataValidator),
    );
}



/v1/datasets/{datasetId}/datasource/fileHEAD

export const getHEADFileReadUrlFromDatasourceByDatasetIdFN: RequestHandler<
    GetHEADFileReadUrlFromDatasourceByDatasetIdRequestParams,
    string | ApiErrorResponse,
    GetHEADFileReadUrlFromDatasourceByDatasetIdRequestBody,
    GetHEADFileReadUrlFromDatasourceByDatasetIdRequestQuery
> = async (req, res) => {
    if (!ensureUserOnReq(req)) {
        return
    }

    const {
        
    } = await validateAndSanitizeStrict(req.body, GetHEADFileReadUrlFromDatasourceByDatasetIdRequestBodySanitizer, GetHEADFileReadUrlFromDatasourceByDatasetIdRequestBodyValidator);
    const {
        datasetId,
        
    } =  await validateAndSanitize(req.params, GetHEADFileReadUrlFromDatasourceByDatasetIdRequestParamsSanitizer, GetHEADFileReadUrlFromDatasourceByDatasetIdRequestParamsValidator);
    const {
        
        fileName,
    } = await validateAndSanitize(req.query, GetHEADFileReadUrlFromDatasourceByDatasetIdRequestQuerySanitizer, GetHEADFileReadUrlFromDatasourceByDatasetIdRequestQueryValidator);



    
    const schema = ....

    const { _id: id, ...rest } = schema;
    return fastJSONResponse(
        res,
        stringStringify,
        validateAndRespond({ id, ...rest }, stringFromJSON, stringValidator),
    );
}



/v1/datasets/{datasetId}/datasource/list

export const getListOfRawSamplesFromDatasourceByDatasetIdFN: RequestHandler<
    GetListOfRawSamplesFromDatasourceByDatasetIdRequestParams,
    DatasourceRawSamplesData | ApiErrorResponse,
    GetListOfRawSamplesFromDatasourceByDatasetIdRequestBody,
    GetListOfRawSamplesFromDatasourceByDatasetIdRequestQuery
> = async (req, res) => {
    if (!ensureUserOnReq(req)) {
        return
    }

    const {
        
    } = await validateAndSanitizeStrict(req.body, GetListOfRawSamplesFromDatasourceByDatasetIdRequestBodySanitizer, GetListOfRawSamplesFromDatasourceByDatasetIdRequestBodyValidator);
    const {
        datasetId,
        
        
        
        
        
    } =  await validateAndSanitize(req.params, GetListOfRawSamplesFromDatasourceByDatasetIdRequestParamsSanitizer, GetListOfRawSamplesFromDatasourceByDatasetIdRequestParamsValidator);
    const {
        
        from,
        to,
        cursor,
        useRedirectedReadUrl,
        relevantFilenamesFileName,
    } = await validateAndSanitize(req.query, GetListOfRawSamplesFromDatasourceByDatasetIdRequestQuerySanitizer, GetListOfRawSamplesFromDatasourceByDatasetIdRequestQueryValidator);



    
    const schema = ....

    const { _id: id, ...rest } = schema;
    return fastJSONResponse(
        res,
        DatasourceRawSamplesDataStringify,
        validateAndRespond({ id, ...rest }, DatasourceRawSamplesDataFromJSON, DatasourceRawSamplesDataValidator),
    );
}



/v1/datasets/{datasetId}/datasource/metadata/list

export const getListOfRawSamplesMetadataFromDatasourceByDatasetIdFN: RequestHandler<
    GetListOfRawSamplesMetadataFromDatasourceByDatasetIdRequestParams,
    DatasourceRawSamplesMetadataData | ApiErrorResponse,
    GetListOfRawSamplesMetadataFromDatasourceByDatasetIdRequestBody,
    GetListOfRawSamplesMetadataFromDatasourceByDatasetIdRequestQuery
> = async (req, res) => {
    if (!ensureUserOnReq(req)) {
        return
    }

    const {
        
    } = await validateAndSanitizeStrict(req.body, GetListOfRawSamplesMetadataFromDatasourceByDatasetIdRequestBodySanitizer, GetListOfRawSamplesMetadataFromDatasourceByDatasetIdRequestBodyValidator);
    const {
        datasetId,
        
        
        
        
        
        
        
    } =  await validateAndSanitize(req.params, GetListOfRawSamplesMetadataFromDatasourceByDatasetIdRequestParamsSanitizer, GetListOfRawSamplesMetadataFromDatasourceByDatasetIdRequestParamsValidator);
    const {
        
        from,
        to,
        cursor,
        useRedirectedReadUrl,
        relevantFilenamesFileName,
        relevantFilenamesRunId,
        relevantFilenamesArtifactId,
    } = await validateAndSanitize(req.query, GetListOfRawSamplesMetadataFromDatasourceByDatasetIdRequestQuerySanitizer, GetListOfRawSamplesMetadataFromDatasourceByDatasetIdRequestQueryValidator);



    
    const schema = ....

    const { _id: id, ...rest } = schema;
    return fastJSONResponse(
        res,
        DatasourceRawSamplesMetadataDataStringify,
        validateAndRespond({ id, ...rest }, DatasourceRawSamplesMetadataDataFromJSON, DatasourceRawSamplesMetadataDataValidator),
    );
}



/v1/datasets/{datasetId}/datasource/predictions/list

export const getListOfRawSamplesPredictionsFromDatasourceByDatasetIdFN: RequestHandler<
    GetListOfRawSamplesPredictionsFromDatasourceByDatasetIdRequestParams,
    DatasourceRawSamplesPredictionsData | ApiErrorResponse,
    GetListOfRawSamplesPredictionsFromDatasourceByDatasetIdRequestBody,
    GetListOfRawSamplesPredictionsFromDatasourceByDatasetIdRequestQuery
> = async (req, res) => {
    if (!ensureUserOnReq(req)) {
        return
    }

    const {
        
    } = await validateAndSanitizeStrict(req.body, GetListOfRawSamplesPredictionsFromDatasourceByDatasetIdRequestBodySanitizer, GetListOfRawSamplesPredictionsFromDatasourceByDatasetIdRequestBodyValidator);
    const {
        datasetId,
        
        
        
        
        
        
        
        
    } =  await validateAndSanitize(req.params, GetListOfRawSamplesPredictionsFromDatasourceByDatasetIdRequestParamsSanitizer, GetListOfRawSamplesPredictionsFromDatasourceByDatasetIdRequestParamsValidator);
    const {
        
        taskName,
        from,
        to,
        cursor,
        useRedirectedReadUrl,
        relevantFilenamesFileName,
        relevantFilenamesRunId,
        relevantFilenamesArtifactId,
    } = await validateAndSanitize(req.query, GetListOfRawSamplesPredictionsFromDatasourceByDatasetIdRequestQuerySanitizer, GetListOfRawSamplesPredictionsFromDatasourceByDatasetIdRequestQueryValidator);



    
    const schema = ....

    const { _id: id, ...rest } = schema;
    return fastJSONResponse(
        res,
        DatasourceRawSamplesPredictionsDataStringify,
        validateAndRespond({ id, ...rest }, DatasourceRawSamplesPredictionsDataFromJSON, DatasourceRawSamplesPredictionsDataValidator),
    );
}



/v1/datasets/{datasetId}/datasource/metadata/file

export const getMetadataFileReadUrlFromDatasourceByDatasetIdFN: RequestHandler<
    GetMetadataFileReadUrlFromDatasourceByDatasetIdRequestParams,
    string | ApiErrorResponse,
    GetMetadataFileReadUrlFromDatasourceByDatasetIdRequestBody,
    GetMetadataFileReadUrlFromDatasourceByDatasetIdRequestQuery
> = async (req, res) => {
    if (!ensureUserOnReq(req)) {
        return
    }

    const {
        
    } = await validateAndSanitizeStrict(req.body, GetMetadataFileReadUrlFromDatasourceByDatasetIdRequestBodySanitizer, GetMetadataFileReadUrlFromDatasourceByDatasetIdRequestBodyValidator);
    const {
        datasetId,
        
    } =  await validateAndSanitize(req.params, GetMetadataFileReadUrlFromDatasourceByDatasetIdRequestParamsSanitizer, GetMetadataFileReadUrlFromDatasourceByDatasetIdRequestParamsValidator);
    const {
        
        fileName,
    } = await validateAndSanitize(req.query, GetMetadataFileReadUrlFromDatasourceByDatasetIdRequestQuerySanitizer, GetMetadataFileReadUrlFromDatasourceByDatasetIdRequestQueryValidator);



    
    const schema = ....

    const { _id: id, ...rest } = schema;
    return fastJSONResponse(
        res,
        stringStringify,
        validateAndRespond({ id, ...rest }, stringFromJSON, stringValidator),
    );
}



/v1/datasets/{datasetId}/datasource/predictions/file

export const getPredictionFileReadUrlFromDatasourceByDatasetIdFN: RequestHandler<
    GetPredictionFileReadUrlFromDatasourceByDatasetIdRequestParams,
    string | ApiErrorResponse,
    GetPredictionFileReadUrlFromDatasourceByDatasetIdRequestBody,
    GetPredictionFileReadUrlFromDatasourceByDatasetIdRequestQuery
> = async (req, res) => {
    if (!ensureUserOnReq(req)) {
        return
    }

    const {
        
    } = await validateAndSanitizeStrict(req.body, GetPredictionFileReadUrlFromDatasourceByDatasetIdRequestBodySanitizer, GetPredictionFileReadUrlFromDatasourceByDatasetIdRequestBodyValidator);
    const {
        datasetId,
        
    } =  await validateAndSanitize(req.params, GetPredictionFileReadUrlFromDatasourceByDatasetIdRequestParamsSanitizer, GetPredictionFileReadUrlFromDatasourceByDatasetIdRequestParamsValidator);
    const {
        
        fileName,
    } = await validateAndSanitize(req.query, GetPredictionFileReadUrlFromDatasourceByDatasetIdRequestQuerySanitizer, GetPredictionFileReadUrlFromDatasourceByDatasetIdRequestQueryValidator);



    
    const schema = ....

    const { _id: id, ...rest } = schema;
    return fastJSONResponse(
        res,
        stringStringify,
        validateAndRespond({ id, ...rest }, stringFromJSON, stringValidator),
    );
}



/v1/datasets/{datasetId}/datasource/predictions/writeUrl

export const getPredictionFileWriteUrlFromDatasourceByDatasetIdFN: RequestHandler<
    GetPredictionFileWriteUrlFromDatasourceByDatasetIdRequestParams,
    string | ApiErrorResponse,
    GetPredictionFileWriteUrlFromDatasourceByDatasetIdRequestBody,
    GetPredictionFileWriteUrlFromDatasourceByDatasetIdRequestQuery
> = async (req, res) => {
    if (!ensureUserOnReq(req)) {
        return
    }

    const {
        
    } = await validateAndSanitizeStrict(req.body, GetPredictionFileWriteUrlFromDatasourceByDatasetIdRequestBodySanitizer, GetPredictionFileWriteUrlFromDatasourceByDatasetIdRequestBodyValidator);
    const {
        datasetId,
        
    } =  await validateAndSanitize(req.params, GetPredictionFileWriteUrlFromDatasourceByDatasetIdRequestParamsSanitizer, GetPredictionFileWriteUrlFromDatasourceByDatasetIdRequestParamsValidator);
    const {
        
        fileName,
    } = await validateAndSanitize(req.query, GetPredictionFileWriteUrlFromDatasourceByDatasetIdRequestQuerySanitizer, GetPredictionFileWriteUrlFromDatasourceByDatasetIdRequestQueryValidator);



    
    const schema = ....

    const { _id: id, ...rest } = schema;
    return fastJSONResponse(
        res,
        stringStringify,
        validateAndRespond({ id, ...rest }, stringFromJSON, stringValidator),
    );
}



/v1/datasets/{datasetId}/datasource/readurlRedirect

export const getResourceReadURLRedirectFN: RequestHandler<
    GetResourceReadURLRedirectRequestParams,
     | ApiErrorResponse,
    GetResourceReadURLRedirectRequestBody,
    GetResourceReadURLRedirectRequestQuery
> = async (req, res) => {
    if (!ensureUserOnReq(req)) {
        return
    }

    const {
        
    } = await validateAndSanitizeStrict(req.body, GetResourceReadURLRedirectRequestBodySanitizer, GetResourceReadURLRedirectRequestBodyValidator);
    const {
        datasetId,
        
    } =  await validateAndSanitize(req.params, GetResourceReadURLRedirectRequestParamsSanitizer, GetResourceReadURLRedirectRequestParamsValidator);
    const {
        
        path,
    } = await validateAndSanitize(req.query, GetResourceReadURLRedirectRequestQuerySanitizer, GetResourceReadURLRedirectRequestQueryValidator);



    
    const schema = ....

    const { _id: id, ...rest } = schema;
    return fastJSONResponse(
        res,
        Stringify,
        validateAndRespond({ id, ...rest }, FromJSON, Validator),
    );
}



/v1/datasets/{datasetId}/datasource

export const updateDatasourceByDatasetIdFN: RequestHandler<
    UpdateDatasourceByDatasetIdRequestParams,
     | ApiErrorResponse,
    UpdateDatasourceByDatasetIdRequestBody,
    UpdateDatasourceByDatasetIdRequestQuery
> = async (req, res) => {
    if (!ensureUserOnReq(req)) {
        return
    }

    const {
        
    } = await validateAndSanitizeStrict(req.body, UpdateDatasourceByDatasetIdRequestBodySanitizer, UpdateDatasourceByDatasetIdRequestBodyValidator);
    const {
        
        datasetId,
    } =  await validateAndSanitize(req.params, UpdateDatasourceByDatasetIdRequestParamsSanitizer, UpdateDatasourceByDatasetIdRequestParamsValidator);
    const {
        
        
    } = await validateAndSanitize(req.query, UpdateDatasourceByDatasetIdRequestQuerySanitizer, UpdateDatasourceByDatasetIdRequestQueryValidator);



    
    const schema = ....

    const { _id: id, ...rest } = schema;
    return fastJSONResponse(
        res,
        Stringify,
        validateAndRespond({ id, ...rest }, FromJSON, Validator),
    );
}



/v1/datasets/{datasetId}/datasource/processedUntilTimestamp

export const updateDatasourceProcessedUntilTimestampByDatasetIdFN: RequestHandler<
    UpdateDatasourceProcessedUntilTimestampByDatasetIdRequestParams,
     | ApiErrorResponse,
    UpdateDatasourceProcessedUntilTimestampByDatasetIdRequestBody,
    UpdateDatasourceProcessedUntilTimestampByDatasetIdRequestQuery
> = async (req, res) => {
    if (!ensureUserOnReq(req)) {
        return
    }

    const {
        
    } = await validateAndSanitizeStrict(req.body, UpdateDatasourceProcessedUntilTimestampByDatasetIdRequestBodySanitizer, UpdateDatasourceProcessedUntilTimestampByDatasetIdRequestBodyValidator);
    const {
        
        datasetId,
    } =  await validateAndSanitize(req.params, UpdateDatasourceProcessedUntilTimestampByDatasetIdRequestParamsSanitizer, UpdateDatasourceProcessedUntilTimestampByDatasetIdRequestParamsValidator);
    const {
        
        
    } = await validateAndSanitize(req.query, UpdateDatasourceProcessedUntilTimestampByDatasetIdRequestQuerySanitizer, UpdateDatasourceProcessedUntilTimestampByDatasetIdRequestQueryValidator);



    
    const schema = ....

    const { _id: id, ...rest } = schema;
    return fastJSONResponse(
        res,
        Stringify,
        validateAndRespond({ id, ...rest }, FromJSON, Validator),
    );
}



/v1/datasets/{datasetId}/datasource/verify

export const verifyDatasourceByDatasetIdFN: RequestHandler<
    VerifyDatasourceByDatasetIdRequestParams,
    DatasourceConfigVerifyData | ApiErrorResponse,
    VerifyDatasourceByDatasetIdRequestBody,
    VerifyDatasourceByDatasetIdRequestQuery
> = async (req, res) => {
    if (!ensureUserOnReq(req)) {
        return
    }

    const {
        
    } = await validateAndSanitizeStrict(req.body, VerifyDatasourceByDatasetIdRequestBodySanitizer, VerifyDatasourceByDatasetIdRequestBodyValidator);
    const {
        datasetId,
    } =  await validateAndSanitize(req.params, VerifyDatasourceByDatasetIdRequestParamsSanitizer, VerifyDatasourceByDatasetIdRequestParamsValidator);
    const {
        
    } = await validateAndSanitize(req.query, VerifyDatasourceByDatasetIdRequestQuerySanitizer, VerifyDatasourceByDatasetIdRequestQueryValidator);



    
    const schema = ....

    const { _id: id, ...rest } = schema;
    return fastJSONResponse(
        res,
        DatasourceConfigVerifyDataStringify,
        validateAndRespond({ id, ...rest }, DatasourceConfigVerifyDataFromJSON, DatasourceConfigVerifyDataValidator),
    );
}


*/
/* LIGHTLY CUSTOM END -> api */
/**
 * DatasourcesApi - interface
 *
 * @export
 * @interface DatasourcesApiInterface
 */
export interface DatasourcesApiInterface {
    /**
     * Get the GET ReadURL of a custom embedding csv file within the embeddings folder (e.g myCustomEmbedding.csv)
     * @summary Get custom embedding file ReadURL
     * @param {string} datasetId ObjectId of the dataset
     * @param {string} fileName The name of the csv file within the embeddings folder to get the GET readUrl for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatasourcesApiInterface
     */
    getCustomEmbeddingFileReadUrlFromDatasourceByDatasetIdRaw(requestParameters: GetCustomEmbeddingFileReadUrlFromDatasourceByDatasetIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>>;
    /**
     * Get the GET ReadURL of a custom embedding csv file within the embeddings folder (e.g myCustomEmbedding.csv)
     * Get custom embedding file ReadURL
     */
    getCustomEmbeddingFileReadUrlFromDatasourceByDatasetId(requestParameters: GetCustomEmbeddingFileReadUrlFromDatasourceByDatasetIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string>;
    /**
     * DEPRECATED - use getDatasourcesByDatasetId. Get the datasource of a dataset
     * @summary Get datasource by dataset id
     * @param {string} datasetId ObjectId of the dataset
     * @param {DatasourcePurpose} [purpose] Which datasource with which purpose we want to get. Defaults to INPUT_OUTPUT
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof DatasourcesApiInterface
     */
    getDatasourceByDatasetIdRaw(requestParameters: GetDatasourceByDatasetIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DatasourceConfig>>;
    /**
     * DEPRECATED - use getDatasourcesByDatasetId. Get the datasource of a dataset
     * Get datasource by dataset id
     */
    getDatasourceByDatasetId(requestParameters: GetDatasourceByDatasetIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DatasourceConfig>;
    /**
     * Get timestamp of last treated resource
     * @summary Get processed timestamp by dataset id
     * @param {string} datasetId ObjectId of the dataset
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatasourcesApiInterface
     */
    getDatasourceProcessedUntilTimestampByDatasetIdRaw(requestParameters: GetDatasourceProcessedUntilTimestampByDatasetIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DatasourceProcessedUntilTimestampResponse>>;
    /**
     * Get timestamp of last treated resource
     * Get processed timestamp by dataset id
     */
    getDatasourceProcessedUntilTimestampByDatasetId(requestParameters: GetDatasourceProcessedUntilTimestampByDatasetIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DatasourceProcessedUntilTimestampResponse>;
    /**
     * Get all the datasources of a dataset
     * @summary Get all datasources by dataset id
     * @param {string} datasetId ObjectId of the dataset
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatasourcesApiInterface
     */
    getDatasourcesByDatasetIdRaw(requestParameters: GetDatasourcesByDatasetIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<DatasourceConfig>>>;
    /**
     * Get all the datasources of a dataset
     * Get all datasources by dataset id
     */
    getDatasourcesByDatasetId(requestParameters: GetDatasourcesByDatasetIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<DatasourceConfig>>;
    /**
     * Use divide and conquer to get multiple cursors for listing the raw samples  from the datasource for a specific taskName in parallel. The cursors should be used at the endpoint getListOfRawSamplesFromDatasourceByDatasetId. There is no guarantee that the cursors returned are in order, that any cursor will return the same number of items, or that there will be more than one cursor returned.
     * @summary divide and conquer the listing of samples files into multiple cursors
     * @param {string} datasetId ObjectId of the dataset
     * @param {number} dncShards The amount of shards we should split the data into when using the divide and conquer strategy.
     * @param {number} [from] Unix timestamp, only samples with a creation date after &#x60;from&#x60; will be returned. This parameter is ignored if &#x60;cursor&#x60; is specified.
     * @param {number} [to] Unix timestamp, only samples with a creation date before &#x60;to&#x60; will be returned. This parameter is ignored if &#x60;cursor&#x60; is specified.
     * @param {string} [relevantFilenamesFileName] The name of the file within your datasource which contains a list of relevant filenames to list. See https://docs.lightly.ai/docker/getting_started/first_steps.html#specify-relevant-files for more details
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatasourcesApiInterface
     */
    getDivideAndConquerListOfRawSamplesFromDatasourceByDatasetIdRaw(requestParameters: GetDivideAndConquerListOfRawSamplesFromDatasourceByDatasetIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DivideAndConquerCursorData>>;
    /**
     * Use divide and conquer to get multiple cursors for listing the raw samples  from the datasource for a specific taskName in parallel. The cursors should be used at the endpoint getListOfRawSamplesFromDatasourceByDatasetId. There is no guarantee that the cursors returned are in order, that any cursor will return the same number of items, or that there will be more than one cursor returned.
     * divide and conquer the listing of samples files into multiple cursors
     */
    getDivideAndConquerListOfRawSamplesFromDatasourceByDatasetId(requestParameters: GetDivideAndConquerListOfRawSamplesFromDatasourceByDatasetIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DivideAndConquerCursorData>;
    /**
     * Use divide and conquer to get multiple cursors for listing the raw samples metadata from the datasource for a specific taskName in parallel. The cursors should be used at the endpoint getListOfRawSamplesMetadataFromDatasourceByDatasetId. There is no guarantee that the cursors returned are in order, that any cursor will return the same number of items, or that there will be more than one cursor returned.
     * @summary divide and conquer the listing of metadata files into multiple cursors
     * @param {string} datasetId ObjectId of the dataset
     * @param {number} dncShards The amount of shards we should split the data into when using the divide and conquer strategy.
     * @param {number} [from] Unix timestamp, only samples with a creation date after &#x60;from&#x60; will be returned. This parameter is ignored if &#x60;cursor&#x60; is specified.
     * @param {number} [to] Unix timestamp, only samples with a creation date before &#x60;to&#x60; will be returned. This parameter is ignored if &#x60;cursor&#x60; is specified.
     * @param {string} [relevantFilenamesFileName] The name of the file within your datasource which contains a list of relevant filenames to list. See https://docs.lightly.ai/docker/getting_started/first_steps.html#specify-relevant-files for more details
     * @param {string} [relevantFilenamesRunId] The run id of the run which generated an artifact to be used as the relevant filenames file. (see DatasourceRelevantFilenamesArtifactIdParam)
     * @param {string} [relevantFilenamesArtifactId] The artifact id of the run provided by DatasourceRelevantFilenamesRunIdParam to be used as the relevant filenames file.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatasourcesApiInterface
     */
    getDivideAndConquerListOfRawSamplesMetadataFromDatasourceByDatasetIdRaw(requestParameters: GetDivideAndConquerListOfRawSamplesMetadataFromDatasourceByDatasetIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DivideAndConquerCursorData>>;
    /**
     * Use divide and conquer to get multiple cursors for listing the raw samples metadata from the datasource for a specific taskName in parallel. The cursors should be used at the endpoint getListOfRawSamplesMetadataFromDatasourceByDatasetId. There is no guarantee that the cursors returned are in order, that any cursor will return the same number of items, or that there will be more than one cursor returned.
     * divide and conquer the listing of metadata files into multiple cursors
     */
    getDivideAndConquerListOfRawSamplesMetadataFromDatasourceByDatasetId(requestParameters: GetDivideAndConquerListOfRawSamplesMetadataFromDatasourceByDatasetIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DivideAndConquerCursorData>;
    /**
     * Use divide and conquer to get multiple cursors for listing the raw samples predictions from the datasource for a specific taskName in parallel. The cursors should be used at the endpoint getListOfRawSamplesPredictionsFromDatasourceByDatasetId. There is no guarantee that the cursors returned are in order, that any cursor will return the same number of items, or that there will be more than one cursor returned.
     * @summary divide and conquer the listing of predictions files into multiple cursors
     * @param {string} datasetId ObjectId of the dataset
     * @param {string} taskName The prediction task name for which one wants to list the predictions
     * @param {number} dncShards The amount of shards we should split the data into when using the divide and conquer strategy.
     * @param {number} [from] Unix timestamp, only samples with a creation date after &#x60;from&#x60; will be returned. This parameter is ignored if &#x60;cursor&#x60; is specified.
     * @param {number} [to] Unix timestamp, only samples with a creation date before &#x60;to&#x60; will be returned. This parameter is ignored if &#x60;cursor&#x60; is specified.
     * @param {string} [relevantFilenamesFileName] The name of the file within your datasource which contains a list of relevant filenames to list. See https://docs.lightly.ai/docker/getting_started/first_steps.html#specify-relevant-files for more details
     * @param {string} [relevantFilenamesRunId] The run id of the run which generated an artifact to be used as the relevant filenames file. (see DatasourceRelevantFilenamesArtifactIdParam)
     * @param {string} [relevantFilenamesArtifactId] The artifact id of the run provided by DatasourceRelevantFilenamesRunIdParam to be used as the relevant filenames file.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatasourcesApiInterface
     */
    getDivideAndConquerListOfRawSamplesPredictionsFromDatasourceByDatasetIdRaw(requestParameters: GetDivideAndConquerListOfRawSamplesPredictionsFromDatasourceByDatasetIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DivideAndConquerCursorData>>;
    /**
     * Use divide and conquer to get multiple cursors for listing the raw samples predictions from the datasource for a specific taskName in parallel. The cursors should be used at the endpoint getListOfRawSamplesPredictionsFromDatasourceByDatasetId. There is no guarantee that the cursors returned are in order, that any cursor will return the same number of items, or that there will be more than one cursor returned.
     * divide and conquer the listing of predictions files into multiple cursors
     */
    getDivideAndConquerListOfRawSamplesPredictionsFromDatasourceByDatasetId(requestParameters: GetDivideAndConquerListOfRawSamplesPredictionsFromDatasourceByDatasetIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DivideAndConquerCursorData>;
    /**
     * Get a HEAD ReadURL of a file within datasources. Can only be used for HEAD request, no GET requests.
     * @summary Get HEAD ReadURL of file
     * @param {string} datasetId ObjectId of the dataset
     * @param {string} fileName The name of the file within the the datasource to get a HEAD readUrl or GET readURL
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatasourcesApiInterface
     */
    getHEADFileReadUrlFromDatasourceByDatasetIdRaw(requestParameters: GetHEADFileReadUrlFromDatasourceByDatasetIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>>;
    /**
     * Get a HEAD ReadURL of a file within datasources. Can only be used for HEAD request, no GET requests.
     * Get HEAD ReadURL of file
     */
    getHEADFileReadUrlFromDatasourceByDatasetId(requestParameters: GetHEADFileReadUrlFromDatasourceByDatasetIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string>;
    /**
     * Get list of raw samples from datasource
     * @summary list samples from datasource
     * @param {string} datasetId ObjectId of the dataset
     * @param {number} [from] Unix timestamp, only samples with a creation date after &#x60;from&#x60; will be returned. This parameter is ignored if &#x60;cursor&#x60; is specified.
     * @param {number} [to] Unix timestamp, only samples with a creation date before &#x60;to&#x60; will be returned. This parameter is ignored if &#x60;cursor&#x60; is specified.
     * @param {string} [cursor] Cursor from previous request, encodes &#x60;from&#x60; and &#x60;to&#x60; parameters. Specify to continue reading samples from the list.
     * @param {boolean} [useRedirectedReadUrl] By default this is set to false unless a S3DelegatedAccess is configured in which case its always true and this param has no effect. When true this will return RedirectedReadUrls instead of ReadUrls meaning that  returned URLs allow for unlimited access to the file
     * @param {string} [relevantFilenamesFileName] The name of the file within your datasource which contains a list of relevant filenames to list. See https://docs.lightly.ai/docker/getting_started/first_steps.html#specify-relevant-files for more details
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatasourcesApiInterface
     */
    getListOfRawSamplesFromDatasourceByDatasetIdRaw(requestParameters: GetListOfRawSamplesFromDatasourceByDatasetIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DatasourceRawSamplesData>>;
    /**
     * Get list of raw samples from datasource
     * list samples from datasource
     */
    getListOfRawSamplesFromDatasourceByDatasetId(requestParameters: GetListOfRawSamplesFromDatasourceByDatasetIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DatasourceRawSamplesData>;
    /**
     * Get list of the raw samples metadata from datasource for a specific taskName
     * @summary list metadata files
     * @param {string} datasetId ObjectId of the dataset
     * @param {number} [from] Unix timestamp, only samples with a creation date after &#x60;from&#x60; will be returned. This parameter is ignored if &#x60;cursor&#x60; is specified.
     * @param {number} [to] Unix timestamp, only samples with a creation date before &#x60;to&#x60; will be returned. This parameter is ignored if &#x60;cursor&#x60; is specified.
     * @param {string} [cursor] Cursor from previous request, encodes &#x60;from&#x60; and &#x60;to&#x60; parameters. Specify to continue reading samples from the list.
     * @param {boolean} [useRedirectedReadUrl] By default this is set to false unless a S3DelegatedAccess is configured in which case its always true and this param has no effect. When true this will return RedirectedReadUrls instead of ReadUrls meaning that  returned URLs allow for unlimited access to the file
     * @param {string} [relevantFilenamesFileName] The name of the file within your datasource which contains a list of relevant filenames to list. See https://docs.lightly.ai/docker/getting_started/first_steps.html#specify-relevant-files for more details
     * @param {string} [relevantFilenamesRunId] The run id of the run which generated an artifact to be used as the relevant filenames file. (see DatasourceRelevantFilenamesArtifactIdParam)
     * @param {string} [relevantFilenamesArtifactId] The artifact id of the run provided by DatasourceRelevantFilenamesRunIdParam to be used as the relevant filenames file.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatasourcesApiInterface
     */
    getListOfRawSamplesMetadataFromDatasourceByDatasetIdRaw(requestParameters: GetListOfRawSamplesMetadataFromDatasourceByDatasetIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DatasourceRawSamplesMetadataData>>;
    /**
     * Get list of the raw samples metadata from datasource for a specific taskName
     * list metadata files
     */
    getListOfRawSamplesMetadataFromDatasourceByDatasetId(requestParameters: GetListOfRawSamplesMetadataFromDatasourceByDatasetIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DatasourceRawSamplesMetadataData>;
    /**
     * Get list of the raw samples predictions from datasource for a specific taskName
     * @summary Get list of raw samples predictions
     * @param {string} datasetId ObjectId of the dataset
     * @param {string} taskName The prediction task name for which one wants to list the predictions
     * @param {number} [from] Unix timestamp, only samples with a creation date after &#x60;from&#x60; will be returned. This parameter is ignored if &#x60;cursor&#x60; is specified.
     * @param {number} [to] Unix timestamp, only samples with a creation date before &#x60;to&#x60; will be returned. This parameter is ignored if &#x60;cursor&#x60; is specified.
     * @param {string} [cursor] Cursor from previous request, encodes &#x60;from&#x60; and &#x60;to&#x60; parameters. Specify to continue reading samples from the list.
     * @param {boolean} [useRedirectedReadUrl] By default this is set to false unless a S3DelegatedAccess is configured in which case its always true and this param has no effect. When true this will return RedirectedReadUrls instead of ReadUrls meaning that  returned URLs allow for unlimited access to the file
     * @param {string} [relevantFilenamesFileName] The name of the file within your datasource which contains a list of relevant filenames to list. See https://docs.lightly.ai/docker/getting_started/first_steps.html#specify-relevant-files for more details
     * @param {string} [relevantFilenamesRunId] The run id of the run which generated an artifact to be used as the relevant filenames file. (see DatasourceRelevantFilenamesArtifactIdParam)
     * @param {string} [relevantFilenamesArtifactId] The artifact id of the run provided by DatasourceRelevantFilenamesRunIdParam to be used as the relevant filenames file.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatasourcesApiInterface
     */
    getListOfRawSamplesPredictionsFromDatasourceByDatasetIdRaw(requestParameters: GetListOfRawSamplesPredictionsFromDatasourceByDatasetIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DatasourceRawSamplesPredictionsData>>;
    /**
     * Get list of the raw samples predictions from datasource for a specific taskName
     * Get list of raw samples predictions
     */
    getListOfRawSamplesPredictionsFromDatasourceByDatasetId(requestParameters: GetListOfRawSamplesPredictionsFromDatasourceByDatasetIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DatasourceRawSamplesPredictionsData>;
    /**
     * Get the GET ReadURL of a file within the metadata folder (e.g. my_image.json or my_video-099-mp4.json)
     * @summary Get metadata file ReadURL
     * @param {string} datasetId ObjectId of the dataset
     * @param {string} fileName The name of the file within the metadata folder to get the GET readUrl for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatasourcesApiInterface
     */
    getMetadataFileReadUrlFromDatasourceByDatasetIdRaw(requestParameters: GetMetadataFileReadUrlFromDatasourceByDatasetIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>>;
    /**
     * Get the GET ReadURL of a file within the metadata folder (e.g. my_image.json or my_video-099-mp4.json)
     * Get metadata file ReadURL
     */
    getMetadataFileReadUrlFromDatasourceByDatasetId(requestParameters: GetMetadataFileReadUrlFromDatasourceByDatasetIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string>;
    /**
     * Get the GET ReadURL of a file within the predictions folder (e.g tasks.json or my_classification_task/schema.json)
     * @summary Get prediction file readURL
     * @param {string} datasetId ObjectId of the dataset
     * @param {string} fileName The name of the file within the prediction folder to get the GET readUrl for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatasourcesApiInterface
     */
    getPredictionFileReadUrlFromDatasourceByDatasetIdRaw(requestParameters: GetPredictionFileReadUrlFromDatasourceByDatasetIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>>;
    /**
     * Get the GET ReadURL of a file within the predictions folder (e.g tasks.json or my_classification_task/schema.json)
     * Get prediction file readURL
     */
    getPredictionFileReadUrlFromDatasourceByDatasetId(requestParameters: GetPredictionFileReadUrlFromDatasourceByDatasetIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string>;
    /**
     * Get the WriteURL of a file within the predictions folder (e.g tasks.json or my_classification_task/schema.json)
     * @summary Get prediction file writeURL
     * @param {string} datasetId ObjectId of the dataset
     * @param {string} fileName The name of the file within the prediction folder to get the GET readUrl for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatasourcesApiInterface
     */
    getPredictionFileWriteUrlFromDatasourceByDatasetIdRaw(requestParameters: GetPredictionFileWriteUrlFromDatasourceByDatasetIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>>;
    /**
     * Get the WriteURL of a file within the predictions folder (e.g tasks.json or my_classification_task/schema.json)
     * Get prediction file writeURL
     */
    getPredictionFileWriteUrlFromDatasourceByDatasetId(requestParameters: GetPredictionFileWriteUrlFromDatasourceByDatasetIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string>;
    /**
     * This endpoint enables anyone given the correct credentials to access the actual image directly via a redirect. By creating a readURL for the resource and redirecting to that URL, the client can use this endpoint to always have a way to access the resource as there is no expiration
     * @summary Get resource read URL redirect
     * @param {string} datasetId ObjectId of the dataset
     * @param {string} path the resource path
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatasourcesApiInterface
     */
    getResourceReadURLRedirectRaw(requestParameters: GetResourceReadURLRedirectRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;
    /**
     * This endpoint enables anyone given the correct credentials to access the actual image directly via a redirect. By creating a readURL for the resource and redirecting to that URL, the client can use this endpoint to always have a way to access the resource as there is no expiration
     * Get resource read URL redirect
     */
    getResourceReadURLRedirect(requestParameters: GetResourceReadURLRedirectRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;
    /**
     * Update the datasource of a specific dataset
     * @summary Update datasource by dataset id
     * @param {DatasourceConfig} datasourceConfig updated datasource configuration for a dataset
     * @param {string} datasetId ObjectId of the dataset
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatasourcesApiInterface
     */
    updateDatasourceByDatasetIdRaw(requestParameters: UpdateDatasourceByDatasetIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;
    /**
     * Update the datasource of a specific dataset
     * Update datasource by dataset id
     */
    updateDatasourceByDatasetId(requestParameters: UpdateDatasourceByDatasetIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;
    /**
     * Update timestamp of last resource in datapool
     * @summary Update processed timestamp by dataset id
     * @param {DatasourceProcessedUntilTimestampRequest} datasourceProcessedUntilTimestampRequest The updated timestamp to set
     * @param {string} datasetId ObjectId of the dataset
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatasourcesApiInterface
     */
    updateDatasourceProcessedUntilTimestampByDatasetIdRaw(requestParameters: UpdateDatasourceProcessedUntilTimestampByDatasetIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;
    /**
     * Update timestamp of last resource in datapool
     * Update processed timestamp by dataset id
     */
    updateDatasourceProcessedUntilTimestampByDatasetId(requestParameters: UpdateDatasourceProcessedUntilTimestampByDatasetIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;
    /**
     * Test and verify that the configured datasource can be accessed correctly
     * @summary Verify datasource by dataset id
     * @param {string} datasetId ObjectId of the dataset
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatasourcesApiInterface
     */
    verifyDatasourceByDatasetIdRaw(requestParameters: VerifyDatasourceByDatasetIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DatasourceConfigVerifyData>>;
    /**
     * Test and verify that the configured datasource can be accessed correctly
     * Verify datasource by dataset id
     */
    verifyDatasourceByDatasetId(requestParameters: VerifyDatasourceByDatasetIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DatasourceConfigVerifyData>;
}
/**
 *
 */
export class DatasourcesApi extends runtime.BaseAPI implements DatasourcesApiInterface {
    /**
     * Get the GET ReadURL of a custom embedding csv file within the embeddings folder (e.g myCustomEmbedding.csv)
     * Get custom embedding file ReadURL
     */
    async getCustomEmbeddingFileReadUrlFromDatasourceByDatasetIdRaw(requestParameters: GetCustomEmbeddingFileReadUrlFromDatasourceByDatasetIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters.datasetId === null || requestParameters.datasetId === undefined) {
            throw new runtime.RequiredError('datasetId', 'Required parameter requestParameters.datasetId was null or undefined when calling getCustomEmbeddingFileReadUrlFromDatasourceByDatasetId.');
        }
        if (requestParameters.fileName === null || requestParameters.fileName === undefined) {
            throw new runtime.RequiredError('fileName', 'Required parameter requestParameters.fileName was null or undefined when calling getCustomEmbeddingFileReadUrlFromDatasourceByDatasetId.');
        }
        const queryParameters: any = {};
        if (requestParameters.fileName !== undefined) {
            queryParameters['fileName'] = requestParameters.fileName;
        }
        const headerParameters: runtime.HTTPHeaders = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("auth0Bearer", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["token"] = this.configuration.apiKey("token"); // ApiKeyAuth authentication
        }
        const response = await this.request({
            path: `/v1/datasets/{datasetId}/datasource/embeddings/file`.replace(`{${"datasetId"}}`, encodeURIComponent(String(requestParameters.datasetId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.TextApiResponse(response) as any;
    }
    /**
     * Get the GET ReadURL of a custom embedding csv file within the embeddings folder (e.g myCustomEmbedding.csv)
     * Get custom embedding file ReadURL
     */
    async getCustomEmbeddingFileReadUrlFromDatasourceByDatasetId(requestParameters: GetCustomEmbeddingFileReadUrlFromDatasourceByDatasetIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.getCustomEmbeddingFileReadUrlFromDatasourceByDatasetIdRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * DEPRECATED - use getDatasourcesByDatasetId. Get the datasource of a dataset
     * Get datasource by dataset id
     */
    async getDatasourceByDatasetIdRaw(requestParameters: GetDatasourceByDatasetIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DatasourceConfig>> {
        if (requestParameters.datasetId === null || requestParameters.datasetId === undefined) {
            throw new runtime.RequiredError('datasetId', 'Required parameter requestParameters.datasetId was null or undefined when calling getDatasourceByDatasetId.');
        }
        const queryParameters: any = {};
        if (requestParameters.purpose !== undefined) {
            queryParameters['purpose'] = requestParameters.purpose;
        }
        const headerParameters: runtime.HTTPHeaders = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("auth0Bearer", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["token"] = this.configuration.apiKey("token"); // ApiKeyAuth authentication
        }
        const response = await this.request({
            path: `/v1/datasets/{datasetId}/datasource`.replace(`{${"datasetId"}}`, encodeURIComponent(String(requestParameters.datasetId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => DatasourceConfigFromJSON(jsonValue));
    }
    /**
     * DEPRECATED - use getDatasourcesByDatasetId. Get the datasource of a dataset
     * Get datasource by dataset id
     */
    async getDatasourceByDatasetId(requestParameters: GetDatasourceByDatasetIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DatasourceConfig> {
        const response = await this.getDatasourceByDatasetIdRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get timestamp of last treated resource
     * Get processed timestamp by dataset id
     */
    async getDatasourceProcessedUntilTimestampByDatasetIdRaw(requestParameters: GetDatasourceProcessedUntilTimestampByDatasetIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DatasourceProcessedUntilTimestampResponse>> {
        if (requestParameters.datasetId === null || requestParameters.datasetId === undefined) {
            throw new runtime.RequiredError('datasetId', 'Required parameter requestParameters.datasetId was null or undefined when calling getDatasourceProcessedUntilTimestampByDatasetId.');
        }
        const queryParameters: any = {};
        const headerParameters: runtime.HTTPHeaders = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("auth0Bearer", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["token"] = this.configuration.apiKey("token"); // ApiKeyAuth authentication
        }
        const response = await this.request({
            path: `/v1/datasets/{datasetId}/datasource/processedUntilTimestamp`.replace(`{${"datasetId"}}`, encodeURIComponent(String(requestParameters.datasetId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => DatasourceProcessedUntilTimestampResponseFromJSON(jsonValue));
    }
    /**
     * Get timestamp of last treated resource
     * Get processed timestamp by dataset id
     */
    async getDatasourceProcessedUntilTimestampByDatasetId(requestParameters: GetDatasourceProcessedUntilTimestampByDatasetIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DatasourceProcessedUntilTimestampResponse> {
        const response = await this.getDatasourceProcessedUntilTimestampByDatasetIdRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get all the datasources of a dataset
     * Get all datasources by dataset id
     */
    async getDatasourcesByDatasetIdRaw(requestParameters: GetDatasourcesByDatasetIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<DatasourceConfig>>> {
        if (requestParameters.datasetId === null || requestParameters.datasetId === undefined) {
            throw new runtime.RequiredError('datasetId', 'Required parameter requestParameters.datasetId was null or undefined when calling getDatasourcesByDatasetId.');
        }
        const queryParameters: any = {};
        const headerParameters: runtime.HTTPHeaders = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("auth0Bearer", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["token"] = this.configuration.apiKey("token"); // ApiKeyAuth authentication
        }
        const response = await this.request({
            path: `/v1/datasets/{datasetId}/datasource/all`.replace(`{${"datasetId"}}`, encodeURIComponent(String(requestParameters.datasetId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(DatasourceConfigFromJSON));
    }
    /**
     * Get all the datasources of a dataset
     * Get all datasources by dataset id
     */
    async getDatasourcesByDatasetId(requestParameters: GetDatasourcesByDatasetIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<DatasourceConfig>> {
        const response = await this.getDatasourcesByDatasetIdRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Use divide and conquer to get multiple cursors for listing the raw samples  from the datasource for a specific taskName in parallel. The cursors should be used at the endpoint getListOfRawSamplesFromDatasourceByDatasetId. There is no guarantee that the cursors returned are in order, that any cursor will return the same number of items, or that there will be more than one cursor returned.
     * divide and conquer the listing of samples files into multiple cursors
     */
    async getDivideAndConquerListOfRawSamplesFromDatasourceByDatasetIdRaw(requestParameters: GetDivideAndConquerListOfRawSamplesFromDatasourceByDatasetIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DivideAndConquerCursorData>> {
        if (requestParameters.datasetId === null || requestParameters.datasetId === undefined) {
            throw new runtime.RequiredError('datasetId', 'Required parameter requestParameters.datasetId was null or undefined when calling getDivideAndConquerListOfRawSamplesFromDatasourceByDatasetId.');
        }
        if (requestParameters.dncShards === null || requestParameters.dncShards === undefined) {
            throw new runtime.RequiredError('dncShards', 'Required parameter requestParameters.dncShards was null or undefined when calling getDivideAndConquerListOfRawSamplesFromDatasourceByDatasetId.');
        }
        const queryParameters: any = {};
        if (requestParameters.from !== undefined) {
            queryParameters['from'] = requestParameters.from;
        }
        if (requestParameters.to !== undefined) {
            queryParameters['to'] = requestParameters.to;
        }
        if (requestParameters.relevantFilenamesFileName !== undefined) {
            queryParameters['relevantFilenamesFileName'] = requestParameters.relevantFilenamesFileName;
        }
        if (requestParameters.dncShards !== undefined) {
            queryParameters['dncShards'] = requestParameters.dncShards;
        }
        const headerParameters: runtime.HTTPHeaders = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("auth0Bearer", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["token"] = this.configuration.apiKey("token"); // ApiKeyAuth authentication
        }
        const response = await this.request({
            path: `/v1/datasets/{datasetId}/datasource/list/dnc`.replace(`{${"datasetId"}}`, encodeURIComponent(String(requestParameters.datasetId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => DivideAndConquerCursorDataFromJSON(jsonValue));
    }
    /**
     * Use divide and conquer to get multiple cursors for listing the raw samples  from the datasource for a specific taskName in parallel. The cursors should be used at the endpoint getListOfRawSamplesFromDatasourceByDatasetId. There is no guarantee that the cursors returned are in order, that any cursor will return the same number of items, or that there will be more than one cursor returned.
     * divide and conquer the listing of samples files into multiple cursors
     */
    async getDivideAndConquerListOfRawSamplesFromDatasourceByDatasetId(requestParameters: GetDivideAndConquerListOfRawSamplesFromDatasourceByDatasetIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DivideAndConquerCursorData> {
        const response = await this.getDivideAndConquerListOfRawSamplesFromDatasourceByDatasetIdRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Use divide and conquer to get multiple cursors for listing the raw samples metadata from the datasource for a specific taskName in parallel. The cursors should be used at the endpoint getListOfRawSamplesMetadataFromDatasourceByDatasetId. There is no guarantee that the cursors returned are in order, that any cursor will return the same number of items, or that there will be more than one cursor returned.
     * divide and conquer the listing of metadata files into multiple cursors
     */
    async getDivideAndConquerListOfRawSamplesMetadataFromDatasourceByDatasetIdRaw(requestParameters: GetDivideAndConquerListOfRawSamplesMetadataFromDatasourceByDatasetIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DivideAndConquerCursorData>> {
        if (requestParameters.datasetId === null || requestParameters.datasetId === undefined) {
            throw new runtime.RequiredError('datasetId', 'Required parameter requestParameters.datasetId was null or undefined when calling getDivideAndConquerListOfRawSamplesMetadataFromDatasourceByDatasetId.');
        }
        if (requestParameters.dncShards === null || requestParameters.dncShards === undefined) {
            throw new runtime.RequiredError('dncShards', 'Required parameter requestParameters.dncShards was null or undefined when calling getDivideAndConquerListOfRawSamplesMetadataFromDatasourceByDatasetId.');
        }
        const queryParameters: any = {};
        if (requestParameters.from !== undefined) {
            queryParameters['from'] = requestParameters.from;
        }
        if (requestParameters.to !== undefined) {
            queryParameters['to'] = requestParameters.to;
        }
        if (requestParameters.relevantFilenamesFileName !== undefined) {
            queryParameters['relevantFilenamesFileName'] = requestParameters.relevantFilenamesFileName;
        }
        if (requestParameters.relevantFilenamesRunId !== undefined) {
            queryParameters['relevantFilenamesRunId'] = requestParameters.relevantFilenamesRunId;
        }
        if (requestParameters.relevantFilenamesArtifactId !== undefined) {
            queryParameters['relevantFilenamesArtifactId'] = requestParameters.relevantFilenamesArtifactId;
        }
        if (requestParameters.dncShards !== undefined) {
            queryParameters['dncShards'] = requestParameters.dncShards;
        }
        const headerParameters: runtime.HTTPHeaders = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("auth0Bearer", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["token"] = this.configuration.apiKey("token"); // ApiKeyAuth authentication
        }
        const response = await this.request({
            path: `/v1/datasets/{datasetId}/datasource/metadata/list/dnc`.replace(`{${"datasetId"}}`, encodeURIComponent(String(requestParameters.datasetId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => DivideAndConquerCursorDataFromJSON(jsonValue));
    }
    /**
     * Use divide and conquer to get multiple cursors for listing the raw samples metadata from the datasource for a specific taskName in parallel. The cursors should be used at the endpoint getListOfRawSamplesMetadataFromDatasourceByDatasetId. There is no guarantee that the cursors returned are in order, that any cursor will return the same number of items, or that there will be more than one cursor returned.
     * divide and conquer the listing of metadata files into multiple cursors
     */
    async getDivideAndConquerListOfRawSamplesMetadataFromDatasourceByDatasetId(requestParameters: GetDivideAndConquerListOfRawSamplesMetadataFromDatasourceByDatasetIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DivideAndConquerCursorData> {
        const response = await this.getDivideAndConquerListOfRawSamplesMetadataFromDatasourceByDatasetIdRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Use divide and conquer to get multiple cursors for listing the raw samples predictions from the datasource for a specific taskName in parallel. The cursors should be used at the endpoint getListOfRawSamplesPredictionsFromDatasourceByDatasetId. There is no guarantee that the cursors returned are in order, that any cursor will return the same number of items, or that there will be more than one cursor returned.
     * divide and conquer the listing of predictions files into multiple cursors
     */
    async getDivideAndConquerListOfRawSamplesPredictionsFromDatasourceByDatasetIdRaw(requestParameters: GetDivideAndConquerListOfRawSamplesPredictionsFromDatasourceByDatasetIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DivideAndConquerCursorData>> {
        if (requestParameters.datasetId === null || requestParameters.datasetId === undefined) {
            throw new runtime.RequiredError('datasetId', 'Required parameter requestParameters.datasetId was null or undefined when calling getDivideAndConquerListOfRawSamplesPredictionsFromDatasourceByDatasetId.');
        }
        if (requestParameters.taskName === null || requestParameters.taskName === undefined) {
            throw new runtime.RequiredError('taskName', 'Required parameter requestParameters.taskName was null or undefined when calling getDivideAndConquerListOfRawSamplesPredictionsFromDatasourceByDatasetId.');
        }
        if (requestParameters.dncShards === null || requestParameters.dncShards === undefined) {
            throw new runtime.RequiredError('dncShards', 'Required parameter requestParameters.dncShards was null or undefined when calling getDivideAndConquerListOfRawSamplesPredictionsFromDatasourceByDatasetId.');
        }
        const queryParameters: any = {};
        if (requestParameters.taskName !== undefined) {
            queryParameters['taskName'] = requestParameters.taskName;
        }
        if (requestParameters.from !== undefined) {
            queryParameters['from'] = requestParameters.from;
        }
        if (requestParameters.to !== undefined) {
            queryParameters['to'] = requestParameters.to;
        }
        if (requestParameters.relevantFilenamesFileName !== undefined) {
            queryParameters['relevantFilenamesFileName'] = requestParameters.relevantFilenamesFileName;
        }
        if (requestParameters.relevantFilenamesRunId !== undefined) {
            queryParameters['relevantFilenamesRunId'] = requestParameters.relevantFilenamesRunId;
        }
        if (requestParameters.relevantFilenamesArtifactId !== undefined) {
            queryParameters['relevantFilenamesArtifactId'] = requestParameters.relevantFilenamesArtifactId;
        }
        if (requestParameters.dncShards !== undefined) {
            queryParameters['dncShards'] = requestParameters.dncShards;
        }
        const headerParameters: runtime.HTTPHeaders = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("auth0Bearer", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["token"] = this.configuration.apiKey("token"); // ApiKeyAuth authentication
        }
        const response = await this.request({
            path: `/v1/datasets/{datasetId}/datasource/predictions/list/dnc`.replace(`{${"datasetId"}}`, encodeURIComponent(String(requestParameters.datasetId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => DivideAndConquerCursorDataFromJSON(jsonValue));
    }
    /**
     * Use divide and conquer to get multiple cursors for listing the raw samples predictions from the datasource for a specific taskName in parallel. The cursors should be used at the endpoint getListOfRawSamplesPredictionsFromDatasourceByDatasetId. There is no guarantee that the cursors returned are in order, that any cursor will return the same number of items, or that there will be more than one cursor returned.
     * divide and conquer the listing of predictions files into multiple cursors
     */
    async getDivideAndConquerListOfRawSamplesPredictionsFromDatasourceByDatasetId(requestParameters: GetDivideAndConquerListOfRawSamplesPredictionsFromDatasourceByDatasetIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DivideAndConquerCursorData> {
        const response = await this.getDivideAndConquerListOfRawSamplesPredictionsFromDatasourceByDatasetIdRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get a HEAD ReadURL of a file within datasources. Can only be used for HEAD request, no GET requests.
     * Get HEAD ReadURL of file
     */
    async getHEADFileReadUrlFromDatasourceByDatasetIdRaw(requestParameters: GetHEADFileReadUrlFromDatasourceByDatasetIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters.datasetId === null || requestParameters.datasetId === undefined) {
            throw new runtime.RequiredError('datasetId', 'Required parameter requestParameters.datasetId was null or undefined when calling getHEADFileReadUrlFromDatasourceByDatasetId.');
        }
        if (requestParameters.fileName === null || requestParameters.fileName === undefined) {
            throw new runtime.RequiredError('fileName', 'Required parameter requestParameters.fileName was null or undefined when calling getHEADFileReadUrlFromDatasourceByDatasetId.');
        }
        const queryParameters: any = {};
        if (requestParameters.fileName !== undefined) {
            queryParameters['fileName'] = requestParameters.fileName;
        }
        const headerParameters: runtime.HTTPHeaders = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("auth0Bearer", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["token"] = this.configuration.apiKey("token"); // ApiKeyAuth authentication
        }
        const response = await this.request({
            path: `/v1/datasets/{datasetId}/datasource/fileHEAD`.replace(`{${"datasetId"}}`, encodeURIComponent(String(requestParameters.datasetId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.TextApiResponse(response) as any;
    }
    /**
     * Get a HEAD ReadURL of a file within datasources. Can only be used for HEAD request, no GET requests.
     * Get HEAD ReadURL of file
     */
    async getHEADFileReadUrlFromDatasourceByDatasetId(requestParameters: GetHEADFileReadUrlFromDatasourceByDatasetIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.getHEADFileReadUrlFromDatasourceByDatasetIdRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get list of raw samples from datasource
     * list samples from datasource
     */
    async getListOfRawSamplesFromDatasourceByDatasetIdRaw(requestParameters: GetListOfRawSamplesFromDatasourceByDatasetIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DatasourceRawSamplesData>> {
        if (requestParameters.datasetId === null || requestParameters.datasetId === undefined) {
            throw new runtime.RequiredError('datasetId', 'Required parameter requestParameters.datasetId was null or undefined when calling getListOfRawSamplesFromDatasourceByDatasetId.');
        }
        const queryParameters: any = {};
        if (requestParameters.from !== undefined) {
            queryParameters['from'] = requestParameters.from;
        }
        if (requestParameters.to !== undefined) {
            queryParameters['to'] = requestParameters.to;
        }
        if (requestParameters.cursor !== undefined) {
            queryParameters['cursor'] = requestParameters.cursor;
        }
        if (requestParameters.useRedirectedReadUrl !== undefined) {
            queryParameters['useRedirectedReadUrl'] = requestParameters.useRedirectedReadUrl;
        }
        if (requestParameters.relevantFilenamesFileName !== undefined) {
            queryParameters['relevantFilenamesFileName'] = requestParameters.relevantFilenamesFileName;
        }
        const headerParameters: runtime.HTTPHeaders = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("auth0Bearer", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["token"] = this.configuration.apiKey("token"); // ApiKeyAuth authentication
        }
        const response = await this.request({
            path: `/v1/datasets/{datasetId}/datasource/list`.replace(`{${"datasetId"}}`, encodeURIComponent(String(requestParameters.datasetId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => DatasourceRawSamplesDataFromJSON(jsonValue));
    }
    /**
     * Get list of raw samples from datasource
     * list samples from datasource
     */
    async getListOfRawSamplesFromDatasourceByDatasetId(requestParameters: GetListOfRawSamplesFromDatasourceByDatasetIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DatasourceRawSamplesData> {
        const response = await this.getListOfRawSamplesFromDatasourceByDatasetIdRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get list of the raw samples metadata from datasource for a specific taskName
     * list metadata files
     */
    async getListOfRawSamplesMetadataFromDatasourceByDatasetIdRaw(requestParameters: GetListOfRawSamplesMetadataFromDatasourceByDatasetIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DatasourceRawSamplesMetadataData>> {
        if (requestParameters.datasetId === null || requestParameters.datasetId === undefined) {
            throw new runtime.RequiredError('datasetId', 'Required parameter requestParameters.datasetId was null or undefined when calling getListOfRawSamplesMetadataFromDatasourceByDatasetId.');
        }
        const queryParameters: any = {};
        if (requestParameters.from !== undefined) {
            queryParameters['from'] = requestParameters.from;
        }
        if (requestParameters.to !== undefined) {
            queryParameters['to'] = requestParameters.to;
        }
        if (requestParameters.cursor !== undefined) {
            queryParameters['cursor'] = requestParameters.cursor;
        }
        if (requestParameters.useRedirectedReadUrl !== undefined) {
            queryParameters['useRedirectedReadUrl'] = requestParameters.useRedirectedReadUrl;
        }
        if (requestParameters.relevantFilenamesFileName !== undefined) {
            queryParameters['relevantFilenamesFileName'] = requestParameters.relevantFilenamesFileName;
        }
        if (requestParameters.relevantFilenamesRunId !== undefined) {
            queryParameters['relevantFilenamesRunId'] = requestParameters.relevantFilenamesRunId;
        }
        if (requestParameters.relevantFilenamesArtifactId !== undefined) {
            queryParameters['relevantFilenamesArtifactId'] = requestParameters.relevantFilenamesArtifactId;
        }
        const headerParameters: runtime.HTTPHeaders = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("auth0Bearer", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["token"] = this.configuration.apiKey("token"); // ApiKeyAuth authentication
        }
        const response = await this.request({
            path: `/v1/datasets/{datasetId}/datasource/metadata/list`.replace(`{${"datasetId"}}`, encodeURIComponent(String(requestParameters.datasetId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => DatasourceRawSamplesMetadataDataFromJSON(jsonValue));
    }
    /**
     * Get list of the raw samples metadata from datasource for a specific taskName
     * list metadata files
     */
    async getListOfRawSamplesMetadataFromDatasourceByDatasetId(requestParameters: GetListOfRawSamplesMetadataFromDatasourceByDatasetIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DatasourceRawSamplesMetadataData> {
        const response = await this.getListOfRawSamplesMetadataFromDatasourceByDatasetIdRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get list of the raw samples predictions from datasource for a specific taskName
     * Get list of raw samples predictions
     */
    async getListOfRawSamplesPredictionsFromDatasourceByDatasetIdRaw(requestParameters: GetListOfRawSamplesPredictionsFromDatasourceByDatasetIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DatasourceRawSamplesPredictionsData>> {
        if (requestParameters.datasetId === null || requestParameters.datasetId === undefined) {
            throw new runtime.RequiredError('datasetId', 'Required parameter requestParameters.datasetId was null or undefined when calling getListOfRawSamplesPredictionsFromDatasourceByDatasetId.');
        }
        if (requestParameters.taskName === null || requestParameters.taskName === undefined) {
            throw new runtime.RequiredError('taskName', 'Required parameter requestParameters.taskName was null or undefined when calling getListOfRawSamplesPredictionsFromDatasourceByDatasetId.');
        }
        const queryParameters: any = {};
        if (requestParameters.taskName !== undefined) {
            queryParameters['taskName'] = requestParameters.taskName;
        }
        if (requestParameters.from !== undefined) {
            queryParameters['from'] = requestParameters.from;
        }
        if (requestParameters.to !== undefined) {
            queryParameters['to'] = requestParameters.to;
        }
        if (requestParameters.cursor !== undefined) {
            queryParameters['cursor'] = requestParameters.cursor;
        }
        if (requestParameters.useRedirectedReadUrl !== undefined) {
            queryParameters['useRedirectedReadUrl'] = requestParameters.useRedirectedReadUrl;
        }
        if (requestParameters.relevantFilenamesFileName !== undefined) {
            queryParameters['relevantFilenamesFileName'] = requestParameters.relevantFilenamesFileName;
        }
        if (requestParameters.relevantFilenamesRunId !== undefined) {
            queryParameters['relevantFilenamesRunId'] = requestParameters.relevantFilenamesRunId;
        }
        if (requestParameters.relevantFilenamesArtifactId !== undefined) {
            queryParameters['relevantFilenamesArtifactId'] = requestParameters.relevantFilenamesArtifactId;
        }
        const headerParameters: runtime.HTTPHeaders = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("auth0Bearer", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["token"] = this.configuration.apiKey("token"); // ApiKeyAuth authentication
        }
        const response = await this.request({
            path: `/v1/datasets/{datasetId}/datasource/predictions/list`.replace(`{${"datasetId"}}`, encodeURIComponent(String(requestParameters.datasetId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => DatasourceRawSamplesPredictionsDataFromJSON(jsonValue));
    }
    /**
     * Get list of the raw samples predictions from datasource for a specific taskName
     * Get list of raw samples predictions
     */
    async getListOfRawSamplesPredictionsFromDatasourceByDatasetId(requestParameters: GetListOfRawSamplesPredictionsFromDatasourceByDatasetIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DatasourceRawSamplesPredictionsData> {
        const response = await this.getListOfRawSamplesPredictionsFromDatasourceByDatasetIdRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get the GET ReadURL of a file within the metadata folder (e.g. my_image.json or my_video-099-mp4.json)
     * Get metadata file ReadURL
     */
    async getMetadataFileReadUrlFromDatasourceByDatasetIdRaw(requestParameters: GetMetadataFileReadUrlFromDatasourceByDatasetIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters.datasetId === null || requestParameters.datasetId === undefined) {
            throw new runtime.RequiredError('datasetId', 'Required parameter requestParameters.datasetId was null or undefined when calling getMetadataFileReadUrlFromDatasourceByDatasetId.');
        }
        if (requestParameters.fileName === null || requestParameters.fileName === undefined) {
            throw new runtime.RequiredError('fileName', 'Required parameter requestParameters.fileName was null or undefined when calling getMetadataFileReadUrlFromDatasourceByDatasetId.');
        }
        const queryParameters: any = {};
        if (requestParameters.fileName !== undefined) {
            queryParameters['fileName'] = requestParameters.fileName;
        }
        const headerParameters: runtime.HTTPHeaders = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("auth0Bearer", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["token"] = this.configuration.apiKey("token"); // ApiKeyAuth authentication
        }
        const response = await this.request({
            path: `/v1/datasets/{datasetId}/datasource/metadata/file`.replace(`{${"datasetId"}}`, encodeURIComponent(String(requestParameters.datasetId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.TextApiResponse(response) as any;
    }
    /**
     * Get the GET ReadURL of a file within the metadata folder (e.g. my_image.json or my_video-099-mp4.json)
     * Get metadata file ReadURL
     */
    async getMetadataFileReadUrlFromDatasourceByDatasetId(requestParameters: GetMetadataFileReadUrlFromDatasourceByDatasetIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.getMetadataFileReadUrlFromDatasourceByDatasetIdRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get the GET ReadURL of a file within the predictions folder (e.g tasks.json or my_classification_task/schema.json)
     * Get prediction file readURL
     */
    async getPredictionFileReadUrlFromDatasourceByDatasetIdRaw(requestParameters: GetPredictionFileReadUrlFromDatasourceByDatasetIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters.datasetId === null || requestParameters.datasetId === undefined) {
            throw new runtime.RequiredError('datasetId', 'Required parameter requestParameters.datasetId was null or undefined when calling getPredictionFileReadUrlFromDatasourceByDatasetId.');
        }
        if (requestParameters.fileName === null || requestParameters.fileName === undefined) {
            throw new runtime.RequiredError('fileName', 'Required parameter requestParameters.fileName was null or undefined when calling getPredictionFileReadUrlFromDatasourceByDatasetId.');
        }
        const queryParameters: any = {};
        if (requestParameters.fileName !== undefined) {
            queryParameters['fileName'] = requestParameters.fileName;
        }
        const headerParameters: runtime.HTTPHeaders = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("auth0Bearer", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["token"] = this.configuration.apiKey("token"); // ApiKeyAuth authentication
        }
        const response = await this.request({
            path: `/v1/datasets/{datasetId}/datasource/predictions/file`.replace(`{${"datasetId"}}`, encodeURIComponent(String(requestParameters.datasetId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.TextApiResponse(response) as any;
    }
    /**
     * Get the GET ReadURL of a file within the predictions folder (e.g tasks.json or my_classification_task/schema.json)
     * Get prediction file readURL
     */
    async getPredictionFileReadUrlFromDatasourceByDatasetId(requestParameters: GetPredictionFileReadUrlFromDatasourceByDatasetIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.getPredictionFileReadUrlFromDatasourceByDatasetIdRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get the WriteURL of a file within the predictions folder (e.g tasks.json or my_classification_task/schema.json)
     * Get prediction file writeURL
     */
    async getPredictionFileWriteUrlFromDatasourceByDatasetIdRaw(requestParameters: GetPredictionFileWriteUrlFromDatasourceByDatasetIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters.datasetId === null || requestParameters.datasetId === undefined) {
            throw new runtime.RequiredError('datasetId', 'Required parameter requestParameters.datasetId was null or undefined when calling getPredictionFileWriteUrlFromDatasourceByDatasetId.');
        }
        if (requestParameters.fileName === null || requestParameters.fileName === undefined) {
            throw new runtime.RequiredError('fileName', 'Required parameter requestParameters.fileName was null or undefined when calling getPredictionFileWriteUrlFromDatasourceByDatasetId.');
        }
        const queryParameters: any = {};
        if (requestParameters.fileName !== undefined) {
            queryParameters['fileName'] = requestParameters.fileName;
        }
        const headerParameters: runtime.HTTPHeaders = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("auth0Bearer", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["token"] = this.configuration.apiKey("token"); // ApiKeyAuth authentication
        }
        const response = await this.request({
            path: `/v1/datasets/{datasetId}/datasource/predictions/writeUrl`.replace(`{${"datasetId"}}`, encodeURIComponent(String(requestParameters.datasetId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.TextApiResponse(response) as any;
    }
    /**
     * Get the WriteURL of a file within the predictions folder (e.g tasks.json or my_classification_task/schema.json)
     * Get prediction file writeURL
     */
    async getPredictionFileWriteUrlFromDatasourceByDatasetId(requestParameters: GetPredictionFileWriteUrlFromDatasourceByDatasetIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.getPredictionFileWriteUrlFromDatasourceByDatasetIdRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * This endpoint enables anyone given the correct credentials to access the actual image directly via a redirect. By creating a readURL for the resource and redirecting to that URL, the client can use this endpoint to always have a way to access the resource as there is no expiration
     * Get resource read URL redirect
     */
    async getResourceReadURLRedirectRaw(requestParameters: GetResourceReadURLRedirectRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.datasetId === null || requestParameters.datasetId === undefined) {
            throw new runtime.RequiredError('datasetId', 'Required parameter requestParameters.datasetId was null or undefined when calling getResourceReadURLRedirect.');
        }
        if (requestParameters.path === null || requestParameters.path === undefined) {
            throw new runtime.RequiredError('path', 'Required parameter requestParameters.path was null or undefined when calling getResourceReadURLRedirect.');
        }
        const queryParameters: any = {};
        if (requestParameters.path !== undefined) {
            queryParameters['path'] = requestParameters.path;
        }
        const headerParameters: runtime.HTTPHeaders = {};
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["publicToken"] = this.configuration.apiKey("publicToken"); // ApiPublicJWTAuth authentication
        }
        const response = await this.request({
            path: `/v1/datasets/{datasetId}/datasource/readurlRedirect`.replace(`{${"datasetId"}}`, encodeURIComponent(String(requestParameters.datasetId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * This endpoint enables anyone given the correct credentials to access the actual image directly via a redirect. By creating a readURL for the resource and redirecting to that URL, the client can use this endpoint to always have a way to access the resource as there is no expiration
     * Get resource read URL redirect
     */
    async getResourceReadURLRedirect(requestParameters: GetResourceReadURLRedirectRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getResourceReadURLRedirectRaw(requestParameters, initOverrides);
    }
    /**
     * Update the datasource of a specific dataset
     * Update datasource by dataset id
     */
    async updateDatasourceByDatasetIdRaw(requestParameters: UpdateDatasourceByDatasetIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.datasourceConfig === null || requestParameters.datasourceConfig === undefined) {
            throw new runtime.RequiredError('datasourceConfig', 'Required parameter requestParameters.datasourceConfig was null or undefined when calling updateDatasourceByDatasetId.');
        }
        if (requestParameters.datasetId === null || requestParameters.datasetId === undefined) {
            throw new runtime.RequiredError('datasetId', 'Required parameter requestParameters.datasetId was null or undefined when calling updateDatasourceByDatasetId.');
        }
        const queryParameters: any = {};
        const headerParameters: runtime.HTTPHeaders = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("auth0Bearer", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["token"] = this.configuration.apiKey("token"); // ApiKeyAuth authentication
        }
        const response = await this.request({
            path: `/v1/datasets/{datasetId}/datasource`.replace(`{${"datasetId"}}`, encodeURIComponent(String(requestParameters.datasetId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: DatasourceConfigToJSON(requestParameters.datasourceConfig),
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Update the datasource of a specific dataset
     * Update datasource by dataset id
     */
    async updateDatasourceByDatasetId(requestParameters: UpdateDatasourceByDatasetIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateDatasourceByDatasetIdRaw(requestParameters, initOverrides);
    }
    /**
     * Update timestamp of last resource in datapool
     * Update processed timestamp by dataset id
     */
    async updateDatasourceProcessedUntilTimestampByDatasetIdRaw(requestParameters: UpdateDatasourceProcessedUntilTimestampByDatasetIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.datasourceProcessedUntilTimestampRequest === null || requestParameters.datasourceProcessedUntilTimestampRequest === undefined) {
            throw new runtime.RequiredError('datasourceProcessedUntilTimestampRequest', 'Required parameter requestParameters.datasourceProcessedUntilTimestampRequest was null or undefined when calling updateDatasourceProcessedUntilTimestampByDatasetId.');
        }
        if (requestParameters.datasetId === null || requestParameters.datasetId === undefined) {
            throw new runtime.RequiredError('datasetId', 'Required parameter requestParameters.datasetId was null or undefined when calling updateDatasourceProcessedUntilTimestampByDatasetId.');
        }
        const queryParameters: any = {};
        const headerParameters: runtime.HTTPHeaders = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("auth0Bearer", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["token"] = this.configuration.apiKey("token"); // ApiKeyAuth authentication
        }
        const response = await this.request({
            path: `/v1/datasets/{datasetId}/datasource/processedUntilTimestamp`.replace(`{${"datasetId"}}`, encodeURIComponent(String(requestParameters.datasetId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: DatasourceProcessedUntilTimestampRequestToJSON(requestParameters.datasourceProcessedUntilTimestampRequest),
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Update timestamp of last resource in datapool
     * Update processed timestamp by dataset id
     */
    async updateDatasourceProcessedUntilTimestampByDatasetId(requestParameters: UpdateDatasourceProcessedUntilTimestampByDatasetIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateDatasourceProcessedUntilTimestampByDatasetIdRaw(requestParameters, initOverrides);
    }
    /**
     * Test and verify that the configured datasource can be accessed correctly
     * Verify datasource by dataset id
     */
    async verifyDatasourceByDatasetIdRaw(requestParameters: VerifyDatasourceByDatasetIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DatasourceConfigVerifyData>> {
        if (requestParameters.datasetId === null || requestParameters.datasetId === undefined) {
            throw new runtime.RequiredError('datasetId', 'Required parameter requestParameters.datasetId was null or undefined when calling verifyDatasourceByDatasetId.');
        }
        const queryParameters: any = {};
        const headerParameters: runtime.HTTPHeaders = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("auth0Bearer", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["token"] = this.configuration.apiKey("token"); // ApiKeyAuth authentication
        }
        const response = await this.request({
            path: `/v1/datasets/{datasetId}/datasource/verify`.replace(`{${"datasetId"}}`, encodeURIComponent(String(requestParameters.datasetId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => DatasourceConfigVerifyDataFromJSON(jsonValue));
    }
    /**
     * Test and verify that the configured datasource can be accessed correctly
     * Verify datasource by dataset id
     */
    async verifyDatasourceByDatasetId(requestParameters: VerifyDatasourceByDatasetIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DatasourceConfigVerifyData> {
        const response = await this.verifyDatasourceByDatasetIdRaw(requestParameters, initOverrides);
        return await response.value();
    }
}
